// source: attachment/attachment.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var common_model_pb = require('../common/model_pb.js');
goog.object.extend(proto, common_model_pb);
var common_time_pb = require('../common/time_pb.js');
goog.object.extend(proto, common_time_pb);
var common_grc_platform_pb = require('../common/grc_platform_pb.js');
goog.object.extend(proto, common_grc_platform_pb);
var common_payload_pb = require('../common/payload_pb.js');
goog.object.extend(proto, common_payload_pb);
var common_sorting_pb = require('../common/sorting_pb.js');
goog.object.extend(proto, common_sorting_pb);
var common_pagination_pb = require('../common/pagination_pb.js');
goog.object.extend(proto, common_pagination_pb);
var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
goog.exportSymbol('proto.attachment.ACTOR_TYPE', null, global);
goog.exportSymbol('proto.attachment.ATTACHMENT_TYPE', null, global);
goog.exportSymbol('proto.attachment.ActorFilter', null, global);
goog.exportSymbol('proto.attachment.AddDocumentRequest', null, global);
goog.exportSymbol('proto.attachment.AddEvidenceLabelRequest', null, global);
goog.exportSymbol('proto.attachment.AddEvidenceRequest', null, global);
goog.exportSymbol('proto.attachment.AddOrUpdateEvidenceGroupRequest', null, global);
goog.exportSymbol('proto.attachment.AllExclusions', null, global);
goog.exportSymbol('proto.attachment.AuditModelID', null, global);
goog.exportSymbol('proto.attachment.AuditModelIDs', null, global);
goog.exportSymbol('proto.attachment.AuditPeriod', null, global);
goog.exportSymbol('proto.attachment.AuditPeriods', null, global);
goog.exportSymbol('proto.attachment.AutomatedEvidenceFilter', null, global);
goog.exportSymbol('proto.attachment.BulkAddEvidenceRequest', null, global);
goog.exportSymbol('proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest', null, global);
goog.exportSymbol('proto.attachment.BulkUnlinkEvidenceRequest', null, global);
goog.exportSymbol('proto.attachment.Caption', null, global);
goog.exportSymbol('proto.attachment.CloseAudit', null, global);
goog.exportSymbol('proto.attachment.CompleteAudit', null, global);
goog.exportSymbol('proto.attachment.ControlEvidence', null, global);
goog.exportSymbol('proto.attachment.ControlEvidenceGroup', null, global);
goog.exportSymbol('proto.attachment.ControlFilter', null, global);
goog.exportSymbol('proto.attachment.DOCUMENT_TYPE', null, global);
goog.exportSymbol('proto.attachment.DeleteAuditPeriodRequest', null, global);
goog.exportSymbol('proto.attachment.DeleteControlEvidencesByCaptionRequest', null, global);
goog.exportSymbol('proto.attachment.DeleteDocumentRequest', null, global);
goog.exportSymbol('proto.attachment.DeleteEvidenceGroupRequest', null, global);
goog.exportSymbol('proto.attachment.Document', null, global);
goog.exportSymbol('proto.attachment.DocumentPeriod', null, global);
goog.exportSymbol('proto.attachment.DocumentTypeQuery', null, global);
goog.exportSymbol('proto.attachment.Documents', null, global);
goog.exportSymbol('proto.attachment.EVIDENCE_LINKAGE_TYPE', null, global);
goog.exportSymbol('proto.attachment.EVIDENCE_READ_ONLY_FIELDS', null, global);
goog.exportSymbol('proto.attachment.EVIDENCE_SORT_COLUMN', null, global);
goog.exportSymbol('proto.attachment.EVIDENCE_SOURCE_KIND', null, global);
goog.exportSymbol('proto.attachment.EVIDENCE_WINDOW_STATUS', null, global);
goog.exportSymbol('proto.attachment.Evidence', null, global);
goog.exportSymbol('proto.attachment.EvidenceControl', null, global);
goog.exportSymbol('proto.attachment.EvidenceGenerator', null, global);
goog.exportSymbol('proto.attachment.EvidenceGenerators', null, global);
goog.exportSymbol('proto.attachment.EvidenceGroup', null, global);
goog.exportSymbol('proto.attachment.EvidenceGroupId', null, global);
goog.exportSymbol('proto.attachment.EvidenceGroups', null, global);
goog.exportSymbol('proto.attachment.EvidenceIdFilter', null, global);
goog.exportSymbol('proto.attachment.EvidenceLinkage', null, global);
goog.exportSymbol('proto.attachment.EvidenceReadOnlyField', null, global);
goog.exportSymbol('proto.attachment.EvidenceReadOnlyFields', null, global);
goog.exportSymbol('proto.attachment.EvidenceSort', null, global);
goog.exportSymbol('proto.attachment.EvidenceTypeFilter', null, global);
goog.exportSymbol('proto.attachment.EvidenceWrapper', null, global);
goog.exportSymbol('proto.attachment.EvidenceWrapperResponse', null, global);
goog.exportSymbol('proto.attachment.Excluded', null, global);
goog.exportSymbol('proto.attachment.ExportRiskRegisterCSVRequest', null, global);
goog.exportSymbol('proto.attachment.FileTypeFilter', null, global);
goog.exportSymbol('proto.attachment.GetAuditPeriodByOIDRequest', null, global);
goog.exportSymbol('proto.attachment.GetControlEvidenceRequest', null, global);
goog.exportSymbol('proto.attachment.GetControlEvidenceResponse', null, global);
goog.exportSymbol('proto.attachment.GetControlEvidenceTabRequest', null, global);
goog.exportSymbol('proto.attachment.GetDocumentByCaptionRequest', null, global);
goog.exportSymbol('proto.attachment.GetDocumentByOIDRequest', null, global);
goog.exportSymbol('proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest', null, global);
goog.exportSymbol('proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse', null, global);
goog.exportSymbol('proto.attachment.GetDocumentsByOIDsRequest', null, global);
goog.exportSymbol('proto.attachment.GetDocumentsByOIDsResponse', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceBodyByOIDRequest', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceBodyByOIDRequest.FORMAT', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceBodyByOIDResponse', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceControlsRequest', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceControlsResponse', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceDiscoveryRequest', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceDiscoveryResponse', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceGroupByIdRequest', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceGroupByIdResponse', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceGroupControlsRequest', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceGroupControlsResponse', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceGroupDRLRequest', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceGroupDRLResponse', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceGroupDocumentsRequest', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceGroupDocumentsResponse', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceGroupIfExistsRequest', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceGroupIfExistsResponse', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceGroupRequest', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceGroupResponse', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceIndexPageRequest', null, global);
goog.exportSymbol('proto.attachment.GetEvidenceInstanceListRequest', null, global);
goog.exportSymbol('proto.attachment.GetExclusionsRequest', null, global);
goog.exportSymbol('proto.attachment.GetExclusionsResponse', null, global);
goog.exportSymbol('proto.attachment.GetLatestEvidenceGroupsRequest', null, global);
goog.exportSymbol('proto.attachment.GetLatestEvidenceGroupsResponse', null, global);
goog.exportSymbol('proto.attachment.GetLatestEvidenceRequest', null, global);
goog.exportSymbol('proto.attachment.GetLatestEvidenceResponse', null, global);
goog.exportSymbol('proto.attachment.GetRequestEvidenceTabRequest', null, global);
goog.exportSymbol('proto.attachment.GetRiskRegisterCSVResponse', null, global);
goog.exportSymbol('proto.attachment.HeaderValue', null, global);
goog.exportSymbol('proto.attachment.IDCount', null, global);
goog.exportSymbol('proto.attachment.IDCounts', null, global);
goog.exportSymbol('proto.attachment.IDsQuery', null, global);
goog.exportSymbol('proto.attachment.IncludeModelIDs', null, global);
goog.exportSymbol('proto.attachment.LatestEvidence', null, global);
goog.exportSymbol('proto.attachment.LatestEvidenceGroup', null, global);
goog.exportSymbol('proto.attachment.LinkControlsToEvidenceRequest', null, global);
goog.exportSymbol('proto.attachment.LinkDocumentRequest', null, global);
goog.exportSymbol('proto.attachment.LinkDocumentsRequest', null, global);
goog.exportSymbol('proto.attachment.LinkEvidenceToControlRequest', null, global);
goog.exportSymbol('proto.attachment.LinkRequestsToEvidenceRequest', null, global);
goog.exportSymbol('proto.attachment.ListConnectedEvidenceGeneratorsRequest', null, global);
goog.exportSymbol('proto.attachment.ListEvidenceGroupsRequest', null, global);
goog.exportSymbol('proto.attachment.ListEvidenceGroupsResponse', null, global);
goog.exportSymbol('proto.attachment.ListEvidenceRequest', null, global);
goog.exportSymbol('proto.attachment.ListEvidenceResponse', null, global);
goog.exportSymbol('proto.attachment.ModelTypeQuery', null, global);
goog.exportSymbol('proto.attachment.RemoveEvidenceLabelRequest', null, global);
goog.exportSymbol('proto.attachment.RequestFilter', null, global);
goog.exportSymbol('proto.attachment.ServiceDiscovery', null, global);
goog.exportSymbol('proto.attachment.URL', null, global);
goog.exportSymbol('proto.attachment.UnlinkControlsFromEvidenceRequest', null, global);
goog.exportSymbol('proto.attachment.UnlinkEvidenceFromControlRequest', null, global);
goog.exportSymbol('proto.attachment.UnlinkEvidenceFromRequestRequest', null, global);
goog.exportSymbol('proto.attachment.UpdateEvidenceLabelsRequest', null, global);
goog.exportSymbol('proto.attachment.UpdateEvidenceReadOnlyFieldsRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest.displayName = 'proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.repeatedFields_, null);
};
goog.inherits(proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.displayName = 'proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetDocumentByOIDRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetDocumentByOIDRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetDocumentByOIDRequest.displayName = 'proto.attachment.GetDocumentByOIDRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetDocumentsByOIDsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.GetDocumentsByOIDsRequest.repeatedFields_, null);
};
goog.inherits(proto.attachment.GetDocumentsByOIDsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetDocumentsByOIDsRequest.displayName = 'proto.attachment.GetDocumentsByOIDsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetDocumentsByOIDsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.GetDocumentsByOIDsResponse.repeatedFields_, null);
};
goog.inherits(proto.attachment.GetDocumentsByOIDsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetDocumentsByOIDsResponse.displayName = 'proto.attachment.GetDocumentsByOIDsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetDocumentByCaptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetDocumentByCaptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetDocumentByCaptionRequest.displayName = 'proto.attachment.GetDocumentByCaptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetAuditPeriodByOIDRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetAuditPeriodByOIDRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetAuditPeriodByOIDRequest.displayName = 'proto.attachment.GetAuditPeriodByOIDRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.DeleteAuditPeriodRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.DeleteAuditPeriodRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.DeleteAuditPeriodRequest.displayName = 'proto.attachment.DeleteAuditPeriodRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.Document = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.Document.repeatedFields_, null);
};
goog.inherits(proto.attachment.Document, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.Document.displayName = 'proto.attachment.Document';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.AddDocumentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.AddDocumentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.AddDocumentRequest.displayName = 'proto.attachment.AddDocumentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.LinkDocumentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.LinkDocumentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.LinkDocumentRequest.displayName = 'proto.attachment.LinkDocumentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.LinkDocumentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.LinkDocumentsRequest.repeatedFields_, null);
};
goog.inherits(proto.attachment.LinkDocumentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.LinkDocumentsRequest.displayName = 'proto.attachment.LinkDocumentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.Documents = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.Documents.repeatedFields_, null);
};
goog.inherits(proto.attachment.Documents, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.Documents.displayName = 'proto.attachment.Documents';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.AddEvidenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.AddEvidenceRequest.repeatedFields_, null);
};
goog.inherits(proto.attachment.AddEvidenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.AddEvidenceRequest.displayName = 'proto.attachment.AddEvidenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.BulkAddEvidenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.BulkAddEvidenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.BulkAddEvidenceRequest.displayName = 'proto.attachment.BulkAddEvidenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.DocumentPeriod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.DocumentPeriod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.DocumentPeriod.displayName = 'proto.attachment.DocumentPeriod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.Caption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.Caption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.Caption.displayName = 'proto.attachment.Caption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.AuditPeriod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.AuditPeriod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.AuditPeriod.displayName = 'proto.attachment.AuditPeriod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.AuditModelID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.AuditModelID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.AuditModelID.displayName = 'proto.attachment.AuditModelID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.AuditModelIDs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.AuditModelIDs.repeatedFields_, null);
};
goog.inherits(proto.attachment.AuditModelIDs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.AuditModelIDs.displayName = 'proto.attachment.AuditModelIDs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.AuditPeriods = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.AuditPeriods.repeatedFields_, null);
};
goog.inherits(proto.attachment.AuditPeriods, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.AuditPeriods.displayName = 'proto.attachment.AuditPeriods';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.IncludeModelIDs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.IncludeModelIDs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.IncludeModelIDs.displayName = 'proto.attachment.IncludeModelIDs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.CloseAudit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.CloseAudit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.CloseAudit.displayName = 'proto.attachment.CloseAudit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.CompleteAudit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.CompleteAudit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.CompleteAudit.displayName = 'proto.attachment.CompleteAudit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.ModelTypeQuery = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.ModelTypeQuery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.ModelTypeQuery.displayName = 'proto.attachment.ModelTypeQuery';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.DocumentTypeQuery = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.DocumentTypeQuery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.DocumentTypeQuery.displayName = 'proto.attachment.DocumentTypeQuery';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.IDsQuery = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.IDsQuery.repeatedFields_, null);
};
goog.inherits(proto.attachment.IDsQuery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.IDsQuery.displayName = 'proto.attachment.IDsQuery';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.IDCount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.IDCount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.IDCount.displayName = 'proto.attachment.IDCount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.IDCounts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.IDCounts.repeatedFields_, null);
};
goog.inherits(proto.attachment.IDCounts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.IDCounts.displayName = 'proto.attachment.IDCounts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceBodyByOIDRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetEvidenceBodyByOIDRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceBodyByOIDRequest.displayName = 'proto.attachment.GetEvidenceBodyByOIDRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceBodyByOIDResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.GetEvidenceBodyByOIDResponse.repeatedFields_, null);
};
goog.inherits(proto.attachment.GetEvidenceBodyByOIDResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceBodyByOIDResponse.displayName = 'proto.attachment.GetEvidenceBodyByOIDResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetLatestEvidenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetLatestEvidenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetLatestEvidenceRequest.displayName = 'proto.attachment.GetLatestEvidenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetControlEvidenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetControlEvidenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetControlEvidenceRequest.displayName = 'proto.attachment.GetControlEvidenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetControlEvidenceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.GetControlEvidenceResponse.repeatedFields_, null);
};
goog.inherits(proto.attachment.GetControlEvidenceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetControlEvidenceResponse.displayName = 'proto.attachment.GetControlEvidenceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.AutomatedEvidenceFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.AutomatedEvidenceFilter.repeatedFields_, null);
};
goog.inherits(proto.attachment.AutomatedEvidenceFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.AutomatedEvidenceFilter.displayName = 'proto.attachment.AutomatedEvidenceFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.FileTypeFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.FileTypeFilter.repeatedFields_, null);
};
goog.inherits(proto.attachment.FileTypeFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.FileTypeFilter.displayName = 'proto.attachment.FileTypeFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.EvidenceTypeFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.EvidenceTypeFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.EvidenceTypeFilter.displayName = 'proto.attachment.EvidenceTypeFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.EvidenceIdFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.EvidenceIdFilter.repeatedFields_, null);
};
goog.inherits(proto.attachment.EvidenceIdFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.EvidenceIdFilter.displayName = 'proto.attachment.EvidenceIdFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.ControlFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.ControlFilter.repeatedFields_, null);
};
goog.inherits(proto.attachment.ControlFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.ControlFilter.displayName = 'proto.attachment.ControlFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.ActorFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.ActorFilter.repeatedFields_, null);
};
goog.inherits(proto.attachment.ActorFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.ActorFilter.displayName = 'proto.attachment.ActorFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.EvidenceSort = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.EvidenceSort, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.EvidenceSort.displayName = 'proto.attachment.EvidenceSort';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetLatestEvidenceGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetLatestEvidenceGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetLatestEvidenceGroupsRequest.displayName = 'proto.attachment.GetLatestEvidenceGroupsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.Excluded = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.Excluded.repeatedFields_, null);
};
goog.inherits(proto.attachment.Excluded, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.Excluded.displayName = 'proto.attachment.Excluded';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.AllExclusions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.AllExclusions.repeatedFields_, null);
};
goog.inherits(proto.attachment.AllExclusions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.AllExclusions.displayName = 'proto.attachment.AllExclusions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceDiscoveryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetEvidenceDiscoveryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceDiscoveryRequest.displayName = 'proto.attachment.GetEvidenceDiscoveryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceDiscoveryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.GetEvidenceDiscoveryResponse.repeatedFields_, null);
};
goog.inherits(proto.attachment.GetEvidenceDiscoveryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceDiscoveryResponse.displayName = 'proto.attachment.GetEvidenceDiscoveryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.ServiceDiscovery = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.ServiceDiscovery.repeatedFields_, null);
};
goog.inherits(proto.attachment.ServiceDiscovery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.ServiceDiscovery.displayName = 'proto.attachment.ServiceDiscovery';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.ListEvidenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.ListEvidenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.ListEvidenceRequest.displayName = 'proto.attachment.ListEvidenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.RequestFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.RequestFilter.repeatedFields_, null);
};
goog.inherits(proto.attachment.RequestFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.RequestFilter.displayName = 'proto.attachment.RequestFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.ListEvidenceGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.ListEvidenceGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.ListEvidenceGroupsRequest.displayName = 'proto.attachment.ListEvidenceGroupsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.ListEvidenceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.ListEvidenceResponse.repeatedFields_, null);
};
goog.inherits(proto.attachment.ListEvidenceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.ListEvidenceResponse.displayName = 'proto.attachment.ListEvidenceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.ListEvidenceGroupsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.ListEvidenceGroupsResponse.repeatedFields_, null);
};
goog.inherits(proto.attachment.ListEvidenceGroupsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.ListEvidenceGroupsResponse.displayName = 'proto.attachment.ListEvidenceGroupsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetLatestEvidenceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.GetLatestEvidenceResponse.repeatedFields_, null);
};
goog.inherits(proto.attachment.GetLatestEvidenceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetLatestEvidenceResponse.displayName = 'proto.attachment.GetLatestEvidenceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetLatestEvidenceGroupsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.GetLatestEvidenceGroupsResponse.repeatedFields_, null);
};
goog.inherits(proto.attachment.GetLatestEvidenceGroupsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetLatestEvidenceGroupsResponse.displayName = 'proto.attachment.GetLatestEvidenceGroupsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.ListConnectedEvidenceGeneratorsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.ListConnectedEvidenceGeneratorsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.ListConnectedEvidenceGeneratorsRequest.displayName = 'proto.attachment.ListConnectedEvidenceGeneratorsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.LatestEvidence = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.LatestEvidence, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.LatestEvidence.displayName = 'proto.attachment.LatestEvidence';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.LatestEvidenceGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.LatestEvidenceGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.LatestEvidenceGroup.displayName = 'proto.attachment.LatestEvidenceGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.Evidence = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.Evidence.repeatedFields_, null);
};
goog.inherits(proto.attachment.Evidence, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.Evidence.displayName = 'proto.attachment.Evidence';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.ControlEvidenceGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.ControlEvidenceGroup.repeatedFields_, null);
};
goog.inherits(proto.attachment.ControlEvidenceGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.ControlEvidenceGroup.displayName = 'proto.attachment.ControlEvidenceGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.ControlEvidence = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.ControlEvidence.repeatedFields_, null);
};
goog.inherits(proto.attachment.ControlEvidence, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.ControlEvidence.displayName = 'proto.attachment.ControlEvidence';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.EvidenceGroupId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.EvidenceGroupId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.EvidenceGroupId.displayName = 'proto.attachment.EvidenceGroupId';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.EvidenceGroups = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.EvidenceGroups.repeatedFields_, null);
};
goog.inherits(proto.attachment.EvidenceGroups, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.EvidenceGroups.displayName = 'proto.attachment.EvidenceGroups';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.EvidenceGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.EvidenceGroup.repeatedFields_, null);
};
goog.inherits(proto.attachment.EvidenceGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.EvidenceGroup.displayName = 'proto.attachment.EvidenceGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.EvidenceGenerators = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.EvidenceGenerators.repeatedFields_, null);
};
goog.inherits(proto.attachment.EvidenceGenerators, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.EvidenceGenerators.displayName = 'proto.attachment.EvidenceGenerators';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.EvidenceGenerator = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.EvidenceGenerator, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.EvidenceGenerator.displayName = 'proto.attachment.EvidenceGenerator';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.DeleteDocumentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.DeleteDocumentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.DeleteDocumentRequest.displayName = 'proto.attachment.DeleteDocumentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetRiskRegisterCSVResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetRiskRegisterCSVResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetRiskRegisterCSVResponse.displayName = 'proto.attachment.GetRiskRegisterCSVResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.ExportRiskRegisterCSVRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.ExportRiskRegisterCSVRequest.repeatedFields_, null);
};
goog.inherits(proto.attachment.ExportRiskRegisterCSVRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.ExportRiskRegisterCSVRequest.displayName = 'proto.attachment.ExportRiskRegisterCSVRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetExclusionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetExclusionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetExclusionsRequest.displayName = 'proto.attachment.GetExclusionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetExclusionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetExclusionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetExclusionsResponse.displayName = 'proto.attachment.GetExclusionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.DeleteControlEvidencesByCaptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.DeleteControlEvidencesByCaptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.DeleteControlEvidencesByCaptionRequest.displayName = 'proto.attachment.DeleteControlEvidencesByCaptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.URL = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.URL, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.URL.displayName = 'proto.attachment.URL';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.HeaderValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.HeaderValue.repeatedFields_, null);
};
goog.inherits(proto.attachment.HeaderValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.HeaderValue.displayName = 'proto.attachment.HeaderValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.AddOrUpdateEvidenceGroupRequest.repeatedFields_, null);
};
goog.inherits(proto.attachment.AddOrUpdateEvidenceGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.AddOrUpdateEvidenceGroupRequest.displayName = 'proto.attachment.AddOrUpdateEvidenceGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.repeatedFields_, null);
};
goog.inherits(proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.displayName = 'proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.DeleteEvidenceGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.DeleteEvidenceGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.DeleteEvidenceGroupRequest.displayName = 'proto.attachment.DeleteEvidenceGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.EvidenceLinkage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.EvidenceLinkage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.EvidenceLinkage.displayName = 'proto.attachment.EvidenceLinkage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.LinkControlsToEvidenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.LinkControlsToEvidenceRequest.repeatedFields_, null);
};
goog.inherits(proto.attachment.LinkControlsToEvidenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.LinkControlsToEvidenceRequest.displayName = 'proto.attachment.LinkControlsToEvidenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.LinkRequestsToEvidenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.LinkRequestsToEvidenceRequest.repeatedFields_, null);
};
goog.inherits(proto.attachment.LinkRequestsToEvidenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.LinkRequestsToEvidenceRequest.displayName = 'proto.attachment.LinkRequestsToEvidenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.UnlinkEvidenceFromRequestRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.UnlinkEvidenceFromRequestRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.UnlinkEvidenceFromRequestRequest.displayName = 'proto.attachment.UnlinkEvidenceFromRequestRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.LinkEvidenceToControlRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.LinkEvidenceToControlRequest.repeatedFields_, null);
};
goog.inherits(proto.attachment.LinkEvidenceToControlRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.LinkEvidenceToControlRequest.displayName = 'proto.attachment.LinkEvidenceToControlRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.UnlinkEvidenceFromControlRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.UnlinkEvidenceFromControlRequest.repeatedFields_, null);
};
goog.inherits(proto.attachment.UnlinkEvidenceFromControlRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.UnlinkEvidenceFromControlRequest.displayName = 'proto.attachment.UnlinkEvidenceFromControlRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.UnlinkControlsFromEvidenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.UnlinkControlsFromEvidenceRequest.repeatedFields_, null);
};
goog.inherits(proto.attachment.UnlinkControlsFromEvidenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.UnlinkControlsFromEvidenceRequest.displayName = 'proto.attachment.UnlinkControlsFromEvidenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.BulkUnlinkEvidenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.BulkUnlinkEvidenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.BulkUnlinkEvidenceRequest.displayName = 'proto.attachment.BulkUnlinkEvidenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceGroupControlsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetEvidenceGroupControlsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceGroupControlsRequest.displayName = 'proto.attachment.GetEvidenceGroupControlsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceGroupControlsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.GetEvidenceGroupControlsResponse.repeatedFields_, null);
};
goog.inherits(proto.attachment.GetEvidenceGroupControlsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceGroupControlsResponse.displayName = 'proto.attachment.GetEvidenceGroupControlsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceGroupDRLRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetEvidenceGroupDRLRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceGroupDRLRequest.displayName = 'proto.attachment.GetEvidenceGroupDRLRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceGroupDRLResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.GetEvidenceGroupDRLResponse.repeatedFields_, null);
};
goog.inherits(proto.attachment.GetEvidenceGroupDRLResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceGroupDRLResponse.displayName = 'proto.attachment.GetEvidenceGroupDRLResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceGroupDocumentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetEvidenceGroupDocumentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceGroupDocumentsRequest.displayName = 'proto.attachment.GetEvidenceGroupDocumentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceGroupDocumentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.GetEvidenceGroupDocumentsResponse.repeatedFields_, null);
};
goog.inherits(proto.attachment.GetEvidenceGroupDocumentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceGroupDocumentsResponse.displayName = 'proto.attachment.GetEvidenceGroupDocumentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetEvidenceGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceGroupRequest.displayName = 'proto.attachment.GetEvidenceGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceGroupResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetEvidenceGroupResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceGroupResponse.displayName = 'proto.attachment.GetEvidenceGroupResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceGroupByIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetEvidenceGroupByIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceGroupByIdRequest.displayName = 'proto.attachment.GetEvidenceGroupByIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceGroupIfExistsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetEvidenceGroupIfExistsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceGroupIfExistsRequest.displayName = 'proto.attachment.GetEvidenceGroupIfExistsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceGroupByIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetEvidenceGroupByIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceGroupByIdResponse.displayName = 'proto.attachment.GetEvidenceGroupByIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceGroupIfExistsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetEvidenceGroupIfExistsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceGroupIfExistsResponse.displayName = 'proto.attachment.GetEvidenceGroupIfExistsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceIndexPageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.GetEvidenceIndexPageRequest.repeatedFields_, null);
};
goog.inherits(proto.attachment.GetEvidenceIndexPageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceIndexPageRequest.displayName = 'proto.attachment.GetEvidenceIndexPageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetControlEvidenceTabRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetControlEvidenceTabRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetControlEvidenceTabRequest.displayName = 'proto.attachment.GetControlEvidenceTabRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetRequestEvidenceTabRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetRequestEvidenceTabRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetRequestEvidenceTabRequest.displayName = 'proto.attachment.GetRequestEvidenceTabRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceInstanceListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetEvidenceInstanceListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceInstanceListRequest.displayName = 'proto.attachment.GetEvidenceInstanceListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.EvidenceWrapperResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.EvidenceWrapperResponse.repeatedFields_, null);
};
goog.inherits(proto.attachment.EvidenceWrapperResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.EvidenceWrapperResponse.displayName = 'proto.attachment.EvidenceWrapperResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.EvidenceReadOnlyField = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.EvidenceReadOnlyField, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.EvidenceReadOnlyField.displayName = 'proto.attachment.EvidenceReadOnlyField';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.EvidenceReadOnlyFields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.EvidenceReadOnlyFields.repeatedFields_, null);
};
goog.inherits(proto.attachment.EvidenceReadOnlyFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.EvidenceReadOnlyFields.displayName = 'proto.attachment.EvidenceReadOnlyFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.EvidenceWrapper = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.EvidenceWrapper.repeatedFields_, null);
};
goog.inherits(proto.attachment.EvidenceWrapper, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.EvidenceWrapper.displayName = 'proto.attachment.EvidenceWrapper';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceControlsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.GetEvidenceControlsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceControlsRequest.displayName = 'proto.attachment.GetEvidenceControlsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.EvidenceControl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.EvidenceControl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.EvidenceControl.displayName = 'proto.attachment.EvidenceControl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.GetEvidenceControlsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.GetEvidenceControlsResponse.repeatedFields_, null);
};
goog.inherits(proto.attachment.GetEvidenceControlsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.GetEvidenceControlsResponse.displayName = 'proto.attachment.GetEvidenceControlsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.UpdateEvidenceReadOnlyFieldsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.UpdateEvidenceReadOnlyFieldsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.displayName = 'proto.attachment.UpdateEvidenceReadOnlyFieldsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.UpdateEvidenceLabelsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attachment.UpdateEvidenceLabelsRequest.repeatedFields_, null);
};
goog.inherits(proto.attachment.UpdateEvidenceLabelsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.UpdateEvidenceLabelsRequest.displayName = 'proto.attachment.UpdateEvidenceLabelsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.AddEvidenceLabelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.AddEvidenceLabelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.AddEvidenceLabelRequest.displayName = 'proto.attachment.AddEvidenceLabelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attachment.RemoveEvidenceLabelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attachment.RemoveEvidenceLabelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attachment.RemoveEvidenceLabelRequest.displayName = 'proto.attachment.RemoveEvidenceLabelRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest}
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest;
  return proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest}
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest} returns this
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse}
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse;
  return proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse}
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse} returns this
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse} returns this
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse} returns this
 */
proto.attachment.GetDocumentOIDsByAuditPeriodOIDResponse.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetDocumentByOIDRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetDocumentByOIDRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetDocumentByOIDRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetDocumentByOIDRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    includeBody: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    auditId: (f = msg.getAuditId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetDocumentByOIDRequest}
 */
proto.attachment.GetDocumentByOIDRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetDocumentByOIDRequest;
  return proto.attachment.GetDocumentByOIDRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetDocumentByOIDRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetDocumentByOIDRequest}
 */
proto.attachment.GetDocumentByOIDRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeBody(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetDocumentByOIDRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetDocumentByOIDRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetDocumentByOIDRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetDocumentByOIDRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIncludeBody();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getAuditId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.attachment.GetDocumentByOIDRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetDocumentByOIDRequest} returns this
 */
proto.attachment.GetDocumentByOIDRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool include_body = 2;
 * @return {boolean}
 */
proto.attachment.GetDocumentByOIDRequest.prototype.getIncludeBody = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetDocumentByOIDRequest} returns this
 */
proto.attachment.GetDocumentByOIDRequest.prototype.setIncludeBody = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue audit_id = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.GetDocumentByOIDRequest.prototype.getAuditId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.GetDocumentByOIDRequest} returns this
*/
proto.attachment.GetDocumentByOIDRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetDocumentByOIDRequest} returns this
 */
proto.attachment.GetDocumentByOIDRequest.prototype.clearAuditId = function() {
  return this.setAuditId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetDocumentByOIDRequest.prototype.hasAuditId = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.GetDocumentsByOIDsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetDocumentsByOIDsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetDocumentsByOIDsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetDocumentsByOIDsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetDocumentsByOIDsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    includeBody: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    auditId: (f = msg.getAuditId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetDocumentsByOIDsRequest}
 */
proto.attachment.GetDocumentsByOIDsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetDocumentsByOIDsRequest;
  return proto.attachment.GetDocumentsByOIDsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetDocumentsByOIDsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetDocumentsByOIDsRequest}
 */
proto.attachment.GetDocumentsByOIDsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeBody(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetDocumentsByOIDsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetDocumentsByOIDsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetDocumentsByOIDsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetDocumentsByOIDsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getIncludeBody();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getAuditId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.attachment.GetDocumentsByOIDsRequest.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.GetDocumentsByOIDsRequest} returns this
 */
proto.attachment.GetDocumentsByOIDsRequest.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.GetDocumentsByOIDsRequest} returns this
 */
proto.attachment.GetDocumentsByOIDsRequest.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetDocumentsByOIDsRequest} returns this
 */
proto.attachment.GetDocumentsByOIDsRequest.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};


/**
 * optional bool include_body = 2;
 * @return {boolean}
 */
proto.attachment.GetDocumentsByOIDsRequest.prototype.getIncludeBody = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetDocumentsByOIDsRequest} returns this
 */
proto.attachment.GetDocumentsByOIDsRequest.prototype.setIncludeBody = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue audit_id = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.GetDocumentsByOIDsRequest.prototype.getAuditId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.GetDocumentsByOIDsRequest} returns this
*/
proto.attachment.GetDocumentsByOIDsRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetDocumentsByOIDsRequest} returns this
 */
proto.attachment.GetDocumentsByOIDsRequest.prototype.clearAuditId = function() {
  return this.setAuditId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetDocumentsByOIDsRequest.prototype.hasAuditId = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.GetDocumentsByOIDsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetDocumentsByOIDsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetDocumentsByOIDsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetDocumentsByOIDsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetDocumentsByOIDsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    documentsList: jspb.Message.toObjectList(msg.getDocumentsList(),
    proto.attachment.Document.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetDocumentsByOIDsResponse}
 */
proto.attachment.GetDocumentsByOIDsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetDocumentsByOIDsResponse;
  return proto.attachment.GetDocumentsByOIDsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetDocumentsByOIDsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetDocumentsByOIDsResponse}
 */
proto.attachment.GetDocumentsByOIDsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.Document;
      reader.readMessage(value,proto.attachment.Document.deserializeBinaryFromReader);
      msg.addDocuments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetDocumentsByOIDsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetDocumentsByOIDsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetDocumentsByOIDsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetDocumentsByOIDsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.Document.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Document documents = 1;
 * @return {!Array<!proto.attachment.Document>}
 */
proto.attachment.GetDocumentsByOIDsResponse.prototype.getDocumentsList = function() {
  return /** @type{!Array<!proto.attachment.Document>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.Document, 1));
};


/**
 * @param {!Array<!proto.attachment.Document>} value
 * @return {!proto.attachment.GetDocumentsByOIDsResponse} returns this
*/
proto.attachment.GetDocumentsByOIDsResponse.prototype.setDocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.Document=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.Document}
 */
proto.attachment.GetDocumentsByOIDsResponse.prototype.addDocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.Document, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetDocumentsByOIDsResponse} returns this
 */
proto.attachment.GetDocumentsByOIDsResponse.prototype.clearDocumentsList = function() {
  return this.setDocumentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetDocumentByCaptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetDocumentByCaptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetDocumentByCaptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetDocumentByCaptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    caption: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetDocumentByCaptionRequest}
 */
proto.attachment.GetDocumentByCaptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetDocumentByCaptionRequest;
  return proto.attachment.GetDocumentByCaptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetDocumentByCaptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetDocumentByCaptionRequest}
 */
proto.attachment.GetDocumentByCaptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetDocumentByCaptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetDocumentByCaptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetDocumentByCaptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetDocumentByCaptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string caption = 1;
 * @return {string}
 */
proto.attachment.GetDocumentByCaptionRequest.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetDocumentByCaptionRequest} returns this
 */
proto.attachment.GetDocumentByCaptionRequest.prototype.setCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetAuditPeriodByOIDRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetAuditPeriodByOIDRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetAuditPeriodByOIDRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetAuditPeriodByOIDRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetAuditPeriodByOIDRequest}
 */
proto.attachment.GetAuditPeriodByOIDRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetAuditPeriodByOIDRequest;
  return proto.attachment.GetAuditPeriodByOIDRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetAuditPeriodByOIDRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetAuditPeriodByOIDRequest}
 */
proto.attachment.GetAuditPeriodByOIDRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetAuditPeriodByOIDRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetAuditPeriodByOIDRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetAuditPeriodByOIDRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetAuditPeriodByOIDRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.attachment.GetAuditPeriodByOIDRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetAuditPeriodByOIDRequest} returns this
 */
proto.attachment.GetAuditPeriodByOIDRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.DeleteAuditPeriodRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.DeleteAuditPeriodRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.DeleteAuditPeriodRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.DeleteAuditPeriodRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.DeleteAuditPeriodRequest}
 */
proto.attachment.DeleteAuditPeriodRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.DeleteAuditPeriodRequest;
  return proto.attachment.DeleteAuditPeriodRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.DeleteAuditPeriodRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.DeleteAuditPeriodRequest}
 */
proto.attachment.DeleteAuditPeriodRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.DeleteAuditPeriodRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.DeleteAuditPeriodRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.DeleteAuditPeriodRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.DeleteAuditPeriodRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.attachment.DeleteAuditPeriodRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.DeleteAuditPeriodRequest} returns this
 */
proto.attachment.DeleteAuditPeriodRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.Document.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.Document.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.Document.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.Document} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.Document.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdat: jspb.Message.getFieldWithDefault(msg, 2, 0),
    accountid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    subjectmodeltype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    subjectmodelid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    actortype: jspb.Message.getFieldWithDefault(msg, 6, 0),
    actor: jspb.Message.getFieldWithDefault(msg, 7, ""),
    auditperiodidsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    doctype: jspb.Message.getFieldWithDefault(msg, 9, 0),
    mime: jspb.Message.getFieldWithDefault(msg, 10, ""),
    body: msg.getBody_asB64(),
    bodysize: jspb.Message.getFieldWithDefault(msg, 12, 0),
    caption: jspb.Message.getFieldWithDefault(msg, 13, ""),
    discoveryid: (f = msg.getDiscoveryid()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    relevantdate: (f = msg.getRelevantdate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    requestid: jspb.Message.getFieldWithDefault(msg, 16, ""),
    allexclusions: (f = msg.getAllexclusions()) && proto.attachment.AllExclusions.toObject(includeInstance, f),
    description: jspb.Message.getFieldWithDefault(msg, 18, ""),
    subjectid: jspb.Message.getFieldWithDefault(msg, 19, ""),
    contentid: jspb.Message.getFieldWithDefault(msg, 20, ""),
    isCustomized: (f = msg.getIsCustomized()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    linkerModelId: jspb.Message.getFieldWithDefault(msg, 22, ""),
    documentpath: jspb.Message.getFieldWithDefault(msg, 23, ""),
    fileName: jspb.Message.getFieldWithDefault(msg, 24, ""),
    sourceServiceModelId: jspb.Message.getFieldWithDefault(msg, 25, ""),
    isViaRequest: jspb.Message.getBooleanFieldWithDefault(msg, 26, false),
    isNewModel: jspb.Message.getBooleanFieldWithDefault(msg, 27, false),
    isLinkedDocument: jspb.Message.getBooleanFieldWithDefault(msg, 28, false),
    isLinkBroken: jspb.Message.getBooleanFieldWithDefault(msg, 29, false),
    receptorId: jspb.Message.getFieldWithDefault(msg, 30, ""),
    receptorModelId: jspb.Message.getFieldWithDefault(msg, 31, ""),
    docImportKey: jspb.Message.getFieldWithDefault(msg, 32, ""),
    docImportLink: jspb.Message.getFieldWithDefault(msg, 33, ""),
    docModifiedAt: (f = msg.getDocModifiedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    docScannedAt: (f = msg.getDocScannedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    isInstanceMissing: jspb.Message.getBooleanFieldWithDefault(msg, 36, false),
    newInstanceId: jspb.Message.getFieldWithDefault(msg, 37, ""),
    lastReviewedDate: (f = msg.getLastReviewedDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    lastApprovedDate: (f = msg.getLastApprovedDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    indexingStatus: jspb.Message.getFieldWithDefault(msg, 40, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.Document}
 */
proto.attachment.Document.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.Document;
  return proto.attachment.Document.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.Document} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.Document}
 */
proto.attachment.Document.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedat(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountid(value);
      break;
    case 4:
      var value = /** @type {!proto.common.MODEL_TYPE} */ (reader.readEnum());
      msg.setSubjectmodeltype(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubjectmodelid(value);
      break;
    case 6:
      var value = /** @type {!proto.attachment.ACTOR_TYPE} */ (reader.readEnum());
      msg.setActortype(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setActor(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addAuditperiodids(value);
      break;
    case 9:
      var value = /** @type {!proto.attachment.DOCUMENT_TYPE} */ (reader.readEnum());
      msg.setDoctype(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setMime(value);
      break;
    case 11:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBody(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBodysize(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDiscoveryid(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRelevantdate(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 17:
      var value = new proto.attachment.AllExclusions;
      reader.readMessage(value,proto.attachment.AllExclusions.deserializeBinaryFromReader);
      msg.setAllexclusions(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubjectid(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentid(value);
      break;
    case 21:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsCustomized(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkerModelId(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentpath(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceServiceModelId(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsViaRequest(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsNewModel(value);
      break;
    case 28:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLinkedDocument(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLinkBroken(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorModelId(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocImportKey(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocImportLink(value);
      break;
    case 34:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDocModifiedAt(value);
      break;
    case 35:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDocScannedAt(value);
      break;
    case 36:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsInstanceMissing(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewInstanceId(value);
      break;
    case 38:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastReviewedDate(value);
      break;
    case 39:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastApprovedDate(value);
      break;
    case 40:
      var value = /** @type {!proto.common.INDEXING_STATUS} */ (reader.readEnum());
      msg.setIndexingStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.Document.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.Document.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.Document} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.Document.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedat();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAccountid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSubjectmodeltype();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSubjectmodelid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getActortype();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getActor();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAuditperiodidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getDoctype();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getMime();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getBody_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      11,
      f
    );
  }
  f = message.getBodysize();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getDiscoveryid();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRelevantdate();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getAllexclusions();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.attachment.AllExclusions.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getSubjectid();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getContentid();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getIsCustomized();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getLinkerModelId();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getDocumentpath();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getSourceServiceModelId();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getIsViaRequest();
  if (f) {
    writer.writeBool(
      26,
      f
    );
  }
  f = message.getIsNewModel();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
  f = message.getIsLinkedDocument();
  if (f) {
    writer.writeBool(
      28,
      f
    );
  }
  f = message.getIsLinkBroken();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getReceptorModelId();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getDocImportKey();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getDocImportLink();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getDocModifiedAt();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDocScannedAt();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsInstanceMissing();
  if (f) {
    writer.writeBool(
      36,
      f
    );
  }
  f = message.getNewInstanceId();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getLastReviewedDate();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastApprovedDate();
  if (f != null) {
    writer.writeMessage(
      39,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIndexingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      40,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.attachment.Document.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 CreatedAt = 2;
 * @return {number}
 */
proto.attachment.Document.prototype.getCreatedat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setCreatedat = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string AccountID = 3;
 * @return {string}
 */
proto.attachment.Document.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setAccountid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional common.MODEL_TYPE SubjectModelType = 4;
 * @return {!proto.common.MODEL_TYPE}
 */
proto.attachment.Document.prototype.getSubjectmodeltype = function() {
  return /** @type {!proto.common.MODEL_TYPE} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.common.MODEL_TYPE} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setSubjectmodeltype = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string SubjectModelID = 5;
 * @return {string}
 */
proto.attachment.Document.prototype.getSubjectmodelid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setSubjectmodelid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional ACTOR_TYPE ActorType = 6;
 * @return {!proto.attachment.ACTOR_TYPE}
 */
proto.attachment.Document.prototype.getActortype = function() {
  return /** @type {!proto.attachment.ACTOR_TYPE} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.attachment.ACTOR_TYPE} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setActortype = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string Actor = 7;
 * @return {string}
 */
proto.attachment.Document.prototype.getActor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setActor = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated string AuditPeriodIDs = 8;
 * @return {!Array<string>}
 */
proto.attachment.Document.prototype.getAuditperiodidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setAuditperiodidsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.addAuditperiodids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.clearAuditperiodidsList = function() {
  return this.setAuditperiodidsList([]);
};


/**
 * optional DOCUMENT_TYPE DocType = 9;
 * @return {!proto.attachment.DOCUMENT_TYPE}
 */
proto.attachment.Document.prototype.getDoctype = function() {
  return /** @type {!proto.attachment.DOCUMENT_TYPE} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.attachment.DOCUMENT_TYPE} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setDoctype = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string Mime = 10;
 * @return {string}
 */
proto.attachment.Document.prototype.getMime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setMime = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional bytes Body = 11;
 * @return {!(string|Uint8Array)}
 */
proto.attachment.Document.prototype.getBody = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * optional bytes Body = 11;
 * This is a type-conversion wrapper around `getBody()`
 * @return {string}
 */
proto.attachment.Document.prototype.getBody_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBody()));
};


/**
 * optional bytes Body = 11;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBody()`
 * @return {!Uint8Array}
 */
proto.attachment.Document.prototype.getBody_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBody()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setBody = function(value) {
  return jspb.Message.setProto3BytesField(this, 11, value);
};


/**
 * optional int64 BodySize = 12;
 * @return {number}
 */
proto.attachment.Document.prototype.getBodysize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setBodysize = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string Caption = 13;
 * @return {string}
 */
proto.attachment.Document.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional google.protobuf.StringValue DiscoveryId = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.Document.prototype.getDiscoveryid = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.Document} returns this
*/
proto.attachment.Document.prototype.setDiscoveryid = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.clearDiscoveryid = function() {
  return this.setDiscoveryid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.Document.prototype.hasDiscoveryid = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Timestamp RelevantDate = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.Document.prototype.getRelevantdate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.Document} returns this
*/
proto.attachment.Document.prototype.setRelevantdate = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.clearRelevantdate = function() {
  return this.setRelevantdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.Document.prototype.hasRelevantdate = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string RequestId = 16;
 * @return {string}
 */
proto.attachment.Document.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional AllExclusions AllExclusions = 17;
 * @return {?proto.attachment.AllExclusions}
 */
proto.attachment.Document.prototype.getAllexclusions = function() {
  return /** @type{?proto.attachment.AllExclusions} */ (
    jspb.Message.getWrapperField(this, proto.attachment.AllExclusions, 17));
};


/**
 * @param {?proto.attachment.AllExclusions|undefined} value
 * @return {!proto.attachment.Document} returns this
*/
proto.attachment.Document.prototype.setAllexclusions = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.clearAllexclusions = function() {
  return this.setAllexclusions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.Document.prototype.hasAllexclusions = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional string Description = 18;
 * @return {string}
 */
proto.attachment.Document.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string SubjectID = 19;
 * @return {string}
 */
proto.attachment.Document.prototype.getSubjectid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setSubjectid = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string ContentID = 20;
 * @return {string}
 */
proto.attachment.Document.prototype.getContentid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setContentid = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional google.protobuf.BoolValue is_customized = 21;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.attachment.Document.prototype.getIsCustomized = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 21));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.attachment.Document} returns this
*/
proto.attachment.Document.prototype.setIsCustomized = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.clearIsCustomized = function() {
  return this.setIsCustomized(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.Document.prototype.hasIsCustomized = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional string linker_model_id = 22;
 * @return {string}
 */
proto.attachment.Document.prototype.getLinkerModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setLinkerModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string DocumentPath = 23;
 * @return {string}
 */
proto.attachment.Document.prototype.getDocumentpath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setDocumentpath = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string file_name = 24;
 * @return {string}
 */
proto.attachment.Document.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string source_service_model_id = 25;
 * @return {string}
 */
proto.attachment.Document.prototype.getSourceServiceModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setSourceServiceModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional bool is_via_request = 26;
 * @return {boolean}
 */
proto.attachment.Document.prototype.getIsViaRequest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setIsViaRequest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 26, value);
};


/**
 * optional bool is_new_model = 27;
 * @return {boolean}
 */
proto.attachment.Document.prototype.getIsNewModel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setIsNewModel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 27, value);
};


/**
 * optional bool is_linked_document = 28;
 * @return {boolean}
 */
proto.attachment.Document.prototype.getIsLinkedDocument = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 28, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setIsLinkedDocument = function(value) {
  return jspb.Message.setProto3BooleanField(this, 28, value);
};


/**
 * optional bool is_link_broken = 29;
 * @return {boolean}
 */
proto.attachment.Document.prototype.getIsLinkBroken = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setIsLinkBroken = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};


/**
 * optional string receptor_id = 30;
 * @return {string}
 */
proto.attachment.Document.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string receptor_model_id = 31;
 * @return {string}
 */
proto.attachment.Document.prototype.getReceptorModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setReceptorModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string doc_import_key = 32;
 * @return {string}
 */
proto.attachment.Document.prototype.getDocImportKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setDocImportKey = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string doc_import_link = 33;
 * @return {string}
 */
proto.attachment.Document.prototype.getDocImportLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setDocImportLink = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional google.protobuf.Timestamp doc_modified_at = 34;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.Document.prototype.getDocModifiedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 34));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.Document} returns this
*/
proto.attachment.Document.prototype.setDocModifiedAt = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.clearDocModifiedAt = function() {
  return this.setDocModifiedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.Document.prototype.hasDocModifiedAt = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional google.protobuf.Timestamp doc_scanned_at = 35;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.Document.prototype.getDocScannedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 35));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.Document} returns this
*/
proto.attachment.Document.prototype.setDocScannedAt = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.clearDocScannedAt = function() {
  return this.setDocScannedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.Document.prototype.hasDocScannedAt = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional bool is_instance_missing = 36;
 * @return {boolean}
 */
proto.attachment.Document.prototype.getIsInstanceMissing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 36, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setIsInstanceMissing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 36, value);
};


/**
 * optional string new_instance_id = 37;
 * @return {string}
 */
proto.attachment.Document.prototype.getNewInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setNewInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional google.protobuf.Timestamp last_reviewed_date = 38;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.Document.prototype.getLastReviewedDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 38));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.Document} returns this
*/
proto.attachment.Document.prototype.setLastReviewedDate = function(value) {
  return jspb.Message.setWrapperField(this, 38, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.clearLastReviewedDate = function() {
  return this.setLastReviewedDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.Document.prototype.hasLastReviewedDate = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional google.protobuf.Timestamp last_approved_date = 39;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.Document.prototype.getLastApprovedDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 39));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.Document} returns this
*/
proto.attachment.Document.prototype.setLastApprovedDate = function(value) {
  return jspb.Message.setWrapperField(this, 39, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.clearLastApprovedDate = function() {
  return this.setLastApprovedDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.Document.prototype.hasLastApprovedDate = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional common.INDEXING_STATUS indexing_status = 40;
 * @return {!proto.common.INDEXING_STATUS}
 */
proto.attachment.Document.prototype.getIndexingStatus = function() {
  return /** @type {!proto.common.INDEXING_STATUS} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/**
 * @param {!proto.common.INDEXING_STATUS} value
 * @return {!proto.attachment.Document} returns this
 */
proto.attachment.Document.prototype.setIndexingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 40, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.AddDocumentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.AddDocumentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.AddDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AddDocumentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    document: (f = msg.getDocument()) && proto.attachment.Document.toObject(includeInstance, f),
    overrideActor: (f = msg.getOverrideActor()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    overrideActorType: (f = msg.getOverrideActorType()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    skipMigration: (f = msg.getSkipMigration()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    regenerateDescription: (f = msg.getRegenerateDescription()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.AddDocumentRequest}
 */
proto.attachment.AddDocumentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.AddDocumentRequest;
  return proto.attachment.AddDocumentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.AddDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.AddDocumentRequest}
 */
proto.attachment.AddDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.Document;
      reader.readMessage(value,proto.attachment.Document.deserializeBinaryFromReader);
      msg.setDocument(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setOverrideActor(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setOverrideActorType(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSkipMigration(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setRegenerateDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.AddDocumentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.AddDocumentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.AddDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AddDocumentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocument();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.Document.serializeBinaryToWriter
    );
  }
  f = message.getOverrideActor();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getOverrideActorType();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getSkipMigration();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getRegenerateDescription();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional Document document = 1;
 * @return {?proto.attachment.Document}
 */
proto.attachment.AddDocumentRequest.prototype.getDocument = function() {
  return /** @type{?proto.attachment.Document} */ (
    jspb.Message.getWrapperField(this, proto.attachment.Document, 1));
};


/**
 * @param {?proto.attachment.Document|undefined} value
 * @return {!proto.attachment.AddDocumentRequest} returns this
*/
proto.attachment.AddDocumentRequest.prototype.setDocument = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.AddDocumentRequest} returns this
 */
proto.attachment.AddDocumentRequest.prototype.clearDocument = function() {
  return this.setDocument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.AddDocumentRequest.prototype.hasDocument = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.BoolValue override_actor = 2;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.attachment.AddDocumentRequest.prototype.getOverrideActor = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 2));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.attachment.AddDocumentRequest} returns this
*/
proto.attachment.AddDocumentRequest.prototype.setOverrideActor = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.AddDocumentRequest} returns this
 */
proto.attachment.AddDocumentRequest.prototype.clearOverrideActor = function() {
  return this.setOverrideActor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.AddDocumentRequest.prototype.hasOverrideActor = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.BoolValue override_actor_type = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.attachment.AddDocumentRequest.prototype.getOverrideActorType = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.attachment.AddDocumentRequest} returns this
*/
proto.attachment.AddDocumentRequest.prototype.setOverrideActorType = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.AddDocumentRequest} returns this
 */
proto.attachment.AddDocumentRequest.prototype.clearOverrideActorType = function() {
  return this.setOverrideActorType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.AddDocumentRequest.prototype.hasOverrideActorType = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue skip_migration = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.attachment.AddDocumentRequest.prototype.getSkipMigration = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.attachment.AddDocumentRequest} returns this
*/
proto.attachment.AddDocumentRequest.prototype.setSkipMigration = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.AddDocumentRequest} returns this
 */
proto.attachment.AddDocumentRequest.prototype.clearSkipMigration = function() {
  return this.setSkipMigration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.AddDocumentRequest.prototype.hasSkipMigration = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.BoolValue regenerate_description = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.attachment.AddDocumentRequest.prototype.getRegenerateDescription = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.attachment.AddDocumentRequest} returns this
*/
proto.attachment.AddDocumentRequest.prototype.setRegenerateDescription = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.AddDocumentRequest} returns this
 */
proto.attachment.AddDocumentRequest.prototype.clearRegenerateDescription = function() {
  return this.setRegenerateDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.AddDocumentRequest.prototype.hasRegenerateDescription = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.LinkDocumentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.LinkDocumentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.LinkDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.LinkDocumentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    document: (f = msg.getDocument()) && proto.attachment.Document.toObject(includeInstance, f),
    url: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.LinkDocumentRequest}
 */
proto.attachment.LinkDocumentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.LinkDocumentRequest;
  return proto.attachment.LinkDocumentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.LinkDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.LinkDocumentRequest}
 */
proto.attachment.LinkDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.Document;
      reader.readMessage(value,proto.attachment.Document.deserializeBinaryFromReader);
      msg.setDocument(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.LinkDocumentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.LinkDocumentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.LinkDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.LinkDocumentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocument();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.Document.serializeBinaryToWriter
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Document document = 1;
 * @return {?proto.attachment.Document}
 */
proto.attachment.LinkDocumentRequest.prototype.getDocument = function() {
  return /** @type{?proto.attachment.Document} */ (
    jspb.Message.getWrapperField(this, proto.attachment.Document, 1));
};


/**
 * @param {?proto.attachment.Document|undefined} value
 * @return {!proto.attachment.LinkDocumentRequest} returns this
*/
proto.attachment.LinkDocumentRequest.prototype.setDocument = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.LinkDocumentRequest} returns this
 */
proto.attachment.LinkDocumentRequest.prototype.clearDocument = function() {
  return this.setDocument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.LinkDocumentRequest.prototype.hasDocument = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.attachment.LinkDocumentRequest.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.LinkDocumentRequest} returns this
 */
proto.attachment.LinkDocumentRequest.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.LinkDocumentsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.LinkDocumentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.LinkDocumentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.LinkDocumentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.LinkDocumentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    documentsList: jspb.Message.toObjectList(msg.getDocumentsList(),
    proto.attachment.LinkDocumentRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.LinkDocumentsRequest}
 */
proto.attachment.LinkDocumentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.LinkDocumentsRequest;
  return proto.attachment.LinkDocumentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.LinkDocumentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.LinkDocumentsRequest}
 */
proto.attachment.LinkDocumentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.LinkDocumentRequest;
      reader.readMessage(value,proto.attachment.LinkDocumentRequest.deserializeBinaryFromReader);
      msg.addDocuments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.LinkDocumentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.LinkDocumentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.LinkDocumentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.LinkDocumentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.LinkDocumentRequest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LinkDocumentRequest documents = 1;
 * @return {!Array<!proto.attachment.LinkDocumentRequest>}
 */
proto.attachment.LinkDocumentsRequest.prototype.getDocumentsList = function() {
  return /** @type{!Array<!proto.attachment.LinkDocumentRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.LinkDocumentRequest, 1));
};


/**
 * @param {!Array<!proto.attachment.LinkDocumentRequest>} value
 * @return {!proto.attachment.LinkDocumentsRequest} returns this
*/
proto.attachment.LinkDocumentsRequest.prototype.setDocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.LinkDocumentRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.LinkDocumentRequest}
 */
proto.attachment.LinkDocumentsRequest.prototype.addDocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.LinkDocumentRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.LinkDocumentsRequest} returns this
 */
proto.attachment.LinkDocumentsRequest.prototype.clearDocumentsList = function() {
  return this.setDocumentsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.Documents.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.Documents.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.Documents.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.Documents} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.Documents.toObject = function(includeInstance, msg) {
  var f, obj = {
    documentsList: jspb.Message.toObjectList(msg.getDocumentsList(),
    proto.attachment.Document.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.Documents}
 */
proto.attachment.Documents.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.Documents;
  return proto.attachment.Documents.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.Documents} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.Documents}
 */
proto.attachment.Documents.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.Document;
      reader.readMessage(value,proto.attachment.Document.deserializeBinaryFromReader);
      msg.addDocuments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.Documents.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.Documents.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.Documents} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.Documents.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.Document.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Document Documents = 1;
 * @return {!Array<!proto.attachment.Document>}
 */
proto.attachment.Documents.prototype.getDocumentsList = function() {
  return /** @type{!Array<!proto.attachment.Document>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.Document, 1));
};


/**
 * @param {!Array<!proto.attachment.Document>} value
 * @return {!proto.attachment.Documents} returns this
*/
proto.attachment.Documents.prototype.setDocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.Document=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.Document}
 */
proto.attachment.Documents.prototype.addDocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.Document, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.Documents} returns this
 */
proto.attachment.Documents.prototype.clearDocumentsList = function() {
  return this.setDocumentsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.AddEvidenceRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.AddEvidenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.AddEvidenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.AddEvidenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AddEvidenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    document: (f = msg.getDocument()) && proto.attachment.Document.toObject(includeInstance, f),
    discoveryId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    receptorId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    serviceModelId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    isManual: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    controlsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    sourceServiceModelId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    relevantDate: (f = msg.getRelevantDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    doNotDuplicate: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    skipMigration: (f = msg.getSkipMigration()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.AddEvidenceRequest}
 */
proto.attachment.AddEvidenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.AddEvidenceRequest;
  return proto.attachment.AddEvidenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.AddEvidenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.AddEvidenceRequest}
 */
proto.attachment.AddEvidenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.Document;
      reader.readMessage(value,proto.attachment.Document.deserializeBinaryFromReader);
      msg.setDocument(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscoveryId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceModelId(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsManual(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addControls(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceServiceModelId(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRelevantDate(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDoNotDuplicate(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSkipMigration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.AddEvidenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.AddEvidenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.AddEvidenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AddEvidenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocument();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.Document.serializeBinaryToWriter
    );
  }
  f = message.getDiscoveryId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getServiceModelId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIsManual();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getControlsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getSourceServiceModelId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRelevantDate();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDoNotDuplicate();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getSkipMigration();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional Document document = 1;
 * @return {?proto.attachment.Document}
 */
proto.attachment.AddEvidenceRequest.prototype.getDocument = function() {
  return /** @type{?proto.attachment.Document} */ (
    jspb.Message.getWrapperField(this, proto.attachment.Document, 1));
};


/**
 * @param {?proto.attachment.Document|undefined} value
 * @return {!proto.attachment.AddEvidenceRequest} returns this
*/
proto.attachment.AddEvidenceRequest.prototype.setDocument = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.AddEvidenceRequest} returns this
 */
proto.attachment.AddEvidenceRequest.prototype.clearDocument = function() {
  return this.setDocument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.AddEvidenceRequest.prototype.hasDocument = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string discovery_id = 2;
 * @return {string}
 */
proto.attachment.AddEvidenceRequest.prototype.getDiscoveryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AddEvidenceRequest} returns this
 */
proto.attachment.AddEvidenceRequest.prototype.setDiscoveryId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string receptor_id = 3;
 * @return {string}
 */
proto.attachment.AddEvidenceRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AddEvidenceRequest} returns this
 */
proto.attachment.AddEvidenceRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string service_model_id = 4;
 * @return {string}
 */
proto.attachment.AddEvidenceRequest.prototype.getServiceModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AddEvidenceRequest} returns this
 */
proto.attachment.AddEvidenceRequest.prototype.setServiceModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool is_manual = 5;
 * @return {boolean}
 */
proto.attachment.AddEvidenceRequest.prototype.getIsManual = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.AddEvidenceRequest} returns this
 */
proto.attachment.AddEvidenceRequest.prototype.setIsManual = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated string controls = 6;
 * @return {!Array<string>}
 */
proto.attachment.AddEvidenceRequest.prototype.getControlsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.AddEvidenceRequest} returns this
 */
proto.attachment.AddEvidenceRequest.prototype.setControlsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.AddEvidenceRequest} returns this
 */
proto.attachment.AddEvidenceRequest.prototype.addControls = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.AddEvidenceRequest} returns this
 */
proto.attachment.AddEvidenceRequest.prototype.clearControlsList = function() {
  return this.setControlsList([]);
};


/**
 * optional string source_service_model_id = 7;
 * @return {string}
 */
proto.attachment.AddEvidenceRequest.prototype.getSourceServiceModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AddEvidenceRequest} returns this
 */
proto.attachment.AddEvidenceRequest.prototype.setSourceServiceModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp relevant_date = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.AddEvidenceRequest.prototype.getRelevantDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.AddEvidenceRequest} returns this
*/
proto.attachment.AddEvidenceRequest.prototype.setRelevantDate = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.AddEvidenceRequest} returns this
 */
proto.attachment.AddEvidenceRequest.prototype.clearRelevantDate = function() {
  return this.setRelevantDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.AddEvidenceRequest.prototype.hasRelevantDate = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool do_not_duplicate = 9;
 * @return {boolean}
 */
proto.attachment.AddEvidenceRequest.prototype.getDoNotDuplicate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.AddEvidenceRequest} returns this
 */
proto.attachment.AddEvidenceRequest.prototype.setDoNotDuplicate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional google.protobuf.BoolValue skip_migration = 10;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.attachment.AddEvidenceRequest.prototype.getSkipMigration = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 10));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.attachment.AddEvidenceRequest} returns this
*/
proto.attachment.AddEvidenceRequest.prototype.setSkipMigration = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.AddEvidenceRequest} returns this
 */
proto.attachment.AddEvidenceRequest.prototype.clearSkipMigration = function() {
  return this.setSkipMigration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.AddEvidenceRequest.prototype.hasSkipMigration = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.BulkAddEvidenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.BulkAddEvidenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.BulkAddEvidenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.BulkAddEvidenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    documents: (f = msg.getDocuments()) && proto.attachment.Documents.toObject(includeInstance, f),
    identifier: (f = msg.getIdentifier()) && common_model_pb.Identifier.toObject(includeInstance, f),
    requestId: (f = msg.getRequestId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    uploadSize: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.BulkAddEvidenceRequest}
 */
proto.attachment.BulkAddEvidenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.BulkAddEvidenceRequest;
  return proto.attachment.BulkAddEvidenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.BulkAddEvidenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.BulkAddEvidenceRequest}
 */
proto.attachment.BulkAddEvidenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.Documents;
      reader.readMessage(value,proto.attachment.Documents.deserializeBinaryFromReader);
      msg.setDocuments(value);
      break;
    case 2:
      var value = new common_model_pb.Identifier;
      reader.readMessage(value,common_model_pb.Identifier.deserializeBinaryFromReader);
      msg.setIdentifier(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRequestId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUploadSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.BulkAddEvidenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.BulkAddEvidenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.BulkAddEvidenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.BulkAddEvidenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocuments();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.Documents.serializeBinaryToWriter
    );
  }
  f = message.getIdentifier();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_model_pb.Identifier.serializeBinaryToWriter
    );
  }
  f = message.getRequestId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getUploadSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional Documents documents = 1;
 * @return {?proto.attachment.Documents}
 */
proto.attachment.BulkAddEvidenceRequest.prototype.getDocuments = function() {
  return /** @type{?proto.attachment.Documents} */ (
    jspb.Message.getWrapperField(this, proto.attachment.Documents, 1));
};


/**
 * @param {?proto.attachment.Documents|undefined} value
 * @return {!proto.attachment.BulkAddEvidenceRequest} returns this
*/
proto.attachment.BulkAddEvidenceRequest.prototype.setDocuments = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.BulkAddEvidenceRequest} returns this
 */
proto.attachment.BulkAddEvidenceRequest.prototype.clearDocuments = function() {
  return this.setDocuments(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.BulkAddEvidenceRequest.prototype.hasDocuments = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.Identifier identifier = 2;
 * @return {?proto.common.Identifier}
 */
proto.attachment.BulkAddEvidenceRequest.prototype.getIdentifier = function() {
  return /** @type{?proto.common.Identifier} */ (
    jspb.Message.getWrapperField(this, common_model_pb.Identifier, 2));
};


/**
 * @param {?proto.common.Identifier|undefined} value
 * @return {!proto.attachment.BulkAddEvidenceRequest} returns this
*/
proto.attachment.BulkAddEvidenceRequest.prototype.setIdentifier = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.BulkAddEvidenceRequest} returns this
 */
proto.attachment.BulkAddEvidenceRequest.prototype.clearIdentifier = function() {
  return this.setIdentifier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.BulkAddEvidenceRequest.prototype.hasIdentifier = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue request_id = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.BulkAddEvidenceRequest.prototype.getRequestId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.BulkAddEvidenceRequest} returns this
*/
proto.attachment.BulkAddEvidenceRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.BulkAddEvidenceRequest} returns this
 */
proto.attachment.BulkAddEvidenceRequest.prototype.clearRequestId = function() {
  return this.setRequestId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.BulkAddEvidenceRequest.prototype.hasRequestId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 upload_size = 4;
 * @return {number}
 */
proto.attachment.BulkAddEvidenceRequest.prototype.getUploadSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.BulkAddEvidenceRequest} returns this
 */
proto.attachment.BulkAddEvidenceRequest.prototype.setUploadSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.DocumentPeriod.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.DocumentPeriod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.DocumentPeriod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.DocumentPeriod.toObject = function(includeInstance, msg) {
  var f, obj = {
    documentid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    auditperiodid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.DocumentPeriod}
 */
proto.attachment.DocumentPeriod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.DocumentPeriod;
  return proto.attachment.DocumentPeriod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.DocumentPeriod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.DocumentPeriod}
 */
proto.attachment.DocumentPeriod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditperiodid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.DocumentPeriod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.DocumentPeriod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.DocumentPeriod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.DocumentPeriod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuditperiodid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string DocumentID = 1;
 * @return {string}
 */
proto.attachment.DocumentPeriod.prototype.getDocumentid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.DocumentPeriod} returns this
 */
proto.attachment.DocumentPeriod.prototype.setDocumentid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string AuditPeriodID = 2;
 * @return {string}
 */
proto.attachment.DocumentPeriod.prototype.getAuditperiodid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.DocumentPeriod} returns this
 */
proto.attachment.DocumentPeriod.prototype.setAuditperiodid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.Caption.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.Caption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.Caption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.Caption.toObject = function(includeInstance, msg) {
  var f, obj = {
    oid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    caption: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.Caption}
 */
proto.attachment.Caption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.Caption;
  return proto.attachment.Caption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.Caption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.Caption}
 */
proto.attachment.Caption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.Caption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.Caption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.Caption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.Caption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string OID = 1;
 * @return {string}
 */
proto.attachment.Caption.prototype.getOid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Caption} returns this
 */
proto.attachment.Caption.prototype.setOid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Caption = 2;
 * @return {string}
 */
proto.attachment.Caption.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Caption} returns this
 */
proto.attachment.Caption.prototype.setCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.AuditPeriod.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.AuditPeriod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.AuditPeriod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AuditPeriod.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 2, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    subjectModelId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    actor: jspb.Message.getFieldWithDefault(msg, 5, ""),
    beginTime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    endTime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    notes: jspb.Message.getFieldWithDefault(msg, 8, ""),
    modelVersion: jspb.Message.getFieldWithDefault(msg, 9, ""),
    modelIds: (f = msg.getModelIds()) && proto.attachment.AuditModelIDs.toObject(includeInstance, f),
    auditor: jspb.Message.getFieldWithDefault(msg, 11, ""),
    auditTime: jspb.Message.getFieldWithDefault(msg, 12, 0),
    closed: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.AuditPeriod}
 */
proto.attachment.AuditPeriod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.AuditPeriod;
  return proto.attachment.AuditPeriod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.AuditPeriod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.AuditPeriod}
 */
proto.attachment.AuditPeriod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubjectModelId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setActor(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBeginTime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndTime(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelVersion(value);
      break;
    case 10:
      var value = new proto.attachment.AuditModelIDs;
      reader.readMessage(value,proto.attachment.AuditModelIDs.deserializeBinaryFromReader);
      msg.setModelIds(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditor(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAuditTime(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClosed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.AuditPeriod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.AuditPeriod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.AuditPeriod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AuditPeriod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSubjectModelId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getActor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBeginTime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getEndTime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getModelVersion();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getModelIds();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.attachment.AuditModelIDs.serializeBinaryToWriter
    );
  }
  f = message.getAuditor();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAuditTime();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getClosed();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.attachment.AuditPeriod.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AuditPeriod} returns this
 */
proto.attachment.AuditPeriod.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 created_at = 2;
 * @return {number}
 */
proto.attachment.AuditPeriod.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.AuditPeriod} returns this
 */
proto.attachment.AuditPeriod.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string account_id = 3;
 * @return {string}
 */
proto.attachment.AuditPeriod.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AuditPeriod} returns this
 */
proto.attachment.AuditPeriod.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string subject_model_id = 4;
 * @return {string}
 */
proto.attachment.AuditPeriod.prototype.getSubjectModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AuditPeriod} returns this
 */
proto.attachment.AuditPeriod.prototype.setSubjectModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string actor = 5;
 * @return {string}
 */
proto.attachment.AuditPeriod.prototype.getActor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AuditPeriod} returns this
 */
proto.attachment.AuditPeriod.prototype.setActor = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 begin_time = 6;
 * @return {number}
 */
proto.attachment.AuditPeriod.prototype.getBeginTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.AuditPeriod} returns this
 */
proto.attachment.AuditPeriod.prototype.setBeginTime = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 end_time = 7;
 * @return {number}
 */
proto.attachment.AuditPeriod.prototype.getEndTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.AuditPeriod} returns this
 */
proto.attachment.AuditPeriod.prototype.setEndTime = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string notes = 8;
 * @return {string}
 */
proto.attachment.AuditPeriod.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AuditPeriod} returns this
 */
proto.attachment.AuditPeriod.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string model_version = 9;
 * @return {string}
 */
proto.attachment.AuditPeriod.prototype.getModelVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AuditPeriod} returns this
 */
proto.attachment.AuditPeriod.prototype.setModelVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional AuditModelIDs model_ids = 10;
 * @return {?proto.attachment.AuditModelIDs}
 */
proto.attachment.AuditPeriod.prototype.getModelIds = function() {
  return /** @type{?proto.attachment.AuditModelIDs} */ (
    jspb.Message.getWrapperField(this, proto.attachment.AuditModelIDs, 10));
};


/**
 * @param {?proto.attachment.AuditModelIDs|undefined} value
 * @return {!proto.attachment.AuditPeriod} returns this
*/
proto.attachment.AuditPeriod.prototype.setModelIds = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.AuditPeriod} returns this
 */
proto.attachment.AuditPeriod.prototype.clearModelIds = function() {
  return this.setModelIds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.AuditPeriod.prototype.hasModelIds = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string auditor = 11;
 * @return {string}
 */
proto.attachment.AuditPeriod.prototype.getAuditor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AuditPeriod} returns this
 */
proto.attachment.AuditPeriod.prototype.setAuditor = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int64 audit_time = 12;
 * @return {number}
 */
proto.attachment.AuditPeriod.prototype.getAuditTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.AuditPeriod} returns this
 */
proto.attachment.AuditPeriod.prototype.setAuditTime = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional bool closed = 13;
 * @return {boolean}
 */
proto.attachment.AuditPeriod.prototype.getClosed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.AuditPeriod} returns this
 */
proto.attachment.AuditPeriod.prototype.setClosed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.AuditModelID.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.AuditModelID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.AuditModelID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AuditModelID.toObject = function(includeInstance, msg) {
  var f, obj = {
    auditid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    modeltype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    modelid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.AuditModelID}
 */
proto.attachment.AuditModelID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.AuditModelID;
  return proto.attachment.AuditModelID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.AuditModelID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.AuditModelID}
 */
proto.attachment.AuditModelID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditid(value);
      break;
    case 2:
      var value = /** @type {!proto.common.MODEL_TYPE} */ (reader.readEnum());
      msg.setModeltype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.AuditModelID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.AuditModelID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.AuditModelID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AuditModelID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuditid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getModeltype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getModelid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string AuditID = 1;
 * @return {string}
 */
proto.attachment.AuditModelID.prototype.getAuditid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AuditModelID} returns this
 */
proto.attachment.AuditModelID.prototype.setAuditid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.MODEL_TYPE ModelType = 2;
 * @return {!proto.common.MODEL_TYPE}
 */
proto.attachment.AuditModelID.prototype.getModeltype = function() {
  return /** @type {!proto.common.MODEL_TYPE} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.common.MODEL_TYPE} value
 * @return {!proto.attachment.AuditModelID} returns this
 */
proto.attachment.AuditModelID.prototype.setModeltype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string ModelID = 3;
 * @return {string}
 */
proto.attachment.AuditModelID.prototype.getModelid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AuditModelID} returns this
 */
proto.attachment.AuditModelID.prototype.setModelid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.AuditModelIDs.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.AuditModelIDs.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.AuditModelIDs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.AuditModelIDs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AuditModelIDs.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: jspb.Message.toObjectList(msg.getIdsList(),
    proto.attachment.AuditModelID.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.AuditModelIDs}
 */
proto.attachment.AuditModelIDs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.AuditModelIDs;
  return proto.attachment.AuditModelIDs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.AuditModelIDs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.AuditModelIDs}
 */
proto.attachment.AuditModelIDs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.AuditModelID;
      reader.readMessage(value,proto.attachment.AuditModelID.deserializeBinaryFromReader);
      msg.addIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.AuditModelIDs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.AuditModelIDs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.AuditModelIDs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AuditModelIDs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.AuditModelID.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AuditModelID IDs = 1;
 * @return {!Array<!proto.attachment.AuditModelID>}
 */
proto.attachment.AuditModelIDs.prototype.getIdsList = function() {
  return /** @type{!Array<!proto.attachment.AuditModelID>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.AuditModelID, 1));
};


/**
 * @param {!Array<!proto.attachment.AuditModelID>} value
 * @return {!proto.attachment.AuditModelIDs} returns this
*/
proto.attachment.AuditModelIDs.prototype.setIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.AuditModelID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.AuditModelID}
 */
proto.attachment.AuditModelIDs.prototype.addIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.AuditModelID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.AuditModelIDs} returns this
 */
proto.attachment.AuditModelIDs.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.AuditPeriods.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.AuditPeriods.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.AuditPeriods.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.AuditPeriods} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AuditPeriods.toObject = function(includeInstance, msg) {
  var f, obj = {
    periodsList: jspb.Message.toObjectList(msg.getPeriodsList(),
    proto.attachment.AuditPeriod.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.AuditPeriods}
 */
proto.attachment.AuditPeriods.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.AuditPeriods;
  return proto.attachment.AuditPeriods.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.AuditPeriods} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.AuditPeriods}
 */
proto.attachment.AuditPeriods.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.AuditPeriod;
      reader.readMessage(value,proto.attachment.AuditPeriod.deserializeBinaryFromReader);
      msg.addPeriods(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.AuditPeriods.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.AuditPeriods.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.AuditPeriods} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AuditPeriods.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPeriodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.AuditPeriod.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AuditPeriod Periods = 1;
 * @return {!Array<!proto.attachment.AuditPeriod>}
 */
proto.attachment.AuditPeriods.prototype.getPeriodsList = function() {
  return /** @type{!Array<!proto.attachment.AuditPeriod>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.AuditPeriod, 1));
};


/**
 * @param {!Array<!proto.attachment.AuditPeriod>} value
 * @return {!proto.attachment.AuditPeriods} returns this
*/
proto.attachment.AuditPeriods.prototype.setPeriodsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.AuditPeriod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.AuditPeriod}
 */
proto.attachment.AuditPeriods.prototype.addPeriods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.AuditPeriod, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.AuditPeriods} returns this
 */
proto.attachment.AuditPeriods.prototype.clearPeriodsList = function() {
  return this.setPeriodsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.IncludeModelIDs.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.IncludeModelIDs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.IncludeModelIDs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.IncludeModelIDs.toObject = function(includeInstance, msg) {
  var f, obj = {
    includemodelids: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.IncludeModelIDs}
 */
proto.attachment.IncludeModelIDs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.IncludeModelIDs;
  return proto.attachment.IncludeModelIDs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.IncludeModelIDs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.IncludeModelIDs}
 */
proto.attachment.IncludeModelIDs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludemodelids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.IncludeModelIDs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.IncludeModelIDs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.IncludeModelIDs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.IncludeModelIDs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncludemodelids();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool IncludeModelIDs = 1;
 * @return {boolean}
 */
proto.attachment.IncludeModelIDs.prototype.getIncludemodelids = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.IncludeModelIDs} returns this
 */
proto.attachment.IncludeModelIDs.prototype.setIncludemodelids = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.CloseAudit.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.CloseAudit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.CloseAudit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.CloseAudit.toObject = function(includeInstance, msg) {
  var f, obj = {
    auditperiodid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    modelversion: jspb.Message.getFieldWithDefault(msg, 2, ""),
    endtime: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.CloseAudit}
 */
proto.attachment.CloseAudit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.CloseAudit;
  return proto.attachment.CloseAudit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.CloseAudit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.CloseAudit}
 */
proto.attachment.CloseAudit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditperiodid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelversion(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.CloseAudit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.CloseAudit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.CloseAudit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.CloseAudit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuditperiodid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getModelversion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEndtime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string AuditPeriodID = 1;
 * @return {string}
 */
proto.attachment.CloseAudit.prototype.getAuditperiodid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.CloseAudit} returns this
 */
proto.attachment.CloseAudit.prototype.setAuditperiodid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ModelVersion = 2;
 * @return {string}
 */
proto.attachment.CloseAudit.prototype.getModelversion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.CloseAudit} returns this
 */
proto.attachment.CloseAudit.prototype.setModelversion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 EndTime = 3;
 * @return {number}
 */
proto.attachment.CloseAudit.prototype.getEndtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.CloseAudit} returns this
 */
proto.attachment.CloseAudit.prototype.setEndtime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.CompleteAudit.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.CompleteAudit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.CompleteAudit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.CompleteAudit.toObject = function(includeInstance, msg) {
  var f, obj = {
    auditperiodid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    auditor: jspb.Message.getFieldWithDefault(msg, 2, ""),
    notes: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.CompleteAudit}
 */
proto.attachment.CompleteAudit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.CompleteAudit;
  return proto.attachment.CompleteAudit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.CompleteAudit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.CompleteAudit}
 */
proto.attachment.CompleteAudit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditperiodid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditor(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.CompleteAudit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.CompleteAudit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.CompleteAudit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.CompleteAudit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuditperiodid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuditor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string AuditPeriodID = 1;
 * @return {string}
 */
proto.attachment.CompleteAudit.prototype.getAuditperiodid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.CompleteAudit} returns this
 */
proto.attachment.CompleteAudit.prototype.setAuditperiodid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Auditor = 2;
 * @return {string}
 */
proto.attachment.CompleteAudit.prototype.getAuditor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.CompleteAudit} returns this
 */
proto.attachment.CompleteAudit.prototype.setAuditor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Notes = 3;
 * @return {string}
 */
proto.attachment.CompleteAudit.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.CompleteAudit} returns this
 */
proto.attachment.CompleteAudit.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.ModelTypeQuery.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.ModelTypeQuery.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.ModelTypeQuery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ModelTypeQuery.toObject = function(includeInstance, msg) {
  var f, obj = {
    modeltype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    begintime: jspb.Message.getFieldWithDefault(msg, 2, 0),
    endtime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    excludebody: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.ModelTypeQuery}
 */
proto.attachment.ModelTypeQuery.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.ModelTypeQuery;
  return proto.attachment.ModelTypeQuery.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.ModelTypeQuery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.ModelTypeQuery}
 */
proto.attachment.ModelTypeQuery.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.MODEL_TYPE} */ (reader.readEnum());
      msg.setModeltype(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBegintime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndtime(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExcludebody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.ModelTypeQuery.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.ModelTypeQuery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.ModelTypeQuery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ModelTypeQuery.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModeltype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBegintime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getEndtime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getExcludebody();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional common.MODEL_TYPE ModelType = 1;
 * @return {!proto.common.MODEL_TYPE}
 */
proto.attachment.ModelTypeQuery.prototype.getModeltype = function() {
  return /** @type {!proto.common.MODEL_TYPE} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.MODEL_TYPE} value
 * @return {!proto.attachment.ModelTypeQuery} returns this
 */
proto.attachment.ModelTypeQuery.prototype.setModeltype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 BeginTime = 2;
 * @return {number}
 */
proto.attachment.ModelTypeQuery.prototype.getBegintime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.ModelTypeQuery} returns this
 */
proto.attachment.ModelTypeQuery.prototype.setBegintime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 EndTime = 3;
 * @return {number}
 */
proto.attachment.ModelTypeQuery.prototype.getEndtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.ModelTypeQuery} returns this
 */
proto.attachment.ModelTypeQuery.prototype.setEndtime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool ExcludeBody = 4;
 * @return {boolean}
 */
proto.attachment.ModelTypeQuery.prototype.getExcludebody = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.ModelTypeQuery} returns this
 */
proto.attachment.ModelTypeQuery.prototype.setExcludebody = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.DocumentTypeQuery.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.DocumentTypeQuery.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.DocumentTypeQuery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.DocumentTypeQuery.toObject = function(includeInstance, msg) {
  var f, obj = {
    documenttype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    excludebody: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.DocumentTypeQuery}
 */
proto.attachment.DocumentTypeQuery.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.DocumentTypeQuery;
  return proto.attachment.DocumentTypeQuery.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.DocumentTypeQuery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.DocumentTypeQuery}
 */
proto.attachment.DocumentTypeQuery.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.attachment.DOCUMENT_TYPE} */ (reader.readEnum());
      msg.setDocumenttype(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExcludebody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.DocumentTypeQuery.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.DocumentTypeQuery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.DocumentTypeQuery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.DocumentTypeQuery.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumenttype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getExcludebody();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional DOCUMENT_TYPE DocumentType = 1;
 * @return {!proto.attachment.DOCUMENT_TYPE}
 */
proto.attachment.DocumentTypeQuery.prototype.getDocumenttype = function() {
  return /** @type {!proto.attachment.DOCUMENT_TYPE} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.attachment.DOCUMENT_TYPE} value
 * @return {!proto.attachment.DocumentTypeQuery} returns this
 */
proto.attachment.DocumentTypeQuery.prototype.setDocumenttype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool ExcludeBody = 2;
 * @return {boolean}
 */
proto.attachment.DocumentTypeQuery.prototype.getExcludebody = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.DocumentTypeQuery} returns this
 */
proto.attachment.DocumentTypeQuery.prototype.setExcludebody = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.IDsQuery.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.IDsQuery.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.IDsQuery.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.IDsQuery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.IDsQuery.toObject = function(includeInstance, msg) {
  var f, obj = {
    subjectidsList: jspb.Message.toObjectList(msg.getSubjectidsList(),
    common_model_pb.Identifier.toObject, includeInstance),
    begintime: jspb.Message.getFieldWithDefault(msg, 2, 0),
    endtime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    excludebody: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    auditId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.IDsQuery}
 */
proto.attachment.IDsQuery.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.IDsQuery;
  return proto.attachment.IDsQuery.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.IDsQuery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.IDsQuery}
 */
proto.attachment.IDsQuery.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_model_pb.Identifier;
      reader.readMessage(value,common_model_pb.Identifier.deserializeBinaryFromReader);
      msg.addSubjectids(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBegintime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndtime(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExcludebody(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.IDsQuery.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.IDsQuery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.IDsQuery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.IDsQuery.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubjectidsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      common_model_pb.Identifier.serializeBinaryToWriter
    );
  }
  f = message.getBegintime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getEndtime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getExcludebody();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * repeated common.Identifier SubjectIDs = 1;
 * @return {!Array<!proto.common.Identifier>}
 */
proto.attachment.IDsQuery.prototype.getSubjectidsList = function() {
  return /** @type{!Array<!proto.common.Identifier>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_model_pb.Identifier, 1));
};


/**
 * @param {!Array<!proto.common.Identifier>} value
 * @return {!proto.attachment.IDsQuery} returns this
*/
proto.attachment.IDsQuery.prototype.setSubjectidsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.common.Identifier=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.Identifier}
 */
proto.attachment.IDsQuery.prototype.addSubjectids = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.common.Identifier, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.IDsQuery} returns this
 */
proto.attachment.IDsQuery.prototype.clearSubjectidsList = function() {
  return this.setSubjectidsList([]);
};


/**
 * optional int64 BeginTime = 2;
 * @return {number}
 */
proto.attachment.IDsQuery.prototype.getBegintime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.IDsQuery} returns this
 */
proto.attachment.IDsQuery.prototype.setBegintime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 EndTime = 3;
 * @return {number}
 */
proto.attachment.IDsQuery.prototype.getEndtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.IDsQuery} returns this
 */
proto.attachment.IDsQuery.prototype.setEndtime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool ExcludeBody = 4;
 * @return {boolean}
 */
proto.attachment.IDsQuery.prototype.getExcludebody = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.IDsQuery} returns this
 */
proto.attachment.IDsQuery.prototype.setExcludebody = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string audit_id = 5;
 * @return {string}
 */
proto.attachment.IDsQuery.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.IDsQuery} returns this
 */
proto.attachment.IDsQuery.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.IDCount.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.IDCount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.IDCount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.IDCount.toObject = function(includeInstance, msg) {
  var f, obj = {
    modeltype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    modelid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.IDCount}
 */
proto.attachment.IDCount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.IDCount;
  return proto.attachment.IDCount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.IDCount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.IDCount}
 */
proto.attachment.IDCount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.MODEL_TYPE} */ (reader.readEnum());
      msg.setModeltype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.IDCount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.IDCount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.IDCount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.IDCount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModeltype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getModelid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional common.MODEL_TYPE ModelType = 1;
 * @return {!proto.common.MODEL_TYPE}
 */
proto.attachment.IDCount.prototype.getModeltype = function() {
  return /** @type {!proto.common.MODEL_TYPE} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.MODEL_TYPE} value
 * @return {!proto.attachment.IDCount} returns this
 */
proto.attachment.IDCount.prototype.setModeltype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string ModelID = 2;
 * @return {string}
 */
proto.attachment.IDCount.prototype.getModelid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.IDCount} returns this
 */
proto.attachment.IDCount.prototype.setModelid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 Count = 3;
 * @return {number}
 */
proto.attachment.IDCount.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.IDCount} returns this
 */
proto.attachment.IDCount.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.IDCounts.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.IDCounts.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.IDCounts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.IDCounts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.IDCounts.toObject = function(includeInstance, msg) {
  var f, obj = {
    countsList: jspb.Message.toObjectList(msg.getCountsList(),
    proto.attachment.IDCount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.IDCounts}
 */
proto.attachment.IDCounts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.IDCounts;
  return proto.attachment.IDCounts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.IDCounts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.IDCounts}
 */
proto.attachment.IDCounts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.IDCount;
      reader.readMessage(value,proto.attachment.IDCount.deserializeBinaryFromReader);
      msg.addCounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.IDCounts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.IDCounts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.IDCounts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.IDCounts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.IDCount.serializeBinaryToWriter
    );
  }
};


/**
 * repeated IDCount Counts = 1;
 * @return {!Array<!proto.attachment.IDCount>}
 */
proto.attachment.IDCounts.prototype.getCountsList = function() {
  return /** @type{!Array<!proto.attachment.IDCount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.IDCount, 1));
};


/**
 * @param {!Array<!proto.attachment.IDCount>} value
 * @return {!proto.attachment.IDCounts} returns this
*/
proto.attachment.IDCounts.prototype.setCountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.IDCount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.IDCount}
 */
proto.attachment.IDCounts.prototype.addCounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.IDCount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.IDCounts} returns this
 */
proto.attachment.IDCounts.prototype.clearCountsList = function() {
  return this.setCountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceBodyByOIDRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceBodyByOIDRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceBodyByOIDRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceBodyByOIDRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    format: jspb.Message.getFieldWithDefault(msg, 2, 0),
    evidenceTestResultId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceBodyByOIDRequest}
 */
proto.attachment.GetEvidenceBodyByOIDRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceBodyByOIDRequest;
  return proto.attachment.GetEvidenceBodyByOIDRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceBodyByOIDRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceBodyByOIDRequest}
 */
proto.attachment.GetEvidenceBodyByOIDRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.attachment.GetEvidenceBodyByOIDRequest.FORMAT} */ (reader.readEnum());
      msg.setFormat(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceTestResultId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceBodyByOIDRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceBodyByOIDRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceBodyByOIDRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceBodyByOIDRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFormat();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getEvidenceTestResultId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.attachment.GetEvidenceBodyByOIDRequest.FORMAT = {
  CSV: 0,
  MARKDOWN: 1,
  PROTOBUF: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.attachment.GetEvidenceBodyByOIDRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetEvidenceBodyByOIDRequest} returns this
 */
proto.attachment.GetEvidenceBodyByOIDRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FORMAT format = 2;
 * @return {!proto.attachment.GetEvidenceBodyByOIDRequest.FORMAT}
 */
proto.attachment.GetEvidenceBodyByOIDRequest.prototype.getFormat = function() {
  return /** @type {!proto.attachment.GetEvidenceBodyByOIDRequest.FORMAT} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.attachment.GetEvidenceBodyByOIDRequest.FORMAT} value
 * @return {!proto.attachment.GetEvidenceBodyByOIDRequest} returns this
 */
proto.attachment.GetEvidenceBodyByOIDRequest.prototype.setFormat = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string evidence_test_result_id = 3;
 * @return {string}
 */
proto.attachment.GetEvidenceBodyByOIDRequest.prototype.getEvidenceTestResultId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetEvidenceBodyByOIDRequest} returns this
 */
proto.attachment.GetEvidenceBodyByOIDRequest.prototype.setEvidenceTestResultId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.GetEvidenceBodyByOIDResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceBodyByOIDResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceBodyByOIDResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceBodyByOIDResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceBodyByOIDResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidence: (f = msg.getEvidence()) && common_payload_pb.Payload.toObject(includeInstance, f),
    exclusionsList: jspb.Message.toObjectList(msg.getExclusionsList(),
    proto.attachment.Excluded.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceBodyByOIDResponse}
 */
proto.attachment.GetEvidenceBodyByOIDResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceBodyByOIDResponse;
  return proto.attachment.GetEvidenceBodyByOIDResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceBodyByOIDResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceBodyByOIDResponse}
 */
proto.attachment.GetEvidenceBodyByOIDResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_payload_pb.Payload;
      reader.readMessage(value,common_payload_pb.Payload.deserializeBinaryFromReader);
      msg.setEvidence(value);
      break;
    case 2:
      var value = new proto.attachment.Excluded;
      reader.readMessage(value,proto.attachment.Excluded.deserializeBinaryFromReader);
      msg.addExclusions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceBodyByOIDResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceBodyByOIDResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceBodyByOIDResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceBodyByOIDResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidence();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_payload_pb.Payload.serializeBinaryToWriter
    );
  }
  f = message.getExclusionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.attachment.Excluded.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.Payload evidence = 1;
 * @return {?proto.common.Payload}
 */
proto.attachment.GetEvidenceBodyByOIDResponse.prototype.getEvidence = function() {
  return /** @type{?proto.common.Payload} */ (
    jspb.Message.getWrapperField(this, common_payload_pb.Payload, 1));
};


/**
 * @param {?proto.common.Payload|undefined} value
 * @return {!proto.attachment.GetEvidenceBodyByOIDResponse} returns this
*/
proto.attachment.GetEvidenceBodyByOIDResponse.prototype.setEvidence = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceBodyByOIDResponse} returns this
 */
proto.attachment.GetEvidenceBodyByOIDResponse.prototype.clearEvidence = function() {
  return this.setEvidence(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceBodyByOIDResponse.prototype.hasEvidence = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Excluded exclusions = 2;
 * @return {!Array<!proto.attachment.Excluded>}
 */
proto.attachment.GetEvidenceBodyByOIDResponse.prototype.getExclusionsList = function() {
  return /** @type{!Array<!proto.attachment.Excluded>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.Excluded, 2));
};


/**
 * @param {!Array<!proto.attachment.Excluded>} value
 * @return {!proto.attachment.GetEvidenceBodyByOIDResponse} returns this
*/
proto.attachment.GetEvidenceBodyByOIDResponse.prototype.setExclusionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.attachment.Excluded=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.Excluded}
 */
proto.attachment.GetEvidenceBodyByOIDResponse.prototype.addExclusions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.attachment.Excluded, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetEvidenceBodyByOIDResponse} returns this
 */
proto.attachment.GetEvidenceBodyByOIDResponse.prototype.clearExclusionsList = function() {
  return this.setExclusionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetLatestEvidenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetLatestEvidenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetLatestEvidenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetLatestEvidenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    timeRange: (f = msg.getTimeRange()) && common_time_pb.TimeRange.toObject(includeInstance, f),
    documentRequestId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    auditId: (f = msg.getAuditId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    showSnappyStats: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    useNewModel: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetLatestEvidenceRequest}
 */
proto.attachment.GetLatestEvidenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetLatestEvidenceRequest;
  return proto.attachment.GetLatestEvidenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetLatestEvidenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetLatestEvidenceRequest}
 */
proto.attachment.GetLatestEvidenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlId(value);
      break;
    case 2:
      var value = new common_time_pb.TimeRange;
      reader.readMessage(value,common_time_pb.TimeRange.deserializeBinaryFromReader);
      msg.setTimeRange(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentRequestId(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAuditId(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowSnappyStats(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseNewModel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetLatestEvidenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetLatestEvidenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetLatestEvidenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetLatestEvidenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTimeRange();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_time_pb.TimeRange.serializeBinaryToWriter
    );
  }
  f = message.getDocumentRequestId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAuditId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getShowSnappyStats();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getUseNewModel();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string control_id = 1;
 * @return {string}
 */
proto.attachment.GetLatestEvidenceRequest.prototype.getControlId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetLatestEvidenceRequest} returns this
 */
proto.attachment.GetLatestEvidenceRequest.prototype.setControlId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.TimeRange time_range = 2;
 * @return {?proto.common.TimeRange}
 */
proto.attachment.GetLatestEvidenceRequest.prototype.getTimeRange = function() {
  return /** @type{?proto.common.TimeRange} */ (
    jspb.Message.getWrapperField(this, common_time_pb.TimeRange, 2));
};


/**
 * @param {?proto.common.TimeRange|undefined} value
 * @return {!proto.attachment.GetLatestEvidenceRequest} returns this
*/
proto.attachment.GetLatestEvidenceRequest.prototype.setTimeRange = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetLatestEvidenceRequest} returns this
 */
proto.attachment.GetLatestEvidenceRequest.prototype.clearTimeRange = function() {
  return this.setTimeRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceRequest.prototype.hasTimeRange = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string document_request_id = 3;
 * @return {string}
 */
proto.attachment.GetLatestEvidenceRequest.prototype.getDocumentRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetLatestEvidenceRequest} returns this
 */
proto.attachment.GetLatestEvidenceRequest.prototype.setDocumentRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue audit_id = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.GetLatestEvidenceRequest.prototype.getAuditId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.GetLatestEvidenceRequest} returns this
*/
proto.attachment.GetLatestEvidenceRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetLatestEvidenceRequest} returns this
 */
proto.attachment.GetLatestEvidenceRequest.prototype.clearAuditId = function() {
  return this.setAuditId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceRequest.prototype.hasAuditId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool show_snappy_stats = 5;
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceRequest.prototype.getShowSnappyStats = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetLatestEvidenceRequest} returns this
 */
proto.attachment.GetLatestEvidenceRequest.prototype.setShowSnappyStats = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool use_new_model = 6;
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceRequest.prototype.getUseNewModel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetLatestEvidenceRequest} returns this
 */
proto.attachment.GetLatestEvidenceRequest.prototype.setUseNewModel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetControlEvidenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetControlEvidenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetControlEvidenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetControlEvidenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    timeRange: (f = msg.getTimeRange()) && common_time_pb.TimeRange.toObject(includeInstance, f),
    showSnappyStats: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    useNewModel: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetControlEvidenceRequest}
 */
proto.attachment.GetControlEvidenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetControlEvidenceRequest;
  return proto.attachment.GetControlEvidenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetControlEvidenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetControlEvidenceRequest}
 */
proto.attachment.GetControlEvidenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlId(value);
      break;
    case 2:
      var value = new common_time_pb.TimeRange;
      reader.readMessage(value,common_time_pb.TimeRange.deserializeBinaryFromReader);
      msg.setTimeRange(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowSnappyStats(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseNewModel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetControlEvidenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetControlEvidenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetControlEvidenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetControlEvidenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTimeRange();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_time_pb.TimeRange.serializeBinaryToWriter
    );
  }
  f = message.getShowSnappyStats();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getUseNewModel();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string control_id = 1;
 * @return {string}
 */
proto.attachment.GetControlEvidenceRequest.prototype.getControlId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetControlEvidenceRequest} returns this
 */
proto.attachment.GetControlEvidenceRequest.prototype.setControlId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.TimeRange time_range = 2;
 * @return {?proto.common.TimeRange}
 */
proto.attachment.GetControlEvidenceRequest.prototype.getTimeRange = function() {
  return /** @type{?proto.common.TimeRange} */ (
    jspb.Message.getWrapperField(this, common_time_pb.TimeRange, 2));
};


/**
 * @param {?proto.common.TimeRange|undefined} value
 * @return {!proto.attachment.GetControlEvidenceRequest} returns this
*/
proto.attachment.GetControlEvidenceRequest.prototype.setTimeRange = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetControlEvidenceRequest} returns this
 */
proto.attachment.GetControlEvidenceRequest.prototype.clearTimeRange = function() {
  return this.setTimeRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetControlEvidenceRequest.prototype.hasTimeRange = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool show_snappy_stats = 3;
 * @return {boolean}
 */
proto.attachment.GetControlEvidenceRequest.prototype.getShowSnappyStats = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetControlEvidenceRequest} returns this
 */
proto.attachment.GetControlEvidenceRequest.prototype.setShowSnappyStats = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool use_new_model = 4;
 * @return {boolean}
 */
proto.attachment.GetControlEvidenceRequest.prototype.getUseNewModel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetControlEvidenceRequest} returns this
 */
proto.attachment.GetControlEvidenceRequest.prototype.setUseNewModel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.GetControlEvidenceResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetControlEvidenceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetControlEvidenceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetControlEvidenceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetControlEvidenceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.attachment.ControlEvidenceGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetControlEvidenceResponse}
 */
proto.attachment.GetControlEvidenceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetControlEvidenceResponse;
  return proto.attachment.GetControlEvidenceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetControlEvidenceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetControlEvidenceResponse}
 */
proto.attachment.GetControlEvidenceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.ControlEvidenceGroup;
      reader.readMessage(value,proto.attachment.ControlEvidenceGroup.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetControlEvidenceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetControlEvidenceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetControlEvidenceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetControlEvidenceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.ControlEvidenceGroup.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ControlEvidenceGroup items = 1;
 * @return {!Array<!proto.attachment.ControlEvidenceGroup>}
 */
proto.attachment.GetControlEvidenceResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.attachment.ControlEvidenceGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.ControlEvidenceGroup, 1));
};


/**
 * @param {!Array<!proto.attachment.ControlEvidenceGroup>} value
 * @return {!proto.attachment.GetControlEvidenceResponse} returns this
*/
proto.attachment.GetControlEvidenceResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.ControlEvidenceGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.ControlEvidenceGroup}
 */
proto.attachment.GetControlEvidenceResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.ControlEvidenceGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetControlEvidenceResponse} returns this
 */
proto.attachment.GetControlEvidenceResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.AutomatedEvidenceFilter.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.AutomatedEvidenceFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.AutomatedEvidenceFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.AutomatedEvidenceFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AutomatedEvidenceFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.AutomatedEvidenceFilter}
 */
proto.attachment.AutomatedEvidenceFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.AutomatedEvidenceFilter;
  return proto.attachment.AutomatedEvidenceFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.AutomatedEvidenceFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.AutomatedEvidenceFilter}
 */
proto.attachment.AutomatedEvidenceFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addEvidenceIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.AutomatedEvidenceFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.AutomatedEvidenceFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.AutomatedEvidenceFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AutomatedEvidenceFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string evidence_ids = 1;
 * @return {!Array<string>}
 */
proto.attachment.AutomatedEvidenceFilter.prototype.getEvidenceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.AutomatedEvidenceFilter} returns this
 */
proto.attachment.AutomatedEvidenceFilter.prototype.setEvidenceIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.AutomatedEvidenceFilter} returns this
 */
proto.attachment.AutomatedEvidenceFilter.prototype.addEvidenceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.AutomatedEvidenceFilter} returns this
 */
proto.attachment.AutomatedEvidenceFilter.prototype.clearEvidenceIdsList = function() {
  return this.setEvidenceIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.FileTypeFilter.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.FileTypeFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.FileTypeFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.FileTypeFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.FileTypeFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    mimeTypesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.FileTypeFilter}
 */
proto.attachment.FileTypeFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.FileTypeFilter;
  return proto.attachment.FileTypeFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.FileTypeFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.FileTypeFilter}
 */
proto.attachment.FileTypeFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addMimeTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.FileTypeFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.FileTypeFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.FileTypeFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.FileTypeFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMimeTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string mime_types = 1;
 * @return {!Array<string>}
 */
proto.attachment.FileTypeFilter.prototype.getMimeTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.FileTypeFilter} returns this
 */
proto.attachment.FileTypeFilter.prototype.setMimeTypesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.FileTypeFilter} returns this
 */
proto.attachment.FileTypeFilter.prototype.addMimeTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.FileTypeFilter} returns this
 */
proto.attachment.FileTypeFilter.prototype.clearMimeTypesList = function() {
  return this.setMimeTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.EvidenceTypeFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.EvidenceTypeFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.EvidenceTypeFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceTypeFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    automatedEvidenceFilter: (f = msg.getAutomatedEvidenceFilter()) && proto.attachment.AutomatedEvidenceFilter.toObject(includeInstance, f),
    fileTypeFilter: (f = msg.getFileTypeFilter()) && proto.attachment.FileTypeFilter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.EvidenceTypeFilter}
 */
proto.attachment.EvidenceTypeFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.EvidenceTypeFilter;
  return proto.attachment.EvidenceTypeFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.EvidenceTypeFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.EvidenceTypeFilter}
 */
proto.attachment.EvidenceTypeFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.AutomatedEvidenceFilter;
      reader.readMessage(value,proto.attachment.AutomatedEvidenceFilter.deserializeBinaryFromReader);
      msg.setAutomatedEvidenceFilter(value);
      break;
    case 2:
      var value = new proto.attachment.FileTypeFilter;
      reader.readMessage(value,proto.attachment.FileTypeFilter.deserializeBinaryFromReader);
      msg.setFileTypeFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.EvidenceTypeFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.EvidenceTypeFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.EvidenceTypeFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceTypeFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAutomatedEvidenceFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.AutomatedEvidenceFilter.serializeBinaryToWriter
    );
  }
  f = message.getFileTypeFilter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.attachment.FileTypeFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional AutomatedEvidenceFilter automated_evidence_filter = 1;
 * @return {?proto.attachment.AutomatedEvidenceFilter}
 */
proto.attachment.EvidenceTypeFilter.prototype.getAutomatedEvidenceFilter = function() {
  return /** @type{?proto.attachment.AutomatedEvidenceFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.AutomatedEvidenceFilter, 1));
};


/**
 * @param {?proto.attachment.AutomatedEvidenceFilter|undefined} value
 * @return {!proto.attachment.EvidenceTypeFilter} returns this
*/
proto.attachment.EvidenceTypeFilter.prototype.setAutomatedEvidenceFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceTypeFilter} returns this
 */
proto.attachment.EvidenceTypeFilter.prototype.clearAutomatedEvidenceFilter = function() {
  return this.setAutomatedEvidenceFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceTypeFilter.prototype.hasAutomatedEvidenceFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FileTypeFilter file_type_filter = 2;
 * @return {?proto.attachment.FileTypeFilter}
 */
proto.attachment.EvidenceTypeFilter.prototype.getFileTypeFilter = function() {
  return /** @type{?proto.attachment.FileTypeFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.FileTypeFilter, 2));
};


/**
 * @param {?proto.attachment.FileTypeFilter|undefined} value
 * @return {!proto.attachment.EvidenceTypeFilter} returns this
*/
proto.attachment.EvidenceTypeFilter.prototype.setFileTypeFilter = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceTypeFilter} returns this
 */
proto.attachment.EvidenceTypeFilter.prototype.clearFileTypeFilter = function() {
  return this.setFileTypeFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceTypeFilter.prototype.hasFileTypeFilter = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.EvidenceIdFilter.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.EvidenceIdFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.EvidenceIdFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.EvidenceIdFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceIdFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.EvidenceIdFilter}
 */
proto.attachment.EvidenceIdFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.EvidenceIdFilter;
  return proto.attachment.EvidenceIdFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.EvidenceIdFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.EvidenceIdFilter}
 */
proto.attachment.EvidenceIdFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addEvidenceIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.EvidenceIdFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.EvidenceIdFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.EvidenceIdFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceIdFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string evidence_ids = 1;
 * @return {!Array<string>}
 */
proto.attachment.EvidenceIdFilter.prototype.getEvidenceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.EvidenceIdFilter} returns this
 */
proto.attachment.EvidenceIdFilter.prototype.setEvidenceIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceIdFilter} returns this
 */
proto.attachment.EvidenceIdFilter.prototype.addEvidenceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.EvidenceIdFilter} returns this
 */
proto.attachment.EvidenceIdFilter.prototype.clearEvidenceIdsList = function() {
  return this.setEvidenceIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.ControlFilter.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.ControlFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.ControlFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.ControlFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ControlFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.ControlFilter}
 */
proto.attachment.ControlFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.ControlFilter;
  return proto.attachment.ControlFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.ControlFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.ControlFilter}
 */
proto.attachment.ControlFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addControlIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.ControlFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.ControlFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.ControlFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ControlFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string control_ids = 1;
 * @return {!Array<string>}
 */
proto.attachment.ControlFilter.prototype.getControlIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.ControlFilter} returns this
 */
proto.attachment.ControlFilter.prototype.setControlIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.ControlFilter} returns this
 */
proto.attachment.ControlFilter.prototype.addControlIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.ControlFilter} returns this
 */
proto.attachment.ControlFilter.prototype.clearControlIdsList = function() {
  return this.setControlIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.ActorFilter.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.ActorFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.ActorFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.ActorFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ActorFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    actorsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.ActorFilter}
 */
proto.attachment.ActorFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.ActorFilter;
  return proto.attachment.ActorFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.ActorFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.ActorFilter}
 */
proto.attachment.ActorFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addActors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.ActorFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.ActorFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.ActorFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ActorFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActorsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string actors = 1;
 * @return {!Array<string>}
 */
proto.attachment.ActorFilter.prototype.getActorsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.ActorFilter} returns this
 */
proto.attachment.ActorFilter.prototype.setActorsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.ActorFilter} returns this
 */
proto.attachment.ActorFilter.prototype.addActors = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.ActorFilter} returns this
 */
proto.attachment.ActorFilter.prototype.clearActorsList = function() {
  return this.setActorsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.EvidenceSort.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.EvidenceSort.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.EvidenceSort} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceSort.toObject = function(includeInstance, msg) {
  var f, obj = {
    sortOrder: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sortColumn: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.EvidenceSort}
 */
proto.attachment.EvidenceSort.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.EvidenceSort;
  return proto.attachment.EvidenceSort.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.EvidenceSort} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.EvidenceSort}
 */
proto.attachment.EvidenceSort.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.SortOrder} */ (reader.readEnum());
      msg.setSortOrder(value);
      break;
    case 2:
      var value = /** @type {!proto.attachment.EVIDENCE_SORT_COLUMN} */ (reader.readEnum());
      msg.setSortColumn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.EvidenceSort.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.EvidenceSort.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.EvidenceSort} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceSort.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSortOrder();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSortColumn();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional common.SortOrder sort_order = 1;
 * @return {!proto.common.SortOrder}
 */
proto.attachment.EvidenceSort.prototype.getSortOrder = function() {
  return /** @type {!proto.common.SortOrder} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.SortOrder} value
 * @return {!proto.attachment.EvidenceSort} returns this
 */
proto.attachment.EvidenceSort.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional EVIDENCE_SORT_COLUMN sort_column = 2;
 * @return {!proto.attachment.EVIDENCE_SORT_COLUMN}
 */
proto.attachment.EvidenceSort.prototype.getSortColumn = function() {
  return /** @type {!proto.attachment.EVIDENCE_SORT_COLUMN} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.attachment.EVIDENCE_SORT_COLUMN} value
 * @return {!proto.attachment.EvidenceSort} returns this
 */
proto.attachment.EvidenceSort.prototype.setSortColumn = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetLatestEvidenceGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetLatestEvidenceGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetLatestEvidenceGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    auditId: (f = msg.getAuditId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    dateRangeFilter: (f = msg.getDateRangeFilter()) && common_time_pb.TimeRange.toObject(includeInstance, f),
    controlFilter: (f = msg.getControlFilter()) && proto.attachment.ControlFilter.toObject(includeInstance, f),
    actorFilter: (f = msg.getActorFilter()) && proto.attachment.ActorFilter.toObject(includeInstance, f),
    sort: (f = msg.getSort()) && proto.attachment.EvidenceSort.toObject(includeInstance, f),
    pagination: (f = msg.getPagination()) && common_pagination_pb.PaginationConfig.toObject(includeInstance, f),
    evidenceTypeFilter: (f = msg.getEvidenceTypeFilter()) && proto.attachment.EvidenceTypeFilter.toObject(includeInstance, f),
    useSnappyCode: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    showSnappyStats: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    useNewModel: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    requestFilter: (f = msg.getRequestFilter()) && proto.attachment.RequestFilter.toObject(includeInstance, f),
    includeOutOfWindow: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    auditScopesDatesOnly: jspb.Message.getBooleanFieldWithDefault(msg, 15, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetLatestEvidenceGroupsRequest;
  return proto.attachment.GetLatestEvidenceGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetLatestEvidenceGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAuditId(value);
      break;
    case 4:
      var value = new common_time_pb.TimeRange;
      reader.readMessage(value,common_time_pb.TimeRange.deserializeBinaryFromReader);
      msg.setDateRangeFilter(value);
      break;
    case 5:
      var value = new proto.attachment.ControlFilter;
      reader.readMessage(value,proto.attachment.ControlFilter.deserializeBinaryFromReader);
      msg.setControlFilter(value);
      break;
    case 6:
      var value = new proto.attachment.ActorFilter;
      reader.readMessage(value,proto.attachment.ActorFilter.deserializeBinaryFromReader);
      msg.setActorFilter(value);
      break;
    case 7:
      var value = new proto.attachment.EvidenceSort;
      reader.readMessage(value,proto.attachment.EvidenceSort.deserializeBinaryFromReader);
      msg.setSort(value);
      break;
    case 8:
      var value = new common_pagination_pb.PaginationConfig;
      reader.readMessage(value,common_pagination_pb.PaginationConfig.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 9:
      var value = new proto.attachment.EvidenceTypeFilter;
      reader.readMessage(value,proto.attachment.EvidenceTypeFilter.deserializeBinaryFromReader);
      msg.setEvidenceTypeFilter(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseSnappyCode(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowSnappyStats(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseNewModel(value);
      break;
    case 13:
      var value = new proto.attachment.RequestFilter;
      reader.readMessage(value,proto.attachment.RequestFilter.deserializeBinaryFromReader);
      msg.setRequestFilter(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeOutOfWindow(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAuditScopesDatesOnly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetLatestEvidenceGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetLatestEvidenceGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetLatestEvidenceGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuditId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDateRangeFilter();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_time_pb.TimeRange.serializeBinaryToWriter
    );
  }
  f = message.getControlFilter();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.attachment.ControlFilter.serializeBinaryToWriter
    );
  }
  f = message.getActorFilter();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.attachment.ActorFilter.serializeBinaryToWriter
    );
  }
  f = message.getSort();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.attachment.EvidenceSort.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      common_pagination_pb.PaginationConfig.serializeBinaryToWriter
    );
  }
  f = message.getEvidenceTypeFilter();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.attachment.EvidenceTypeFilter.serializeBinaryToWriter
    );
  }
  f = message.getUseSnappyCode();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getShowSnappyStats();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getUseNewModel();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getRequestFilter();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.attachment.RequestFilter.serializeBinaryToWriter
    );
  }
  f = message.getIncludeOutOfWindow();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getAuditScopesDatesOnly();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
};


/**
 * optional google.protobuf.StringValue audit_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.getAuditId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
*/
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.clearAuditId = function() {
  return this.setAuditId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.hasAuditId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.TimeRange date_range_filter = 4;
 * @return {?proto.common.TimeRange}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.getDateRangeFilter = function() {
  return /** @type{?proto.common.TimeRange} */ (
    jspb.Message.getWrapperField(this, common_time_pb.TimeRange, 4));
};


/**
 * @param {?proto.common.TimeRange|undefined} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
*/
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.setDateRangeFilter = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.clearDateRangeFilter = function() {
  return this.setDateRangeFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.hasDateRangeFilter = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ControlFilter control_filter = 5;
 * @return {?proto.attachment.ControlFilter}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.getControlFilter = function() {
  return /** @type{?proto.attachment.ControlFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.ControlFilter, 5));
};


/**
 * @param {?proto.attachment.ControlFilter|undefined} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
*/
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.setControlFilter = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.clearControlFilter = function() {
  return this.setControlFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.hasControlFilter = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ActorFilter actor_filter = 6;
 * @return {?proto.attachment.ActorFilter}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.getActorFilter = function() {
  return /** @type{?proto.attachment.ActorFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.ActorFilter, 6));
};


/**
 * @param {?proto.attachment.ActorFilter|undefined} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
*/
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.setActorFilter = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.clearActorFilter = function() {
  return this.setActorFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.hasActorFilter = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional EvidenceSort sort = 7;
 * @return {?proto.attachment.EvidenceSort}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.getSort = function() {
  return /** @type{?proto.attachment.EvidenceSort} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceSort, 7));
};


/**
 * @param {?proto.attachment.EvidenceSort|undefined} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
*/
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.setSort = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.clearSort = function() {
  return this.setSort(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.hasSort = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional common.PaginationConfig pagination = 8;
 * @return {?proto.common.PaginationConfig}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.getPagination = function() {
  return /** @type{?proto.common.PaginationConfig} */ (
    jspb.Message.getWrapperField(this, common_pagination_pb.PaginationConfig, 8));
};


/**
 * @param {?proto.common.PaginationConfig|undefined} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
*/
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional EvidenceTypeFilter evidence_type_filter = 9;
 * @return {?proto.attachment.EvidenceTypeFilter}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.getEvidenceTypeFilter = function() {
  return /** @type{?proto.attachment.EvidenceTypeFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceTypeFilter, 9));
};


/**
 * @param {?proto.attachment.EvidenceTypeFilter|undefined} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
*/
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.setEvidenceTypeFilter = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.clearEvidenceTypeFilter = function() {
  return this.setEvidenceTypeFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.hasEvidenceTypeFilter = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool use_snappy_code = 10;
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.getUseSnappyCode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.setUseSnappyCode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool show_snappy_stats = 11;
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.getShowSnappyStats = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.setShowSnappyStats = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool use_new_model = 12;
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.getUseNewModel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.setUseNewModel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional RequestFilter request_filter = 13;
 * @return {?proto.attachment.RequestFilter}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.getRequestFilter = function() {
  return /** @type{?proto.attachment.RequestFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.RequestFilter, 13));
};


/**
 * @param {?proto.attachment.RequestFilter|undefined} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
*/
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.setRequestFilter = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.clearRequestFilter = function() {
  return this.setRequestFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.hasRequestFilter = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional bool include_out_of_window = 14;
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.getIncludeOutOfWindow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.setIncludeOutOfWindow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool audit_scopes_dates_only = 15;
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.getAuditScopesDatesOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsRequest} returns this
 */
proto.attachment.GetLatestEvidenceGroupsRequest.prototype.setAuditScopesDatesOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.Excluded.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.Excluded.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.Excluded.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.Excluded} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.Excluded.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    instanceNamesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.Excluded}
 */
proto.attachment.Excluded.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.Excluded;
  return proto.attachment.Excluded.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.Excluded} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.Excluded}
 */
proto.attachment.Excluded.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addInstanceNames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.Excluded.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.Excluded.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.Excluded} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.Excluded.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInstanceNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string service_id = 1;
 * @return {string}
 */
proto.attachment.Excluded.prototype.getServiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Excluded} returns this
 */
proto.attachment.Excluded.prototype.setServiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string instance_names = 2;
 * @return {!Array<string>}
 */
proto.attachment.Excluded.prototype.getInstanceNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.Excluded} returns this
 */
proto.attachment.Excluded.prototype.setInstanceNamesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.Excluded} returns this
 */
proto.attachment.Excluded.prototype.addInstanceNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.Excluded} returns this
 */
proto.attachment.Excluded.prototype.clearInstanceNamesList = function() {
  return this.setInstanceNamesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.AllExclusions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.AllExclusions.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.AllExclusions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.AllExclusions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AllExclusions.toObject = function(includeInstance, msg) {
  var f, obj = {
    exclusionsList: jspb.Message.toObjectList(msg.getExclusionsList(),
    proto.attachment.Excluded.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.AllExclusions}
 */
proto.attachment.AllExclusions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.AllExclusions;
  return proto.attachment.AllExclusions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.AllExclusions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.AllExclusions}
 */
proto.attachment.AllExclusions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.Excluded;
      reader.readMessage(value,proto.attachment.Excluded.deserializeBinaryFromReader);
      msg.addExclusions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.AllExclusions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.AllExclusions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.AllExclusions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AllExclusions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExclusionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.Excluded.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Excluded exclusions = 1;
 * @return {!Array<!proto.attachment.Excluded>}
 */
proto.attachment.AllExclusions.prototype.getExclusionsList = function() {
  return /** @type{!Array<!proto.attachment.Excluded>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.Excluded, 1));
};


/**
 * @param {!Array<!proto.attachment.Excluded>} value
 * @return {!proto.attachment.AllExclusions} returns this
*/
proto.attachment.AllExclusions.prototype.setExclusionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.Excluded=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.Excluded}
 */
proto.attachment.AllExclusions.prototype.addExclusions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.Excluded, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.AllExclusions} returns this
 */
proto.attachment.AllExclusions.prototype.clearExclusionsList = function() {
  return this.setExclusionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceDiscoveryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceDiscoveryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceDiscoveryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceDiscoveryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceDiscoveryRequest}
 */
proto.attachment.GetEvidenceDiscoveryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceDiscoveryRequest;
  return proto.attachment.GetEvidenceDiscoveryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceDiscoveryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceDiscoveryRequest}
 */
proto.attachment.GetEvidenceDiscoveryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceDiscoveryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceDiscoveryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceDiscoveryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceDiscoveryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string evidence_id = 1;
 * @return {string}
 */
proto.attachment.GetEvidenceDiscoveryRequest.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetEvidenceDiscoveryRequest} returns this
 */
proto.attachment.GetEvidenceDiscoveryRequest.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.GetEvidenceDiscoveryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceDiscoveryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceDiscoveryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceDiscoveryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceDiscoveryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceDiscoveriesList: jspb.Message.toObjectList(msg.getServiceDiscoveriesList(),
    proto.attachment.ServiceDiscovery.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceDiscoveryResponse}
 */
proto.attachment.GetEvidenceDiscoveryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceDiscoveryResponse;
  return proto.attachment.GetEvidenceDiscoveryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceDiscoveryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceDiscoveryResponse}
 */
proto.attachment.GetEvidenceDiscoveryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.ServiceDiscovery;
      reader.readMessage(value,proto.attachment.ServiceDiscovery.deserializeBinaryFromReader);
      msg.addServiceDiscoveries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceDiscoveryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceDiscoveryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceDiscoveryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceDiscoveryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceDiscoveriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.ServiceDiscovery.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ServiceDiscovery service_discoveries = 1;
 * @return {!Array<!proto.attachment.ServiceDiscovery>}
 */
proto.attachment.GetEvidenceDiscoveryResponse.prototype.getServiceDiscoveriesList = function() {
  return /** @type{!Array<!proto.attachment.ServiceDiscovery>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.ServiceDiscovery, 1));
};


/**
 * @param {!Array<!proto.attachment.ServiceDiscovery>} value
 * @return {!proto.attachment.GetEvidenceDiscoveryResponse} returns this
*/
proto.attachment.GetEvidenceDiscoveryResponse.prototype.setServiceDiscoveriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.ServiceDiscovery=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.ServiceDiscovery}
 */
proto.attachment.GetEvidenceDiscoveryResponse.prototype.addServiceDiscoveries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.ServiceDiscovery, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetEvidenceDiscoveryResponse} returns this
 */
proto.attachment.GetEvidenceDiscoveryResponse.prototype.clearServiceDiscoveriesList = function() {
  return this.setServiceDiscoveriesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.ServiceDiscovery.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.ServiceDiscovery.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.ServiceDiscovery.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.ServiceDiscovery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ServiceDiscovery.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    apiCallsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    discovery: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.ServiceDiscovery}
 */
proto.attachment.ServiceDiscovery.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.ServiceDiscovery;
  return proto.attachment.ServiceDiscovery.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.ServiceDiscovery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.ServiceDiscovery}
 */
proto.attachment.ServiceDiscovery.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addApiCalls(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscovery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.ServiceDiscovery.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.ServiceDiscovery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.ServiceDiscovery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ServiceDiscovery.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getApiCallsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getDiscovery();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string service_id = 1;
 * @return {string}
 */
proto.attachment.ServiceDiscovery.prototype.getServiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ServiceDiscovery} returns this
 */
proto.attachment.ServiceDiscovery.prototype.setServiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string api_calls = 2;
 * @return {!Array<string>}
 */
proto.attachment.ServiceDiscovery.prototype.getApiCallsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.ServiceDiscovery} returns this
 */
proto.attachment.ServiceDiscovery.prototype.setApiCallsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.ServiceDiscovery} returns this
 */
proto.attachment.ServiceDiscovery.prototype.addApiCalls = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.ServiceDiscovery} returns this
 */
proto.attachment.ServiceDiscovery.prototype.clearApiCallsList = function() {
  return this.setApiCallsList([]);
};


/**
 * optional string discovery = 3;
 * @return {string}
 */
proto.attachment.ServiceDiscovery.prototype.getDiscovery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ServiceDiscovery} returns this
 */
proto.attachment.ServiceDiscovery.prototype.setDiscovery = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.ListEvidenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.ListEvidenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.ListEvidenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ListEvidenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    caption: (f = msg.getCaption()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    timeRange: (f = msg.getTimeRange()) && common_time_pb.TimeRange.toObject(includeInstance, f),
    documentRequestId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    auditId: (f = msg.getAuditId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.ListEvidenceRequest}
 */
proto.attachment.ListEvidenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.ListEvidenceRequest;
  return proto.attachment.ListEvidenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.ListEvidenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.ListEvidenceRequest}
 */
proto.attachment.ListEvidenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCaption(value);
      break;
    case 3:
      var value = new common_time_pb.TimeRange;
      reader.readMessage(value,common_time_pb.TimeRange.deserializeBinaryFromReader);
      msg.setTimeRange(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentRequestId(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.ListEvidenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.ListEvidenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.ListEvidenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ListEvidenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCaption();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTimeRange();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_time_pb.TimeRange.serializeBinaryToWriter
    );
  }
  f = message.getDocumentRequestId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAuditId();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string control_id = 1;
 * @return {string}
 */
proto.attachment.ListEvidenceRequest.prototype.getControlId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ListEvidenceRequest} returns this
 */
proto.attachment.ListEvidenceRequest.prototype.setControlId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue caption = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.ListEvidenceRequest.prototype.getCaption = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.ListEvidenceRequest} returns this
*/
proto.attachment.ListEvidenceRequest.prototype.setCaption = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ListEvidenceRequest} returns this
 */
proto.attachment.ListEvidenceRequest.prototype.clearCaption = function() {
  return this.setCaption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ListEvidenceRequest.prototype.hasCaption = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional common.TimeRange time_range = 3;
 * @return {?proto.common.TimeRange}
 */
proto.attachment.ListEvidenceRequest.prototype.getTimeRange = function() {
  return /** @type{?proto.common.TimeRange} */ (
    jspb.Message.getWrapperField(this, common_time_pb.TimeRange, 3));
};


/**
 * @param {?proto.common.TimeRange|undefined} value
 * @return {!proto.attachment.ListEvidenceRequest} returns this
*/
proto.attachment.ListEvidenceRequest.prototype.setTimeRange = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ListEvidenceRequest} returns this
 */
proto.attachment.ListEvidenceRequest.prototype.clearTimeRange = function() {
  return this.setTimeRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ListEvidenceRequest.prototype.hasTimeRange = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string document_request_id = 4;
 * @return {string}
 */
proto.attachment.ListEvidenceRequest.prototype.getDocumentRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ListEvidenceRequest} returns this
 */
proto.attachment.ListEvidenceRequest.prototype.setDocumentRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue audit_id = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.ListEvidenceRequest.prototype.getAuditId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.ListEvidenceRequest} returns this
*/
proto.attachment.ListEvidenceRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ListEvidenceRequest} returns this
 */
proto.attachment.ListEvidenceRequest.prototype.clearAuditId = function() {
  return this.setAuditId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ListEvidenceRequest.prototype.hasAuditId = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.RequestFilter.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.RequestFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.RequestFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.RequestFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.RequestFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.RequestFilter}
 */
proto.attachment.RequestFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.RequestFilter;
  return proto.attachment.RequestFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.RequestFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.RequestFilter}
 */
proto.attachment.RequestFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addRequestIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.RequestFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.RequestFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.RequestFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.RequestFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string request_ids = 1;
 * @return {!Array<string>}
 */
proto.attachment.RequestFilter.prototype.getRequestIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.RequestFilter} returns this
 */
proto.attachment.RequestFilter.prototype.setRequestIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.RequestFilter} returns this
 */
proto.attachment.RequestFilter.prototype.addRequestIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.RequestFilter} returns this
 */
proto.attachment.RequestFilter.prototype.clearRequestIdsList = function() {
  return this.setRequestIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.ListEvidenceGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.ListEvidenceGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ListEvidenceGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    caption: (f = msg.getCaption()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    dateRangeFilter: (f = msg.getDateRangeFilter()) && common_time_pb.TimeRange.toObject(includeInstance, f),
    controlFilter: (f = msg.getControlFilter()) && proto.attachment.ControlFilter.toObject(includeInstance, f),
    actorFilter: (f = msg.getActorFilter()) && proto.attachment.ActorFilter.toObject(includeInstance, f),
    sort: (f = msg.getSort()) && proto.attachment.EvidenceSort.toObject(includeInstance, f),
    auditId: (f = msg.getAuditId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    evidenceTypeFilter: (f = msg.getEvidenceTypeFilter()) && proto.attachment.EvidenceTypeFilter.toObject(includeInstance, f),
    evidenceIdFilter: (f = msg.getEvidenceIdFilter()) && proto.attachment.EvidenceIdFilter.toObject(includeInstance, f),
    useNewModel: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    requestFilter: (f = msg.getRequestFilter()) && proto.attachment.RequestFilter.toObject(includeInstance, f),
    includeOutOfWindow: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.ListEvidenceGroupsRequest}
 */
proto.attachment.ListEvidenceGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.ListEvidenceGroupsRequest;
  return proto.attachment.ListEvidenceGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.ListEvidenceGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.ListEvidenceGroupsRequest}
 */
proto.attachment.ListEvidenceGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCaption(value);
      break;
    case 4:
      var value = new common_time_pb.TimeRange;
      reader.readMessage(value,common_time_pb.TimeRange.deserializeBinaryFromReader);
      msg.setDateRangeFilter(value);
      break;
    case 5:
      var value = new proto.attachment.ControlFilter;
      reader.readMessage(value,proto.attachment.ControlFilter.deserializeBinaryFromReader);
      msg.setControlFilter(value);
      break;
    case 6:
      var value = new proto.attachment.ActorFilter;
      reader.readMessage(value,proto.attachment.ActorFilter.deserializeBinaryFromReader);
      msg.setActorFilter(value);
      break;
    case 7:
      var value = new proto.attachment.EvidenceSort;
      reader.readMessage(value,proto.attachment.EvidenceSort.deserializeBinaryFromReader);
      msg.setSort(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAuditId(value);
      break;
    case 9:
      var value = new proto.attachment.EvidenceTypeFilter;
      reader.readMessage(value,proto.attachment.EvidenceTypeFilter.deserializeBinaryFromReader);
      msg.setEvidenceTypeFilter(value);
      break;
    case 10:
      var value = new proto.attachment.EvidenceIdFilter;
      reader.readMessage(value,proto.attachment.EvidenceIdFilter.deserializeBinaryFromReader);
      msg.setEvidenceIdFilter(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseNewModel(value);
      break;
    case 12:
      var value = new proto.attachment.RequestFilter;
      reader.readMessage(value,proto.attachment.RequestFilter.deserializeBinaryFromReader);
      msg.setRequestFilter(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeOutOfWindow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.ListEvidenceGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.ListEvidenceGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ListEvidenceGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaption();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDateRangeFilter();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_time_pb.TimeRange.serializeBinaryToWriter
    );
  }
  f = message.getControlFilter();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.attachment.ControlFilter.serializeBinaryToWriter
    );
  }
  f = message.getActorFilter();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.attachment.ActorFilter.serializeBinaryToWriter
    );
  }
  f = message.getSort();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.attachment.EvidenceSort.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEvidenceTypeFilter();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.attachment.EvidenceTypeFilter.serializeBinaryToWriter
    );
  }
  f = message.getEvidenceIdFilter();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.attachment.EvidenceIdFilter.serializeBinaryToWriter
    );
  }
  f = message.getUseNewModel();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getRequestFilter();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.attachment.RequestFilter.serializeBinaryToWriter
    );
  }
  f = message.getIncludeOutOfWindow();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional google.protobuf.StringValue caption = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.getCaption = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
*/
proto.attachment.ListEvidenceGroupsRequest.prototype.setCaption = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.clearCaption = function() {
  return this.setCaption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.hasCaption = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.TimeRange date_range_filter = 4;
 * @return {?proto.common.TimeRange}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.getDateRangeFilter = function() {
  return /** @type{?proto.common.TimeRange} */ (
    jspb.Message.getWrapperField(this, common_time_pb.TimeRange, 4));
};


/**
 * @param {?proto.common.TimeRange|undefined} value
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
*/
proto.attachment.ListEvidenceGroupsRequest.prototype.setDateRangeFilter = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.clearDateRangeFilter = function() {
  return this.setDateRangeFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.hasDateRangeFilter = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ControlFilter control_filter = 5;
 * @return {?proto.attachment.ControlFilter}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.getControlFilter = function() {
  return /** @type{?proto.attachment.ControlFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.ControlFilter, 5));
};


/**
 * @param {?proto.attachment.ControlFilter|undefined} value
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
*/
proto.attachment.ListEvidenceGroupsRequest.prototype.setControlFilter = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.clearControlFilter = function() {
  return this.setControlFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.hasControlFilter = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ActorFilter actor_filter = 6;
 * @return {?proto.attachment.ActorFilter}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.getActorFilter = function() {
  return /** @type{?proto.attachment.ActorFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.ActorFilter, 6));
};


/**
 * @param {?proto.attachment.ActorFilter|undefined} value
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
*/
proto.attachment.ListEvidenceGroupsRequest.prototype.setActorFilter = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.clearActorFilter = function() {
  return this.setActorFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.hasActorFilter = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional EvidenceSort sort = 7;
 * @return {?proto.attachment.EvidenceSort}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.getSort = function() {
  return /** @type{?proto.attachment.EvidenceSort} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceSort, 7));
};


/**
 * @param {?proto.attachment.EvidenceSort|undefined} value
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
*/
proto.attachment.ListEvidenceGroupsRequest.prototype.setSort = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.clearSort = function() {
  return this.setSort(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.hasSort = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue audit_id = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.getAuditId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
*/
proto.attachment.ListEvidenceGroupsRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.clearAuditId = function() {
  return this.setAuditId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.hasAuditId = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional EvidenceTypeFilter evidence_type_filter = 9;
 * @return {?proto.attachment.EvidenceTypeFilter}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.getEvidenceTypeFilter = function() {
  return /** @type{?proto.attachment.EvidenceTypeFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceTypeFilter, 9));
};


/**
 * @param {?proto.attachment.EvidenceTypeFilter|undefined} value
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
*/
proto.attachment.ListEvidenceGroupsRequest.prototype.setEvidenceTypeFilter = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.clearEvidenceTypeFilter = function() {
  return this.setEvidenceTypeFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.hasEvidenceTypeFilter = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional EvidenceIdFilter evidence_id_filter = 10;
 * @return {?proto.attachment.EvidenceIdFilter}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.getEvidenceIdFilter = function() {
  return /** @type{?proto.attachment.EvidenceIdFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceIdFilter, 10));
};


/**
 * @param {?proto.attachment.EvidenceIdFilter|undefined} value
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
*/
proto.attachment.ListEvidenceGroupsRequest.prototype.setEvidenceIdFilter = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.clearEvidenceIdFilter = function() {
  return this.setEvidenceIdFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.hasEvidenceIdFilter = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool use_new_model = 11;
 * @return {boolean}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.getUseNewModel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.setUseNewModel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional RequestFilter request_filter = 12;
 * @return {?proto.attachment.RequestFilter}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.getRequestFilter = function() {
  return /** @type{?proto.attachment.RequestFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.RequestFilter, 12));
};


/**
 * @param {?proto.attachment.RequestFilter|undefined} value
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
*/
proto.attachment.ListEvidenceGroupsRequest.prototype.setRequestFilter = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.clearRequestFilter = function() {
  return this.setRequestFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.hasRequestFilter = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool include_out_of_window = 13;
 * @return {boolean}
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.getIncludeOutOfWindow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.ListEvidenceGroupsRequest} returns this
 */
proto.attachment.ListEvidenceGroupsRequest.prototype.setIncludeOutOfWindow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.ListEvidenceResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.ListEvidenceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.ListEvidenceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.ListEvidenceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ListEvidenceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.attachment.Evidence.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.ListEvidenceResponse}
 */
proto.attachment.ListEvidenceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.ListEvidenceResponse;
  return proto.attachment.ListEvidenceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.ListEvidenceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.ListEvidenceResponse}
 */
proto.attachment.ListEvidenceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.Evidence;
      reader.readMessage(value,proto.attachment.Evidence.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.ListEvidenceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.ListEvidenceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.ListEvidenceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ListEvidenceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.Evidence.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Evidence items = 1;
 * @return {!Array<!proto.attachment.Evidence>}
 */
proto.attachment.ListEvidenceResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.attachment.Evidence>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.Evidence, 1));
};


/**
 * @param {!Array<!proto.attachment.Evidence>} value
 * @return {!proto.attachment.ListEvidenceResponse} returns this
*/
proto.attachment.ListEvidenceResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.Evidence=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.Evidence}
 */
proto.attachment.ListEvidenceResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.Evidence, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.ListEvidenceResponse} returns this
 */
proto.attachment.ListEvidenceResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.ListEvidenceGroupsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.ListEvidenceGroupsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.ListEvidenceGroupsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.ListEvidenceGroupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ListEvidenceGroupsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.attachment.EvidenceGroup.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.ListEvidenceGroupsResponse}
 */
proto.attachment.ListEvidenceGroupsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.ListEvidenceGroupsResponse;
  return proto.attachment.ListEvidenceGroupsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.ListEvidenceGroupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.ListEvidenceGroupsResponse}
 */
proto.attachment.ListEvidenceGroupsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceGroup;
      reader.readMessage(value,proto.attachment.EvidenceGroup.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.ListEvidenceGroupsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.ListEvidenceGroupsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.ListEvidenceGroupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ListEvidenceGroupsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.EvidenceGroup.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated EvidenceGroup items = 1;
 * @return {!Array<!proto.attachment.EvidenceGroup>}
 */
proto.attachment.ListEvidenceGroupsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.attachment.EvidenceGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.EvidenceGroup, 1));
};


/**
 * @param {!Array<!proto.attachment.EvidenceGroup>} value
 * @return {!proto.attachment.ListEvidenceGroupsResponse} returns this
*/
proto.attachment.ListEvidenceGroupsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.EvidenceGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceGroup}
 */
proto.attachment.ListEvidenceGroupsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.EvidenceGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.ListEvidenceGroupsResponse} returns this
 */
proto.attachment.ListEvidenceGroupsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.attachment.ListEvidenceGroupsResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.ListEvidenceGroupsResponse} returns this
 */
proto.attachment.ListEvidenceGroupsResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.GetLatestEvidenceResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetLatestEvidenceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetLatestEvidenceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetLatestEvidenceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetLatestEvidenceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.attachment.LatestEvidence.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetLatestEvidenceResponse}
 */
proto.attachment.GetLatestEvidenceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetLatestEvidenceResponse;
  return proto.attachment.GetLatestEvidenceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetLatestEvidenceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetLatestEvidenceResponse}
 */
proto.attachment.GetLatestEvidenceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.LatestEvidence;
      reader.readMessage(value,proto.attachment.LatestEvidence.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetLatestEvidenceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetLatestEvidenceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetLatestEvidenceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetLatestEvidenceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.LatestEvidence.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LatestEvidence items = 1;
 * @return {!Array<!proto.attachment.LatestEvidence>}
 */
proto.attachment.GetLatestEvidenceResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.attachment.LatestEvidence>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.LatestEvidence, 1));
};


/**
 * @param {!Array<!proto.attachment.LatestEvidence>} value
 * @return {!proto.attachment.GetLatestEvidenceResponse} returns this
*/
proto.attachment.GetLatestEvidenceResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.LatestEvidence=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.LatestEvidence}
 */
proto.attachment.GetLatestEvidenceResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.LatestEvidence, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetLatestEvidenceResponse} returns this
 */
proto.attachment.GetLatestEvidenceResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.GetLatestEvidenceGroupsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetLatestEvidenceGroupsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetLatestEvidenceGroupsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetLatestEvidenceGroupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetLatestEvidenceGroupsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.attachment.LatestEvidenceGroup.toObject, includeInstance),
    latestGroupIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    hasEvidence: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    outOfWindowCount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetLatestEvidenceGroupsResponse}
 */
proto.attachment.GetLatestEvidenceGroupsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetLatestEvidenceGroupsResponse;
  return proto.attachment.GetLatestEvidenceGroupsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetLatestEvidenceGroupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetLatestEvidenceGroupsResponse}
 */
proto.attachment.GetLatestEvidenceGroupsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.LatestEvidenceGroup;
      reader.readMessage(value,proto.attachment.LatestEvidenceGroup.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addLatestGroupIds(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasEvidence(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOutOfWindowCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetLatestEvidenceGroupsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetLatestEvidenceGroupsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetLatestEvidenceGroupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetLatestEvidenceGroupsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.LatestEvidenceGroup.serializeBinaryToWriter
    );
  }
  f = message.getLatestGroupIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getHasEvidence();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getOutOfWindowCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated LatestEvidenceGroup items = 1;
 * @return {!Array<!proto.attachment.LatestEvidenceGroup>}
 */
proto.attachment.GetLatestEvidenceGroupsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.attachment.LatestEvidenceGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.LatestEvidenceGroup, 1));
};


/**
 * @param {!Array<!proto.attachment.LatestEvidenceGroup>} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsResponse} returns this
*/
proto.attachment.GetLatestEvidenceGroupsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.LatestEvidenceGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.LatestEvidenceGroup}
 */
proto.attachment.GetLatestEvidenceGroupsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.LatestEvidenceGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetLatestEvidenceGroupsResponse} returns this
 */
proto.attachment.GetLatestEvidenceGroupsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * repeated string latest_group_ids = 2;
 * @return {!Array<string>}
 */
proto.attachment.GetLatestEvidenceGroupsResponse.prototype.getLatestGroupIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsResponse} returns this
 */
proto.attachment.GetLatestEvidenceGroupsResponse.prototype.setLatestGroupIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.GetLatestEvidenceGroupsResponse} returns this
 */
proto.attachment.GetLatestEvidenceGroupsResponse.prototype.addLatestGroupIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetLatestEvidenceGroupsResponse} returns this
 */
proto.attachment.GetLatestEvidenceGroupsResponse.prototype.clearLatestGroupIdsList = function() {
  return this.setLatestGroupIdsList([]);
};


/**
 * optional bool has_evidence = 3;
 * @return {boolean}
 */
proto.attachment.GetLatestEvidenceGroupsResponse.prototype.getHasEvidence = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsResponse} returns this
 */
proto.attachment.GetLatestEvidenceGroupsResponse.prototype.setHasEvidence = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional int32 out_of_window_count = 4;
 * @return {number}
 */
proto.attachment.GetLatestEvidenceGroupsResponse.prototype.getOutOfWindowCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.GetLatestEvidenceGroupsResponse} returns this
 */
proto.attachment.GetLatestEvidenceGroupsResponse.prototype.setOutOfWindowCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.ListConnectedEvidenceGeneratorsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.ListConnectedEvidenceGeneratorsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.ListConnectedEvidenceGeneratorsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ListConnectedEvidenceGeneratorsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    identifier: (f = msg.getIdentifier()) && common_model_pb.Identifier.toObject(includeInstance, f),
    connected: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.ListConnectedEvidenceGeneratorsRequest}
 */
proto.attachment.ListConnectedEvidenceGeneratorsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.ListConnectedEvidenceGeneratorsRequest;
  return proto.attachment.ListConnectedEvidenceGeneratorsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.ListConnectedEvidenceGeneratorsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.ListConnectedEvidenceGeneratorsRequest}
 */
proto.attachment.ListConnectedEvidenceGeneratorsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_model_pb.Identifier;
      reader.readMessage(value,common_model_pb.Identifier.deserializeBinaryFromReader);
      msg.setIdentifier(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConnected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.ListConnectedEvidenceGeneratorsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.ListConnectedEvidenceGeneratorsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.ListConnectedEvidenceGeneratorsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ListConnectedEvidenceGeneratorsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentifier();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_model_pb.Identifier.serializeBinaryToWriter
    );
  }
  f = message.getConnected();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional common.Identifier identifier = 1;
 * @return {?proto.common.Identifier}
 */
proto.attachment.ListConnectedEvidenceGeneratorsRequest.prototype.getIdentifier = function() {
  return /** @type{?proto.common.Identifier} */ (
    jspb.Message.getWrapperField(this, common_model_pb.Identifier, 1));
};


/**
 * @param {?proto.common.Identifier|undefined} value
 * @return {!proto.attachment.ListConnectedEvidenceGeneratorsRequest} returns this
*/
proto.attachment.ListConnectedEvidenceGeneratorsRequest.prototype.setIdentifier = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ListConnectedEvidenceGeneratorsRequest} returns this
 */
proto.attachment.ListConnectedEvidenceGeneratorsRequest.prototype.clearIdentifier = function() {
  return this.setIdentifier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ListConnectedEvidenceGeneratorsRequest.prototype.hasIdentifier = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool connected = 2;
 * @return {boolean}
 */
proto.attachment.ListConnectedEvidenceGeneratorsRequest.prototype.getConnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.ListConnectedEvidenceGeneratorsRequest} returns this
 */
proto.attachment.ListConnectedEvidenceGeneratorsRequest.prototype.setConnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.LatestEvidence.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.LatestEvidence.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.LatestEvidence} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.LatestEvidence.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidence: (f = msg.getEvidence()) && proto.attachment.Evidence.toObject(includeInstance, f),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.LatestEvidence}
 */
proto.attachment.LatestEvidence.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.LatestEvidence;
  return proto.attachment.LatestEvidence.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.LatestEvidence} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.LatestEvidence}
 */
proto.attachment.LatestEvidence.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.Evidence;
      reader.readMessage(value,proto.attachment.Evidence.deserializeBinaryFromReader);
      msg.setEvidence(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.LatestEvidence.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.LatestEvidence.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.LatestEvidence} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.LatestEvidence.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidence();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.Evidence.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional Evidence evidence = 1;
 * @return {?proto.attachment.Evidence}
 */
proto.attachment.LatestEvidence.prototype.getEvidence = function() {
  return /** @type{?proto.attachment.Evidence} */ (
    jspb.Message.getWrapperField(this, proto.attachment.Evidence, 1));
};


/**
 * @param {?proto.attachment.Evidence|undefined} value
 * @return {!proto.attachment.LatestEvidence} returns this
*/
proto.attachment.LatestEvidence.prototype.setEvidence = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.LatestEvidence} returns this
 */
proto.attachment.LatestEvidence.prototype.clearEvidence = function() {
  return this.setEvidence(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.LatestEvidence.prototype.hasEvidence = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.attachment.LatestEvidence.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.LatestEvidence} returns this
 */
proto.attachment.LatestEvidence.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.LatestEvidenceGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.LatestEvidenceGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.LatestEvidenceGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.LatestEvidenceGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceGroup: (f = msg.getEvidenceGroup()) && proto.attachment.EvidenceGroup.toObject(includeInstance, f),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0),
    hasControlCount: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    controlCount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.LatestEvidenceGroup}
 */
proto.attachment.LatestEvidenceGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.LatestEvidenceGroup;
  return proto.attachment.LatestEvidenceGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.LatestEvidenceGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.LatestEvidenceGroup}
 */
proto.attachment.LatestEvidenceGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceGroup;
      reader.readMessage(value,proto.attachment.EvidenceGroup.deserializeBinaryFromReader);
      msg.setEvidenceGroup(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasControlCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setControlCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.LatestEvidenceGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.LatestEvidenceGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.LatestEvidenceGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.LatestEvidenceGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceGroup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.EvidenceGroup.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getHasControlCount();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getControlCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional EvidenceGroup evidence_group = 1;
 * @return {?proto.attachment.EvidenceGroup}
 */
proto.attachment.LatestEvidenceGroup.prototype.getEvidenceGroup = function() {
  return /** @type{?proto.attachment.EvidenceGroup} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceGroup, 1));
};


/**
 * @param {?proto.attachment.EvidenceGroup|undefined} value
 * @return {!proto.attachment.LatestEvidenceGroup} returns this
*/
proto.attachment.LatestEvidenceGroup.prototype.setEvidenceGroup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.LatestEvidenceGroup} returns this
 */
proto.attachment.LatestEvidenceGroup.prototype.clearEvidenceGroup = function() {
  return this.setEvidenceGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.LatestEvidenceGroup.prototype.hasEvidenceGroup = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.attachment.LatestEvidenceGroup.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.LatestEvidenceGroup} returns this
 */
proto.attachment.LatestEvidenceGroup.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool has_control_count = 3;
 * @return {boolean}
 */
proto.attachment.LatestEvidenceGroup.prototype.getHasControlCount = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.LatestEvidenceGroup} returns this
 */
proto.attachment.LatestEvidenceGroup.prototype.setHasControlCount = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional int32 control_count = 4;
 * @return {number}
 */
proto.attachment.LatestEvidenceGroup.prototype.getControlCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.LatestEvidenceGroup} returns this
 */
proto.attachment.LatestEvidenceGroup.prototype.setControlCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.Evidence.repeatedFields_ = [14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.Evidence.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.Evidence.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.Evidence} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.Evidence.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    caption: jspb.Message.getFieldWithDefault(msg, 2, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    actorEmail: jspb.Message.getFieldWithDefault(msg, 4, ""),
    actorName: (f = msg.getActorName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    controlId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    isAutomated: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    mime: jspb.Message.getFieldWithDefault(msg, 8, ""),
    relevantDate: (f = msg.getRelevantDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    isViaRequest: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    contentId: jspb.Message.getFieldWithDefault(msg, 11, ""),
    discoveryId: jspb.Message.getFieldWithDefault(msg, 12, ""),
    serviceModelId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    labelIdsList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.Evidence}
 */
proto.attachment.Evidence.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.Evidence;
  return proto.attachment.Evidence.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.Evidence} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.Evidence}
 */
proto.attachment.Evidence.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setActorEmail(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setActorName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlId(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAutomated(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMime(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRelevantDate(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsViaRequest(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscoveryId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceModelId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addLabelIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.Evidence.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.Evidence.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.Evidence} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.Evidence.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getActorEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getActorName();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getControlId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIsAutomated();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getMime();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRelevantDate();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsViaRequest();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDiscoveryId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getServiceModelId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.attachment.Evidence.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string caption = 2;
 * @return {string}
 */
proto.attachment.Evidence.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.setCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.Evidence.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.Evidence} returns this
*/
proto.attachment.Evidence.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.Evidence.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string actor_email = 4;
 * @return {string}
 */
proto.attachment.Evidence.prototype.getActorEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.setActorEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue actor_name = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.Evidence.prototype.getActorName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.Evidence} returns this
*/
proto.attachment.Evidence.prototype.setActorName = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.clearActorName = function() {
  return this.setActorName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.Evidence.prototype.hasActorName = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string control_id = 6;
 * @return {string}
 */
proto.attachment.Evidence.prototype.getControlId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.setControlId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool is_automated = 7;
 * @return {boolean}
 */
proto.attachment.Evidence.prototype.getIsAutomated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.setIsAutomated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string mime = 8;
 * @return {string}
 */
proto.attachment.Evidence.prototype.getMime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.setMime = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp relevant_date = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.Evidence.prototype.getRelevantDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.Evidence} returns this
*/
proto.attachment.Evidence.prototype.setRelevantDate = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.clearRelevantDate = function() {
  return this.setRelevantDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.Evidence.prototype.hasRelevantDate = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool is_via_request = 10;
 * @return {boolean}
 */
proto.attachment.Evidence.prototype.getIsViaRequest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.setIsViaRequest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string content_id = 11;
 * @return {string}
 */
proto.attachment.Evidence.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string discovery_id = 12;
 * @return {string}
 */
proto.attachment.Evidence.prototype.getDiscoveryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.setDiscoveryId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string service_model_id = 13;
 * @return {string}
 */
proto.attachment.Evidence.prototype.getServiceModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.setServiceModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * repeated string label_ids = 14;
 * @return {!Array<string>}
 */
proto.attachment.Evidence.prototype.getLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.setLabelIdsList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.addLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.Evidence} returns this
 */
proto.attachment.Evidence.prototype.clearLabelIdsList = function() {
  return this.setLabelIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.ControlEvidenceGroup.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.ControlEvidenceGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.ControlEvidenceGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.ControlEvidenceGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ControlEvidenceGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    caption: jspb.Message.getFieldWithDefault(msg, 1, ""),
    evidenceCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    latestEvidence: (f = msg.getLatestEvidence()) && proto.attachment.ControlEvidence.toObject(includeInstance, f),
    oldEvidenceList: jspb.Message.toObjectList(msg.getOldEvidenceList(),
    proto.attachment.ControlEvidence.toObject, includeInstance),
    isLinkBroken: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.ControlEvidenceGroup}
 */
proto.attachment.ControlEvidenceGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.ControlEvidenceGroup;
  return proto.attachment.ControlEvidenceGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.ControlEvidenceGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.ControlEvidenceGroup}
 */
proto.attachment.ControlEvidenceGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEvidenceCount(value);
      break;
    case 3:
      var value = new proto.attachment.ControlEvidence;
      reader.readMessage(value,proto.attachment.ControlEvidence.deserializeBinaryFromReader);
      msg.setLatestEvidence(value);
      break;
    case 4:
      var value = new proto.attachment.ControlEvidence;
      reader.readMessage(value,proto.attachment.ControlEvidence.deserializeBinaryFromReader);
      msg.addOldEvidence(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLinkBroken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.ControlEvidenceGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.ControlEvidenceGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.ControlEvidenceGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ControlEvidenceGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEvidenceCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLatestEvidence();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.attachment.ControlEvidence.serializeBinaryToWriter
    );
  }
  f = message.getOldEvidenceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.attachment.ControlEvidence.serializeBinaryToWriter
    );
  }
  f = message.getIsLinkBroken();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string caption = 1;
 * @return {string}
 */
proto.attachment.ControlEvidenceGroup.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidenceGroup} returns this
 */
proto.attachment.ControlEvidenceGroup.prototype.setCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 evidence_count = 2;
 * @return {number}
 */
proto.attachment.ControlEvidenceGroup.prototype.getEvidenceCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.ControlEvidenceGroup} returns this
 */
proto.attachment.ControlEvidenceGroup.prototype.setEvidenceCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional ControlEvidence latest_evidence = 3;
 * @return {?proto.attachment.ControlEvidence}
 */
proto.attachment.ControlEvidenceGroup.prototype.getLatestEvidence = function() {
  return /** @type{?proto.attachment.ControlEvidence} */ (
    jspb.Message.getWrapperField(this, proto.attachment.ControlEvidence, 3));
};


/**
 * @param {?proto.attachment.ControlEvidence|undefined} value
 * @return {!proto.attachment.ControlEvidenceGroup} returns this
*/
proto.attachment.ControlEvidenceGroup.prototype.setLatestEvidence = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ControlEvidenceGroup} returns this
 */
proto.attachment.ControlEvidenceGroup.prototype.clearLatestEvidence = function() {
  return this.setLatestEvidence(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ControlEvidenceGroup.prototype.hasLatestEvidence = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated ControlEvidence old_evidence = 4;
 * @return {!Array<!proto.attachment.ControlEvidence>}
 */
proto.attachment.ControlEvidenceGroup.prototype.getOldEvidenceList = function() {
  return /** @type{!Array<!proto.attachment.ControlEvidence>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.ControlEvidence, 4));
};


/**
 * @param {!Array<!proto.attachment.ControlEvidence>} value
 * @return {!proto.attachment.ControlEvidenceGroup} returns this
*/
proto.attachment.ControlEvidenceGroup.prototype.setOldEvidenceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.attachment.ControlEvidence=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.ControlEvidence}
 */
proto.attachment.ControlEvidenceGroup.prototype.addOldEvidence = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.attachment.ControlEvidence, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.ControlEvidenceGroup} returns this
 */
proto.attachment.ControlEvidenceGroup.prototype.clearOldEvidenceList = function() {
  return this.setOldEvidenceList([]);
};


/**
 * optional bool is_link_broken = 5;
 * @return {boolean}
 */
proto.attachment.ControlEvidenceGroup.prototype.getIsLinkBroken = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.ControlEvidenceGroup} returns this
 */
proto.attachment.ControlEvidenceGroup.prototype.setIsLinkBroken = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.ControlEvidence.repeatedFields_ = [34];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.ControlEvidence.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.ControlEvidence.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.ControlEvidence} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ControlEvidence.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    relevantDate: (f = msg.getRelevantDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    controlId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    evidenceGroupId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    mime: jspb.Message.getFieldWithDefault(msg, 8, ""),
    actorEmail: jspb.Message.getFieldWithDefault(msg, 9, ""),
    isLatest: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    isAutomated: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    isViaRequest: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    serviceModelId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    contentId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    discoveryId: jspb.Message.getFieldWithDefault(msg, 15, ""),
    isNewModel: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
    evidenceId: jspb.Message.getFieldWithDefault(msg, 22, ""),
    evidenceInstanceId: jspb.Message.getFieldWithDefault(msg, 23, ""),
    isLinkedDocument: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    isLinkBroken: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
    receptorId: jspb.Message.getFieldWithDefault(msg, 26, ""),
    receptorModelId: jspb.Message.getFieldWithDefault(msg, 27, ""),
    docImportKey: jspb.Message.getFieldWithDefault(msg, 28, ""),
    docImportLink: jspb.Message.getFieldWithDefault(msg, 29, ""),
    docModifiedAt: (f = msg.getDocModifiedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    docScannedAt: (f = msg.getDocScannedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    isInstanceMissing: jspb.Message.getBooleanFieldWithDefault(msg, 32, false),
    evidenceLinkedControlsCount: jspb.Message.getFieldWithDefault(msg, 33, 0),
    labelIdsList: (f = jspb.Message.getRepeatedField(msg, 34)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.ControlEvidence}
 */
proto.attachment.ControlEvidence.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.ControlEvidence;
  return proto.attachment.ControlEvidence.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.ControlEvidence} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.ControlEvidence}
 */
proto.attachment.ControlEvidence.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRelevantDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceGroupId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMime(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setActorEmail(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLatest(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAutomated(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsViaRequest(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceModelId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscoveryId(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsNewModel(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceInstanceId(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLinkedDocument(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLinkBroken(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorModelId(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocImportKey(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocImportLink(value);
      break;
    case 30:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDocModifiedAt(value);
      break;
    case 31:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDocScannedAt(value);
      break;
    case 32:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsInstanceMissing(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEvidenceLinkedControlsCount(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.addLabelIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.ControlEvidence.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.ControlEvidence.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.ControlEvidence} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ControlEvidence.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRelevantDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getControlId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEvidenceGroupId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMime();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getActorEmail();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIsLatest();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getIsAutomated();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getIsViaRequest();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getServiceModelId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getDiscoveryId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getIsNewModel();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getEvidenceInstanceId();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getIsLinkedDocument();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getIsLinkBroken();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getReceptorModelId();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getDocImportKey();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getDocImportLink();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getDocModifiedAt();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDocScannedAt();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsInstanceMissing();
  if (f) {
    writer.writeBool(
      32,
      f
    );
  }
  f = message.getEvidenceLinkedControlsCount();
  if (f !== 0) {
    writer.writeInt32(
      33,
      f
    );
  }
  f = message.getLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      34,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.attachment.ControlEvidence.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.ControlEvidence.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.ControlEvidence} returns this
*/
proto.attachment.ControlEvidence.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ControlEvidence.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp relevant_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.ControlEvidence.prototype.getRelevantDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.ControlEvidence} returns this
*/
proto.attachment.ControlEvidence.prototype.setRelevantDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.clearRelevantDate = function() {
  return this.setRelevantDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ControlEvidence.prototype.hasRelevantDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string control_id = 4;
 * @return {string}
 */
proto.attachment.ControlEvidence.prototype.getControlId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setControlId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string evidence_group_id = 6;
 * @return {string}
 */
proto.attachment.ControlEvidence.prototype.getEvidenceGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setEvidenceGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string mime = 8;
 * @return {string}
 */
proto.attachment.ControlEvidence.prototype.getMime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setMime = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string actor_email = 9;
 * @return {string}
 */
proto.attachment.ControlEvidence.prototype.getActorEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setActorEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool is_latest = 10;
 * @return {boolean}
 */
proto.attachment.ControlEvidence.prototype.getIsLatest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setIsLatest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool is_automated = 11;
 * @return {boolean}
 */
proto.attachment.ControlEvidence.prototype.getIsAutomated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setIsAutomated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool is_via_request = 12;
 * @return {boolean}
 */
proto.attachment.ControlEvidence.prototype.getIsViaRequest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setIsViaRequest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string service_model_id = 13;
 * @return {string}
 */
proto.attachment.ControlEvidence.prototype.getServiceModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setServiceModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string content_id = 14;
 * @return {string}
 */
proto.attachment.ControlEvidence.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string discovery_id = 15;
 * @return {string}
 */
proto.attachment.ControlEvidence.prototype.getDiscoveryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setDiscoveryId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional bool is_new_model = 21;
 * @return {boolean}
 */
proto.attachment.ControlEvidence.prototype.getIsNewModel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setIsNewModel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional string evidence_id = 22;
 * @return {string}
 */
proto.attachment.ControlEvidence.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string evidence_instance_id = 23;
 * @return {string}
 */
proto.attachment.ControlEvidence.prototype.getEvidenceInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setEvidenceInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional bool is_linked_document = 24;
 * @return {boolean}
 */
proto.attachment.ControlEvidence.prototype.getIsLinkedDocument = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setIsLinkedDocument = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional bool is_link_broken = 25;
 * @return {boolean}
 */
proto.attachment.ControlEvidence.prototype.getIsLinkBroken = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setIsLinkBroken = function(value) {
  return jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional string receptor_id = 26;
 * @return {string}
 */
proto.attachment.ControlEvidence.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string receptor_model_id = 27;
 * @return {string}
 */
proto.attachment.ControlEvidence.prototype.getReceptorModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setReceptorModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string doc_import_key = 28;
 * @return {string}
 */
proto.attachment.ControlEvidence.prototype.getDocImportKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setDocImportKey = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string doc_import_link = 29;
 * @return {string}
 */
proto.attachment.ControlEvidence.prototype.getDocImportLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setDocImportLink = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional google.protobuf.Timestamp doc_modified_at = 30;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.ControlEvidence.prototype.getDocModifiedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 30));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.ControlEvidence} returns this
*/
proto.attachment.ControlEvidence.prototype.setDocModifiedAt = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.clearDocModifiedAt = function() {
  return this.setDocModifiedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ControlEvidence.prototype.hasDocModifiedAt = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional google.protobuf.Timestamp doc_scanned_at = 31;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.ControlEvidence.prototype.getDocScannedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 31));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.ControlEvidence} returns this
*/
proto.attachment.ControlEvidence.prototype.setDocScannedAt = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.clearDocScannedAt = function() {
  return this.setDocScannedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.ControlEvidence.prototype.hasDocScannedAt = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional bool is_instance_missing = 32;
 * @return {boolean}
 */
proto.attachment.ControlEvidence.prototype.getIsInstanceMissing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 32, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setIsInstanceMissing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 32, value);
};


/**
 * optional int32 evidence_linked_controls_count = 33;
 * @return {number}
 */
proto.attachment.ControlEvidence.prototype.getEvidenceLinkedControlsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setEvidenceLinkedControlsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * repeated string label_ids = 34;
 * @return {!Array<string>}
 */
proto.attachment.ControlEvidence.prototype.getLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 34));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.setLabelIdsList = function(value) {
  return jspb.Message.setField(this, 34, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.addLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 34, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.ControlEvidence} returns this
 */
proto.attachment.ControlEvidence.prototype.clearLabelIdsList = function() {
  return this.setLabelIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.EvidenceGroupId.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.EvidenceGroupId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.EvidenceGroupId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceGroupId.toObject = function(includeInstance, msg) {
  var f, obj = {
    caption: (f = msg.getCaption()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    contentId: (f = msg.getContentId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    discoveryId: (f = msg.getDiscoveryId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.EvidenceGroupId}
 */
proto.attachment.EvidenceGroupId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.EvidenceGroupId;
  return proto.attachment.EvidenceGroupId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.EvidenceGroupId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.EvidenceGroupId}
 */
proto.attachment.EvidenceGroupId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCaption(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDiscoveryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.EvidenceGroupId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.EvidenceGroupId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.EvidenceGroupId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceGroupId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaption();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDiscoveryId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue caption = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.EvidenceGroupId.prototype.getCaption = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.EvidenceGroupId} returns this
*/
proto.attachment.EvidenceGroupId.prototype.setCaption = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceGroupId} returns this
 */
proto.attachment.EvidenceGroupId.prototype.clearCaption = function() {
  return this.setCaption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceGroupId.prototype.hasCaption = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue content_id = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.EvidenceGroupId.prototype.getContentId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.EvidenceGroupId} returns this
*/
proto.attachment.EvidenceGroupId.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceGroupId} returns this
 */
proto.attachment.EvidenceGroupId.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceGroupId.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue discovery_id = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.EvidenceGroupId.prototype.getDiscoveryId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.EvidenceGroupId} returns this
*/
proto.attachment.EvidenceGroupId.prototype.setDiscoveryId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceGroupId} returns this
 */
proto.attachment.EvidenceGroupId.prototype.clearDiscoveryId = function() {
  return this.setDiscoveryId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceGroupId.prototype.hasDiscoveryId = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.EvidenceGroups.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.EvidenceGroups.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.EvidenceGroups.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.EvidenceGroups} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceGroups.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.attachment.EvidenceGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.EvidenceGroups}
 */
proto.attachment.EvidenceGroups.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.EvidenceGroups;
  return proto.attachment.EvidenceGroups.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.EvidenceGroups} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.EvidenceGroups}
 */
proto.attachment.EvidenceGroups.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceGroup;
      reader.readMessage(value,proto.attachment.EvidenceGroup.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.EvidenceGroups.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.EvidenceGroups.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.EvidenceGroups} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceGroups.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.EvidenceGroup.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EvidenceGroup items = 1;
 * @return {!Array<!proto.attachment.EvidenceGroup>}
 */
proto.attachment.EvidenceGroups.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.attachment.EvidenceGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.EvidenceGroup, 1));
};


/**
 * @param {!Array<!proto.attachment.EvidenceGroup>} value
 * @return {!proto.attachment.EvidenceGroups} returns this
*/
proto.attachment.EvidenceGroups.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.EvidenceGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceGroup}
 */
proto.attachment.EvidenceGroups.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.EvidenceGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.EvidenceGroups} returns this
 */
proto.attachment.EvidenceGroups.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.EvidenceGroup.repeatedFields_ = [38];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.EvidenceGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.EvidenceGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.EvidenceGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    caption: jspb.Message.getFieldWithDefault(msg, 2, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    actorEmail: jspb.Message.getFieldWithDefault(msg, 4, ""),
    actorName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    isAutomated: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    mime: jspb.Message.getFieldWithDefault(msg, 7, ""),
    relevantDate: (f = msg.getRelevantDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    contentId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    discoveryId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    description: jspb.Message.getFieldWithDefault(msg, 12, ""),
    allExclusions: (f = msg.getAllExclusions()) && proto.attachment.AllExclusions.toObject(includeInstance, f),
    accountId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    bodySize: jspb.Message.getFieldWithDefault(msg, 16, 0),
    actorId: jspb.Message.getFieldWithDefault(msg, 17, ""),
    fileName: jspb.Message.getFieldWithDefault(msg, 18, ""),
    serviceModelId: jspb.Message.getFieldWithDefault(msg, 19, ""),
    isNewModel: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
    evidenceId: jspb.Message.getFieldWithDefault(msg, 22, ""),
    evidenceInstanceId: jspb.Message.getFieldWithDefault(msg, 23, ""),
    isLinkedDocument: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    isLinkBroken: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
    receptorId: jspb.Message.getFieldWithDefault(msg, 26, ""),
    receptorModelId: jspb.Message.getFieldWithDefault(msg, 27, ""),
    docImportKey: jspb.Message.getFieldWithDefault(msg, 28, ""),
    docImportLink: jspb.Message.getFieldWithDefault(msg, 29, ""),
    docModifiedAt: (f = msg.getDocModifiedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    docScannedAt: (f = msg.getDocScannedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    isInstanceMissing: jspb.Message.getBooleanFieldWithDefault(msg, 32, false),
    linkedControlsCount: jspb.Message.getFieldWithDefault(msg, 33, 0),
    grcPlatform: (f = msg.getGrcPlatform()) && common_grc_platform_pb.GrcPlatform.toObject(includeInstance, f),
    readOnlyFields: (f = msg.getReadOnlyFields()) && proto.attachment.EvidenceReadOnlyFields.toObject(includeInstance, f),
    lastSourceScanId: jspb.Message.getFieldWithDefault(msg, 36, ""),
    windowStatus: jspb.Message.getFieldWithDefault(msg, 37, 0),
    labelIdsList: (f = jspb.Message.getRepeatedField(msg, 38)) == null ? undefined : f,
    sourceKind: jspb.Message.getFieldWithDefault(msg, 39, 0),
    sourceId: jspb.Message.getFieldWithDefault(msg, 40, ""),
    sourceName: jspb.Message.getFieldWithDefault(msg, 41, ""),
    sourceParentId: jspb.Message.getFieldWithDefault(msg, 42, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.EvidenceGroup}
 */
proto.attachment.EvidenceGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.EvidenceGroup;
  return proto.attachment.EvidenceGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.EvidenceGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.EvidenceGroup}
 */
proto.attachment.EvidenceGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setActorEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setActorName(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAutomated(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMime(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRelevantDate(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscoveryId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 13:
      var value = new proto.attachment.AllExclusions;
      reader.readMessage(value,proto.attachment.AllExclusions.deserializeBinaryFromReader);
      msg.setAllExclusions(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBodySize(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setActorId(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceModelId(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsNewModel(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceInstanceId(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLinkedDocument(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLinkBroken(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorModelId(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocImportKey(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocImportLink(value);
      break;
    case 30:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDocModifiedAt(value);
      break;
    case 31:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDocScannedAt(value);
      break;
    case 32:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsInstanceMissing(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLinkedControlsCount(value);
      break;
    case 34:
      var value = new common_grc_platform_pb.GrcPlatform;
      reader.readMessage(value,common_grc_platform_pb.GrcPlatform.deserializeBinaryFromReader);
      msg.setGrcPlatform(value);
      break;
    case 35:
      var value = new proto.attachment.EvidenceReadOnlyFields;
      reader.readMessage(value,proto.attachment.EvidenceReadOnlyFields.deserializeBinaryFromReader);
      msg.setReadOnlyFields(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastSourceScanId(value);
      break;
    case 37:
      var value = /** @type {!proto.attachment.EVIDENCE_WINDOW_STATUS} */ (reader.readEnum());
      msg.setWindowStatus(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.addLabelIds(value);
      break;
    case 39:
      var value = /** @type {!proto.attachment.EVIDENCE_SOURCE_KIND} */ (reader.readEnum());
      msg.setSourceKind(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceId(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceName(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceParentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.EvidenceGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.EvidenceGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.EvidenceGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getActorEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getActorName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsAutomated();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getMime();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRelevantDate();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDiscoveryId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAllExclusions();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.attachment.AllExclusions.serializeBinaryToWriter
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getBodySize();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getActorId();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getServiceModelId();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getIsNewModel();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getEvidenceInstanceId();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getIsLinkedDocument();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getIsLinkBroken();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getReceptorModelId();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getDocImportKey();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getDocImportLink();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getDocModifiedAt();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDocScannedAt();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsInstanceMissing();
  if (f) {
    writer.writeBool(
      32,
      f
    );
  }
  f = message.getLinkedControlsCount();
  if (f !== 0) {
    writer.writeInt32(
      33,
      f
    );
  }
  f = message.getGrcPlatform();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      common_grc_platform_pb.GrcPlatform.serializeBinaryToWriter
    );
  }
  f = message.getReadOnlyFields();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      proto.attachment.EvidenceReadOnlyFields.serializeBinaryToWriter
    );
  }
  f = message.getLastSourceScanId();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getWindowStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      37,
      f
    );
  }
  f = message.getLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      38,
      f
    );
  }
  f = message.getSourceKind();
  if (f !== 0.0) {
    writer.writeEnum(
      39,
      f
    );
  }
  f = message.getSourceId();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getSourceName();
  if (f.length > 0) {
    writer.writeString(
      41,
      f
    );
  }
  f = message.getSourceParentId();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string caption = 2;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.EvidenceGroup.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.EvidenceGroup} returns this
*/
proto.attachment.EvidenceGroup.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceGroup.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string actor_email = 4;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getActorEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setActorEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string actor_name = 5;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getActorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setActorName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_automated = 6;
 * @return {boolean}
 */
proto.attachment.EvidenceGroup.prototype.getIsAutomated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setIsAutomated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string mime = 7;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getMime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setMime = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp relevant_date = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.EvidenceGroup.prototype.getRelevantDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.EvidenceGroup} returns this
*/
proto.attachment.EvidenceGroup.prototype.setRelevantDate = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.clearRelevantDate = function() {
  return this.setRelevantDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceGroup.prototype.hasRelevantDate = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string content_id = 9;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string discovery_id = 10;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getDiscoveryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setDiscoveryId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string description = 12;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional AllExclusions all_exclusions = 13;
 * @return {?proto.attachment.AllExclusions}
 */
proto.attachment.EvidenceGroup.prototype.getAllExclusions = function() {
  return /** @type{?proto.attachment.AllExclusions} */ (
    jspb.Message.getWrapperField(this, proto.attachment.AllExclusions, 13));
};


/**
 * @param {?proto.attachment.AllExclusions|undefined} value
 * @return {!proto.attachment.EvidenceGroup} returns this
*/
proto.attachment.EvidenceGroup.prototype.setAllExclusions = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.clearAllExclusions = function() {
  return this.setAllExclusions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceGroup.prototype.hasAllExclusions = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string account_id = 14;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional int64 body_size = 16;
 * @return {number}
 */
proto.attachment.EvidenceGroup.prototype.getBodySize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setBodySize = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string actor_id = 17;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getActorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setActorId = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string file_name = 18;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string service_model_id = 19;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getServiceModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setServiceModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional bool is_new_model = 21;
 * @return {boolean}
 */
proto.attachment.EvidenceGroup.prototype.getIsNewModel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setIsNewModel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional string evidence_id = 22;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string evidence_instance_id = 23;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getEvidenceInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setEvidenceInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional bool is_linked_document = 24;
 * @return {boolean}
 */
proto.attachment.EvidenceGroup.prototype.getIsLinkedDocument = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setIsLinkedDocument = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional bool is_link_broken = 25;
 * @return {boolean}
 */
proto.attachment.EvidenceGroup.prototype.getIsLinkBroken = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setIsLinkBroken = function(value) {
  return jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional string receptor_id = 26;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string receptor_model_id = 27;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getReceptorModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setReceptorModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string doc_import_key = 28;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getDocImportKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setDocImportKey = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string doc_import_link = 29;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getDocImportLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setDocImportLink = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional google.protobuf.Timestamp doc_modified_at = 30;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.EvidenceGroup.prototype.getDocModifiedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 30));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.EvidenceGroup} returns this
*/
proto.attachment.EvidenceGroup.prototype.setDocModifiedAt = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.clearDocModifiedAt = function() {
  return this.setDocModifiedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceGroup.prototype.hasDocModifiedAt = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional google.protobuf.Timestamp doc_scanned_at = 31;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.EvidenceGroup.prototype.getDocScannedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 31));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.EvidenceGroup} returns this
*/
proto.attachment.EvidenceGroup.prototype.setDocScannedAt = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.clearDocScannedAt = function() {
  return this.setDocScannedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceGroup.prototype.hasDocScannedAt = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional bool is_instance_missing = 32;
 * @return {boolean}
 */
proto.attachment.EvidenceGroup.prototype.getIsInstanceMissing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 32, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setIsInstanceMissing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 32, value);
};


/**
 * optional int32 linked_controls_count = 33;
 * @return {number}
 */
proto.attachment.EvidenceGroup.prototype.getLinkedControlsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setLinkedControlsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * optional common.GrcPlatform grc_platform = 34;
 * @return {?proto.common.GrcPlatform}
 */
proto.attachment.EvidenceGroup.prototype.getGrcPlatform = function() {
  return /** @type{?proto.common.GrcPlatform} */ (
    jspb.Message.getWrapperField(this, common_grc_platform_pb.GrcPlatform, 34));
};


/**
 * @param {?proto.common.GrcPlatform|undefined} value
 * @return {!proto.attachment.EvidenceGroup} returns this
*/
proto.attachment.EvidenceGroup.prototype.setGrcPlatform = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.clearGrcPlatform = function() {
  return this.setGrcPlatform(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceGroup.prototype.hasGrcPlatform = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional EvidenceReadOnlyFields read_only_fields = 35;
 * @return {?proto.attachment.EvidenceReadOnlyFields}
 */
proto.attachment.EvidenceGroup.prototype.getReadOnlyFields = function() {
  return /** @type{?proto.attachment.EvidenceReadOnlyFields} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceReadOnlyFields, 35));
};


/**
 * @param {?proto.attachment.EvidenceReadOnlyFields|undefined} value
 * @return {!proto.attachment.EvidenceGroup} returns this
*/
proto.attachment.EvidenceGroup.prototype.setReadOnlyFields = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.clearReadOnlyFields = function() {
  return this.setReadOnlyFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceGroup.prototype.hasReadOnlyFields = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional string last_source_scan_id = 36;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getLastSourceScanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setLastSourceScanId = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional EVIDENCE_WINDOW_STATUS window_status = 37;
 * @return {!proto.attachment.EVIDENCE_WINDOW_STATUS}
 */
proto.attachment.EvidenceGroup.prototype.getWindowStatus = function() {
  return /** @type {!proto.attachment.EVIDENCE_WINDOW_STATUS} */ (jspb.Message.getFieldWithDefault(this, 37, 0));
};


/**
 * @param {!proto.attachment.EVIDENCE_WINDOW_STATUS} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setWindowStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 37, value);
};


/**
 * repeated string label_ids = 38;
 * @return {!Array<string>}
 */
proto.attachment.EvidenceGroup.prototype.getLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 38));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setLabelIdsList = function(value) {
  return jspb.Message.setField(this, 38, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.addLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 38, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.clearLabelIdsList = function() {
  return this.setLabelIdsList([]);
};


/**
 * optional EVIDENCE_SOURCE_KIND source_kind = 39;
 * @return {!proto.attachment.EVIDENCE_SOURCE_KIND}
 */
proto.attachment.EvidenceGroup.prototype.getSourceKind = function() {
  return /** @type {!proto.attachment.EVIDENCE_SOURCE_KIND} */ (jspb.Message.getFieldWithDefault(this, 39, 0));
};


/**
 * @param {!proto.attachment.EVIDENCE_SOURCE_KIND} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setSourceKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 39, value);
};


/**
 * optional string source_id = 40;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getSourceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setSourceId = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional string source_name = 41;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getSourceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setSourceName = function(value) {
  return jspb.Message.setProto3StringField(this, 41, value);
};


/**
 * optional string source_parent_id = 42;
 * @return {string}
 */
proto.attachment.EvidenceGroup.prototype.getSourceParentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGroup} returns this
 */
proto.attachment.EvidenceGroup.prototype.setSourceParentId = function(value) {
  return jspb.Message.setProto3StringField(this, 42, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.EvidenceGenerators.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.EvidenceGenerators.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.EvidenceGenerators.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.EvidenceGenerators} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceGenerators.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.attachment.EvidenceGenerator.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.EvidenceGenerators}
 */
proto.attachment.EvidenceGenerators.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.EvidenceGenerators;
  return proto.attachment.EvidenceGenerators.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.EvidenceGenerators} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.EvidenceGenerators}
 */
proto.attachment.EvidenceGenerators.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceGenerator;
      reader.readMessage(value,proto.attachment.EvidenceGenerator.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.EvidenceGenerators.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.EvidenceGenerators.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.EvidenceGenerators} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceGenerators.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.EvidenceGenerator.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EvidenceGenerator items = 1;
 * @return {!Array<!proto.attachment.EvidenceGenerator>}
 */
proto.attachment.EvidenceGenerators.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.attachment.EvidenceGenerator>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.EvidenceGenerator, 1));
};


/**
 * @param {!Array<!proto.attachment.EvidenceGenerator>} value
 * @return {!proto.attachment.EvidenceGenerators} returns this
*/
proto.attachment.EvidenceGenerators.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.EvidenceGenerator=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceGenerator}
 */
proto.attachment.EvidenceGenerators.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.EvidenceGenerator, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.EvidenceGenerators} returns this
 */
proto.attachment.EvidenceGenerators.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.EvidenceGenerator.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.EvidenceGenerator.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.EvidenceGenerator} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceGenerator.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    evidenceId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    receptorModelId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.EvidenceGenerator}
 */
proto.attachment.EvidenceGenerator.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.EvidenceGenerator;
  return proto.attachment.EvidenceGenerator.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.EvidenceGenerator} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.EvidenceGenerator}
 */
proto.attachment.EvidenceGenerator.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorModelId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.EvidenceGenerator.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.EvidenceGenerator.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.EvidenceGenerator} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceGenerator.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReceptorModelId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.attachment.EvidenceGenerator.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGenerator} returns this
 */
proto.attachment.EvidenceGenerator.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string evidence_id = 3;
 * @return {string}
 */
proto.attachment.EvidenceGenerator.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGenerator} returns this
 */
proto.attachment.EvidenceGenerator.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string receptor_model_id = 4;
 * @return {string}
 */
proto.attachment.EvidenceGenerator.prototype.getReceptorModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceGenerator} returns this
 */
proto.attachment.EvidenceGenerator.prototype.setReceptorModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.DeleteDocumentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.DeleteDocumentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.DeleteDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.DeleteDocumentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    documentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    deleteAssociatedTests: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    requestId: (f = msg.getRequestId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.DeleteDocumentRequest}
 */
proto.attachment.DeleteDocumentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.DeleteDocumentRequest;
  return proto.attachment.DeleteDocumentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.DeleteDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.DeleteDocumentRequest}
 */
proto.attachment.DeleteDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleteAssociatedTests(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.DeleteDocumentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.DeleteDocumentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.DeleteDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.DeleteDocumentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDeleteAssociatedTests();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getRequestId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string document_id = 1;
 * @return {string}
 */
proto.attachment.DeleteDocumentRequest.prototype.getDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.DeleteDocumentRequest} returns this
 */
proto.attachment.DeleteDocumentRequest.prototype.setDocumentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool delete_associated_tests = 2;
 * @return {boolean}
 */
proto.attachment.DeleteDocumentRequest.prototype.getDeleteAssociatedTests = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.DeleteDocumentRequest} returns this
 */
proto.attachment.DeleteDocumentRequest.prototype.setDeleteAssociatedTests = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue request_id = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.DeleteDocumentRequest.prototype.getRequestId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.DeleteDocumentRequest} returns this
*/
proto.attachment.DeleteDocumentRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.DeleteDocumentRequest} returns this
 */
proto.attachment.DeleteDocumentRequest.prototype.clearRequestId = function() {
  return this.setRequestId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.DeleteDocumentRequest.prototype.hasRequestId = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetRiskRegisterCSVResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetRiskRegisterCSVResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetRiskRegisterCSVResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetRiskRegisterCSVResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    csv: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetRiskRegisterCSVResponse}
 */
proto.attachment.GetRiskRegisterCSVResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetRiskRegisterCSVResponse;
  return proto.attachment.GetRiskRegisterCSVResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetRiskRegisterCSVResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetRiskRegisterCSVResponse}
 */
proto.attachment.GetRiskRegisterCSVResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCsv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetRiskRegisterCSVResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetRiskRegisterCSVResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetRiskRegisterCSVResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetRiskRegisterCSVResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCsv();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string csv = 1;
 * @return {string}
 */
proto.attachment.GetRiskRegisterCSVResponse.prototype.getCsv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetRiskRegisterCSVResponse} returns this
 */
proto.attachment.GetRiskRegisterCSVResponse.prototype.setCsv = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.ExportRiskRegisterCSVRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.ExportRiskRegisterCSVRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.ExportRiskRegisterCSVRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.ExportRiskRegisterCSVRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ExportRiskRegisterCSVRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.ExportRiskRegisterCSVRequest}
 */
proto.attachment.ExportRiskRegisterCSVRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.ExportRiskRegisterCSVRequest;
  return proto.attachment.ExportRiskRegisterCSVRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.ExportRiskRegisterCSVRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.ExportRiskRegisterCSVRequest}
 */
proto.attachment.ExportRiskRegisterCSVRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addRiskIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.ExportRiskRegisterCSVRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.ExportRiskRegisterCSVRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.ExportRiskRegisterCSVRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.ExportRiskRegisterCSVRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string risk_ids = 1;
 * @return {!Array<string>}
 */
proto.attachment.ExportRiskRegisterCSVRequest.prototype.getRiskIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.ExportRiskRegisterCSVRequest} returns this
 */
proto.attachment.ExportRiskRegisterCSVRequest.prototype.setRiskIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.ExportRiskRegisterCSVRequest} returns this
 */
proto.attachment.ExportRiskRegisterCSVRequest.prototype.addRiskIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.ExportRiskRegisterCSVRequest} returns this
 */
proto.attachment.ExportRiskRegisterCSVRequest.prototype.clearRiskIdsList = function() {
  return this.setRiskIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetExclusionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetExclusionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetExclusionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetExclusionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceid: (f = msg.getEvidenceid()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetExclusionsRequest}
 */
proto.attachment.GetExclusionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetExclusionsRequest;
  return proto.attachment.GetExclusionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetExclusionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetExclusionsRequest}
 */
proto.attachment.GetExclusionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEvidenceid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetExclusionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetExclusionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetExclusionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetExclusionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceid();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue evidenceId = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.GetExclusionsRequest.prototype.getEvidenceid = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.GetExclusionsRequest} returns this
*/
proto.attachment.GetExclusionsRequest.prototype.setEvidenceid = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetExclusionsRequest} returns this
 */
proto.attachment.GetExclusionsRequest.prototype.clearEvidenceid = function() {
  return this.setEvidenceid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetExclusionsRequest.prototype.hasEvidenceid = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetExclusionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetExclusionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetExclusionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetExclusionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    exclusions: (f = msg.getExclusions()) && proto.attachment.AllExclusions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetExclusionsResponse}
 */
proto.attachment.GetExclusionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetExclusionsResponse;
  return proto.attachment.GetExclusionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetExclusionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetExclusionsResponse}
 */
proto.attachment.GetExclusionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.AllExclusions;
      reader.readMessage(value,proto.attachment.AllExclusions.deserializeBinaryFromReader);
      msg.setExclusions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetExclusionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetExclusionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetExclusionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetExclusionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExclusions();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.AllExclusions.serializeBinaryToWriter
    );
  }
};


/**
 * optional AllExclusions exclusions = 1;
 * @return {?proto.attachment.AllExclusions}
 */
proto.attachment.GetExclusionsResponse.prototype.getExclusions = function() {
  return /** @type{?proto.attachment.AllExclusions} */ (
    jspb.Message.getWrapperField(this, proto.attachment.AllExclusions, 1));
};


/**
 * @param {?proto.attachment.AllExclusions|undefined} value
 * @return {!proto.attachment.GetExclusionsResponse} returns this
*/
proto.attachment.GetExclusionsResponse.prototype.setExclusions = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetExclusionsResponse} returns this
 */
proto.attachment.GetExclusionsResponse.prototype.clearExclusions = function() {
  return this.setExclusions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetExclusionsResponse.prototype.hasExclusions = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.DeleteControlEvidencesByCaptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.DeleteControlEvidencesByCaptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.DeleteControlEvidencesByCaptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.DeleteControlEvidencesByCaptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    caption: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.DeleteControlEvidencesByCaptionRequest}
 */
proto.attachment.DeleteControlEvidencesByCaptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.DeleteControlEvidencesByCaptionRequest;
  return proto.attachment.DeleteControlEvidencesByCaptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.DeleteControlEvidencesByCaptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.DeleteControlEvidencesByCaptionRequest}
 */
proto.attachment.DeleteControlEvidencesByCaptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.DeleteControlEvidencesByCaptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.DeleteControlEvidencesByCaptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.DeleteControlEvidencesByCaptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.DeleteControlEvidencesByCaptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string control_id = 1;
 * @return {string}
 */
proto.attachment.DeleteControlEvidencesByCaptionRequest.prototype.getControlId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.DeleteControlEvidencesByCaptionRequest} returns this
 */
proto.attachment.DeleteControlEvidencesByCaptionRequest.prototype.setControlId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string caption = 2;
 * @return {string}
 */
proto.attachment.DeleteControlEvidencesByCaptionRequest.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.DeleteControlEvidencesByCaptionRequest} returns this
 */
proto.attachment.DeleteControlEvidencesByCaptionRequest.prototype.setCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.URL.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.URL.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.URL} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.URL.toObject = function(includeInstance, msg) {
  var f, obj = {
    url: jspb.Message.getFieldWithDefault(msg, 1, ""),
    headersMap: (f = msg.getHeadersMap()) ? f.toObject(includeInstance, proto.attachment.HeaderValue.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.URL}
 */
proto.attachment.URL.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.URL;
  return proto.attachment.URL.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.URL} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.URL}
 */
proto.attachment.URL.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 2:
      var value = msg.getHeadersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.attachment.HeaderValue.deserializeBinaryFromReader, "", new proto.attachment.HeaderValue());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.URL.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.URL.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.URL} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.URL.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHeadersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.attachment.HeaderValue.serializeBinaryToWriter);
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.attachment.URL.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.URL} returns this
 */
proto.attachment.URL.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * map<string, HeaderValue> headers = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.attachment.HeaderValue>}
 */
proto.attachment.URL.prototype.getHeadersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.attachment.HeaderValue>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.attachment.HeaderValue));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.attachment.URL} returns this
 */
proto.attachment.URL.prototype.clearHeadersMap = function() {
  this.getHeadersMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.HeaderValue.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.HeaderValue.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.HeaderValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.HeaderValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.HeaderValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.HeaderValue}
 */
proto.attachment.HeaderValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.HeaderValue;
  return proto.attachment.HeaderValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.HeaderValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.HeaderValue}
 */
proto.attachment.HeaderValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.HeaderValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.HeaderValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.HeaderValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.HeaderValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.attachment.HeaderValue.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.HeaderValue} returns this
 */
proto.attachment.HeaderValue.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.HeaderValue} returns this
 */
proto.attachment.HeaderValue.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.HeaderValue} returns this
 */
proto.attachment.HeaderValue.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.AddOrUpdateEvidenceGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.AddOrUpdateEvidenceGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceGroup: (f = msg.getEvidenceGroup()) && proto.attachment.EvidenceGroup.toObject(includeInstance, f),
    body: msg.getBody_asB64(),
    newCaption: (f = msg.getNewCaption()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    newRelevantDate: (f = msg.getNewRelevantDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    linkagesList: jspb.Message.toObjectList(msg.getLinkagesList(),
    proto.attachment.EvidenceLinkage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.AddOrUpdateEvidenceGroupRequest}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.AddOrUpdateEvidenceGroupRequest;
  return proto.attachment.AddOrUpdateEvidenceGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.AddOrUpdateEvidenceGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.AddOrUpdateEvidenceGroupRequest}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceGroup;
      reader.readMessage(value,proto.attachment.EvidenceGroup.deserializeBinaryFromReader);
      msg.setEvidenceGroup(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBody(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setNewCaption(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNewRelevantDate(value);
      break;
    case 5:
      var value = new proto.attachment.EvidenceLinkage;
      reader.readMessage(value,proto.attachment.EvidenceLinkage.deserializeBinaryFromReader);
      msg.addLinkages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.AddOrUpdateEvidenceGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.AddOrUpdateEvidenceGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceGroup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.EvidenceGroup.serializeBinaryToWriter
    );
  }
  f = message.getBody_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getNewCaption();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getNewRelevantDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLinkagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.attachment.EvidenceLinkage.serializeBinaryToWriter
    );
  }
};


/**
 * optional EvidenceGroup evidence_group = 1;
 * @return {?proto.attachment.EvidenceGroup}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.getEvidenceGroup = function() {
  return /** @type{?proto.attachment.EvidenceGroup} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceGroup, 1));
};


/**
 * @param {?proto.attachment.EvidenceGroup|undefined} value
 * @return {!proto.attachment.AddOrUpdateEvidenceGroupRequest} returns this
*/
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.setEvidenceGroup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.AddOrUpdateEvidenceGroupRequest} returns this
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.clearEvidenceGroup = function() {
  return this.setEvidenceGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.hasEvidenceGroup = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes body = 2;
 * @return {!(string|Uint8Array)}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.getBody = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes body = 2;
 * This is a type-conversion wrapper around `getBody()`
 * @return {string}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.getBody_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBody()));
};


/**
 * optional bytes body = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBody()`
 * @return {!Uint8Array}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.getBody_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBody()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.attachment.AddOrUpdateEvidenceGroupRequest} returns this
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.setBody = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue new_caption = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.getNewCaption = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.AddOrUpdateEvidenceGroupRequest} returns this
*/
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.setNewCaption = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.AddOrUpdateEvidenceGroupRequest} returns this
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.clearNewCaption = function() {
  return this.setNewCaption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.hasNewCaption = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp new_relevant_date = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.getNewRelevantDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.AddOrUpdateEvidenceGroupRequest} returns this
*/
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.setNewRelevantDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.AddOrUpdateEvidenceGroupRequest} returns this
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.clearNewRelevantDate = function() {
  return this.setNewRelevantDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.hasNewRelevantDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated EvidenceLinkage linkages = 5;
 * @return {!Array<!proto.attachment.EvidenceLinkage>}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.getLinkagesList = function() {
  return /** @type{!Array<!proto.attachment.EvidenceLinkage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.EvidenceLinkage, 5));
};


/**
 * @param {!Array<!proto.attachment.EvidenceLinkage>} value
 * @return {!proto.attachment.AddOrUpdateEvidenceGroupRequest} returns this
*/
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.setLinkagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.attachment.EvidenceLinkage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceLinkage}
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.addLinkages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.attachment.EvidenceLinkage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.AddOrUpdateEvidenceGroupRequest} returns this
 */
proto.attachment.AddOrUpdateEvidenceGroupRequest.prototype.clearLinkagesList = function() {
  return this.setLinkagesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.attachment.AddOrUpdateEvidenceGroupRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest}
 */
proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest;
  return proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest}
 */
proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.AddOrUpdateEvidenceGroupRequest;
      reader.readMessage(value,proto.attachment.AddOrUpdateEvidenceGroupRequest.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.AddOrUpdateEvidenceGroupRequest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AddOrUpdateEvidenceGroupRequest items = 1;
 * @return {!Array<!proto.attachment.AddOrUpdateEvidenceGroupRequest>}
 */
proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.attachment.AddOrUpdateEvidenceGroupRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.AddOrUpdateEvidenceGroupRequest, 1));
};


/**
 * @param {!Array<!proto.attachment.AddOrUpdateEvidenceGroupRequest>} value
 * @return {!proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest} returns this
*/
proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.AddOrUpdateEvidenceGroupRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.AddOrUpdateEvidenceGroupRequest}
 */
proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.AddOrUpdateEvidenceGroupRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest} returns this
 */
proto.attachment.BulkAddOrUpdateEvidenceGroupsRequest.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.DeleteEvidenceGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.DeleteEvidenceGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.DeleteEvidenceGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.DeleteEvidenceGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && proto.attachment.EvidenceGroupId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.DeleteEvidenceGroupRequest}
 */
proto.attachment.DeleteEvidenceGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.DeleteEvidenceGroupRequest;
  return proto.attachment.DeleteEvidenceGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.DeleteEvidenceGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.DeleteEvidenceGroupRequest}
 */
proto.attachment.DeleteEvidenceGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceGroupId;
      reader.readMessage(value,proto.attachment.EvidenceGroupId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.DeleteEvidenceGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.DeleteEvidenceGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.DeleteEvidenceGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.DeleteEvidenceGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.EvidenceGroupId.serializeBinaryToWriter
    );
  }
};


/**
 * optional EvidenceGroupId id = 1;
 * @return {?proto.attachment.EvidenceGroupId}
 */
proto.attachment.DeleteEvidenceGroupRequest.prototype.getId = function() {
  return /** @type{?proto.attachment.EvidenceGroupId} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceGroupId, 1));
};


/**
 * @param {?proto.attachment.EvidenceGroupId|undefined} value
 * @return {!proto.attachment.DeleteEvidenceGroupRequest} returns this
*/
proto.attachment.DeleteEvidenceGroupRequest.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.DeleteEvidenceGroupRequest} returns this
 */
proto.attachment.DeleteEvidenceGroupRequest.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.DeleteEvidenceGroupRequest.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.EvidenceLinkage.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.EvidenceLinkage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.EvidenceLinkage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceLinkage.toObject = function(includeInstance, msg) {
  var f, obj = {
    linkageType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    linkageId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    linkageModelId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.EvidenceLinkage}
 */
proto.attachment.EvidenceLinkage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.EvidenceLinkage;
  return proto.attachment.EvidenceLinkage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.EvidenceLinkage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.EvidenceLinkage}
 */
proto.attachment.EvidenceLinkage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.attachment.EVIDENCE_LINKAGE_TYPE} */ (reader.readEnum());
      msg.setLinkageType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkageId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkageModelId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.EvidenceLinkage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.EvidenceLinkage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.EvidenceLinkage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceLinkage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLinkageType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getLinkageId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLinkageModelId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional EVIDENCE_LINKAGE_TYPE linkage_type = 1;
 * @return {!proto.attachment.EVIDENCE_LINKAGE_TYPE}
 */
proto.attachment.EvidenceLinkage.prototype.getLinkageType = function() {
  return /** @type {!proto.attachment.EVIDENCE_LINKAGE_TYPE} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.attachment.EVIDENCE_LINKAGE_TYPE} value
 * @return {!proto.attachment.EvidenceLinkage} returns this
 */
proto.attachment.EvidenceLinkage.prototype.setLinkageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string linkage_id = 2;
 * @return {string}
 */
proto.attachment.EvidenceLinkage.prototype.getLinkageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceLinkage} returns this
 */
proto.attachment.EvidenceLinkage.prototype.setLinkageId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string linkage_model_id = 3;
 * @return {string}
 */
proto.attachment.EvidenceLinkage.prototype.getLinkageModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceLinkage} returns this
 */
proto.attachment.EvidenceLinkage.prototype.setLinkageModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.LinkControlsToEvidenceRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.LinkControlsToEvidenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.LinkControlsToEvidenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.LinkControlsToEvidenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.LinkControlsToEvidenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    controlIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.LinkControlsToEvidenceRequest}
 */
proto.attachment.LinkControlsToEvidenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.LinkControlsToEvidenceRequest;
  return proto.attachment.LinkControlsToEvidenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.LinkControlsToEvidenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.LinkControlsToEvidenceRequest}
 */
proto.attachment.LinkControlsToEvidenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addControlIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.LinkControlsToEvidenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.LinkControlsToEvidenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.LinkControlsToEvidenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.LinkControlsToEvidenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getControlIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string evidence_id = 1;
 * @return {string}
 */
proto.attachment.LinkControlsToEvidenceRequest.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.LinkControlsToEvidenceRequest} returns this
 */
proto.attachment.LinkControlsToEvidenceRequest.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string control_ids = 2;
 * @return {!Array<string>}
 */
proto.attachment.LinkControlsToEvidenceRequest.prototype.getControlIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.LinkControlsToEvidenceRequest} returns this
 */
proto.attachment.LinkControlsToEvidenceRequest.prototype.setControlIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.LinkControlsToEvidenceRequest} returns this
 */
proto.attachment.LinkControlsToEvidenceRequest.prototype.addControlIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.LinkControlsToEvidenceRequest} returns this
 */
proto.attachment.LinkControlsToEvidenceRequest.prototype.clearControlIdsList = function() {
  return this.setControlIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.LinkRequestsToEvidenceRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.LinkRequestsToEvidenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.LinkRequestsToEvidenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.LinkRequestsToEvidenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.LinkRequestsToEvidenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requestIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.LinkRequestsToEvidenceRequest}
 */
proto.attachment.LinkRequestsToEvidenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.LinkRequestsToEvidenceRequest;
  return proto.attachment.LinkRequestsToEvidenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.LinkRequestsToEvidenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.LinkRequestsToEvidenceRequest}
 */
proto.attachment.LinkRequestsToEvidenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addRequestIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.LinkRequestsToEvidenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.LinkRequestsToEvidenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.LinkRequestsToEvidenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.LinkRequestsToEvidenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequestIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string evidence_id = 1;
 * @return {string}
 */
proto.attachment.LinkRequestsToEvidenceRequest.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.LinkRequestsToEvidenceRequest} returns this
 */
proto.attachment.LinkRequestsToEvidenceRequest.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string request_ids = 2;
 * @return {!Array<string>}
 */
proto.attachment.LinkRequestsToEvidenceRequest.prototype.getRequestIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.LinkRequestsToEvidenceRequest} returns this
 */
proto.attachment.LinkRequestsToEvidenceRequest.prototype.setRequestIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.LinkRequestsToEvidenceRequest} returns this
 */
proto.attachment.LinkRequestsToEvidenceRequest.prototype.addRequestIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.LinkRequestsToEvidenceRequest} returns this
 */
proto.attachment.LinkRequestsToEvidenceRequest.prototype.clearRequestIdsList = function() {
  return this.setRequestIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.UnlinkEvidenceFromRequestRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.UnlinkEvidenceFromRequestRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.UnlinkEvidenceFromRequestRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.UnlinkEvidenceFromRequestRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requestId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.UnlinkEvidenceFromRequestRequest}
 */
proto.attachment.UnlinkEvidenceFromRequestRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.UnlinkEvidenceFromRequestRequest;
  return proto.attachment.UnlinkEvidenceFromRequestRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.UnlinkEvidenceFromRequestRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.UnlinkEvidenceFromRequestRequest}
 */
proto.attachment.UnlinkEvidenceFromRequestRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.UnlinkEvidenceFromRequestRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.UnlinkEvidenceFromRequestRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.UnlinkEvidenceFromRequestRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.UnlinkEvidenceFromRequestRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string evidence_id = 1;
 * @return {string}
 */
proto.attachment.UnlinkEvidenceFromRequestRequest.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.UnlinkEvidenceFromRequestRequest} returns this
 */
proto.attachment.UnlinkEvidenceFromRequestRequest.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string request_id = 2;
 * @return {string}
 */
proto.attachment.UnlinkEvidenceFromRequestRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.UnlinkEvidenceFromRequestRequest} returns this
 */
proto.attachment.UnlinkEvidenceFromRequestRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.LinkEvidenceToControlRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.LinkEvidenceToControlRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.LinkEvidenceToControlRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.LinkEvidenceToControlRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.LinkEvidenceToControlRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    evidenceIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.LinkEvidenceToControlRequest}
 */
proto.attachment.LinkEvidenceToControlRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.LinkEvidenceToControlRequest;
  return proto.attachment.LinkEvidenceToControlRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.LinkEvidenceToControlRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.LinkEvidenceToControlRequest}
 */
proto.attachment.LinkEvidenceToControlRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addEvidenceIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.LinkEvidenceToControlRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.LinkEvidenceToControlRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.LinkEvidenceToControlRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.LinkEvidenceToControlRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEvidenceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string control_id = 1;
 * @return {string}
 */
proto.attachment.LinkEvidenceToControlRequest.prototype.getControlId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.LinkEvidenceToControlRequest} returns this
 */
proto.attachment.LinkEvidenceToControlRequest.prototype.setControlId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string evidence_ids = 2;
 * @return {!Array<string>}
 */
proto.attachment.LinkEvidenceToControlRequest.prototype.getEvidenceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.LinkEvidenceToControlRequest} returns this
 */
proto.attachment.LinkEvidenceToControlRequest.prototype.setEvidenceIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.LinkEvidenceToControlRequest} returns this
 */
proto.attachment.LinkEvidenceToControlRequest.prototype.addEvidenceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.LinkEvidenceToControlRequest} returns this
 */
proto.attachment.LinkEvidenceToControlRequest.prototype.clearEvidenceIdsList = function() {
  return this.setEvidenceIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.UnlinkEvidenceFromControlRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.UnlinkEvidenceFromControlRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.UnlinkEvidenceFromControlRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.UnlinkEvidenceFromControlRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.UnlinkEvidenceFromControlRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    evidenceIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.UnlinkEvidenceFromControlRequest}
 */
proto.attachment.UnlinkEvidenceFromControlRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.UnlinkEvidenceFromControlRequest;
  return proto.attachment.UnlinkEvidenceFromControlRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.UnlinkEvidenceFromControlRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.UnlinkEvidenceFromControlRequest}
 */
proto.attachment.UnlinkEvidenceFromControlRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addEvidenceIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.UnlinkEvidenceFromControlRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.UnlinkEvidenceFromControlRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.UnlinkEvidenceFromControlRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.UnlinkEvidenceFromControlRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEvidenceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string control_id = 2;
 * @return {string}
 */
proto.attachment.UnlinkEvidenceFromControlRequest.prototype.getControlId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.UnlinkEvidenceFromControlRequest} returns this
 */
proto.attachment.UnlinkEvidenceFromControlRequest.prototype.setControlId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string evidence_ids = 3;
 * @return {!Array<string>}
 */
proto.attachment.UnlinkEvidenceFromControlRequest.prototype.getEvidenceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.UnlinkEvidenceFromControlRequest} returns this
 */
proto.attachment.UnlinkEvidenceFromControlRequest.prototype.setEvidenceIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.UnlinkEvidenceFromControlRequest} returns this
 */
proto.attachment.UnlinkEvidenceFromControlRequest.prototype.addEvidenceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.UnlinkEvidenceFromControlRequest} returns this
 */
proto.attachment.UnlinkEvidenceFromControlRequest.prototype.clearEvidenceIdsList = function() {
  return this.setEvidenceIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.UnlinkControlsFromEvidenceRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.UnlinkControlsFromEvidenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.UnlinkControlsFromEvidenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.UnlinkControlsFromEvidenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.UnlinkControlsFromEvidenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    controlIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.UnlinkControlsFromEvidenceRequest}
 */
proto.attachment.UnlinkControlsFromEvidenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.UnlinkControlsFromEvidenceRequest;
  return proto.attachment.UnlinkControlsFromEvidenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.UnlinkControlsFromEvidenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.UnlinkControlsFromEvidenceRequest}
 */
proto.attachment.UnlinkControlsFromEvidenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addControlIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.UnlinkControlsFromEvidenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.UnlinkControlsFromEvidenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.UnlinkControlsFromEvidenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.UnlinkControlsFromEvidenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getControlIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string evidence_id = 1;
 * @return {string}
 */
proto.attachment.UnlinkControlsFromEvidenceRequest.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.UnlinkControlsFromEvidenceRequest} returns this
 */
proto.attachment.UnlinkControlsFromEvidenceRequest.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string control_ids = 2;
 * @return {!Array<string>}
 */
proto.attachment.UnlinkControlsFromEvidenceRequest.prototype.getControlIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.UnlinkControlsFromEvidenceRequest} returns this
 */
proto.attachment.UnlinkControlsFromEvidenceRequest.prototype.setControlIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.UnlinkControlsFromEvidenceRequest} returns this
 */
proto.attachment.UnlinkControlsFromEvidenceRequest.prototype.addControlIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.UnlinkControlsFromEvidenceRequest} returns this
 */
proto.attachment.UnlinkControlsFromEvidenceRequest.prototype.clearControlIdsList = function() {
  return this.setControlIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.BulkUnlinkEvidenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.BulkUnlinkEvidenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.BulkUnlinkEvidenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.BulkUnlinkEvidenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    caption: jspb.Message.getFieldWithDefault(msg, 1, ""),
    linkage: (f = msg.getLinkage()) && proto.attachment.EvidenceLinkage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.BulkUnlinkEvidenceRequest}
 */
proto.attachment.BulkUnlinkEvidenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.BulkUnlinkEvidenceRequest;
  return proto.attachment.BulkUnlinkEvidenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.BulkUnlinkEvidenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.BulkUnlinkEvidenceRequest}
 */
proto.attachment.BulkUnlinkEvidenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    case 2:
      var value = new proto.attachment.EvidenceLinkage;
      reader.readMessage(value,proto.attachment.EvidenceLinkage.deserializeBinaryFromReader);
      msg.setLinkage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.BulkUnlinkEvidenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.BulkUnlinkEvidenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.BulkUnlinkEvidenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.BulkUnlinkEvidenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLinkage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.attachment.EvidenceLinkage.serializeBinaryToWriter
    );
  }
};


/**
 * optional string caption = 1;
 * @return {string}
 */
proto.attachment.BulkUnlinkEvidenceRequest.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.BulkUnlinkEvidenceRequest} returns this
 */
proto.attachment.BulkUnlinkEvidenceRequest.prototype.setCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional EvidenceLinkage linkage = 2;
 * @return {?proto.attachment.EvidenceLinkage}
 */
proto.attachment.BulkUnlinkEvidenceRequest.prototype.getLinkage = function() {
  return /** @type{?proto.attachment.EvidenceLinkage} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceLinkage, 2));
};


/**
 * @param {?proto.attachment.EvidenceLinkage|undefined} value
 * @return {!proto.attachment.BulkUnlinkEvidenceRequest} returns this
*/
proto.attachment.BulkUnlinkEvidenceRequest.prototype.setLinkage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.BulkUnlinkEvidenceRequest} returns this
 */
proto.attachment.BulkUnlinkEvidenceRequest.prototype.clearLinkage = function() {
  return this.setLinkage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.BulkUnlinkEvidenceRequest.prototype.hasLinkage = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceGroupControlsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceGroupControlsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceGroupControlsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupControlsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceGroupId: (f = msg.getEvidenceGroupId()) && proto.attachment.EvidenceGroupId.toObject(includeInstance, f),
    auditId: (f = msg.getAuditId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceGroupControlsRequest}
 */
proto.attachment.GetEvidenceGroupControlsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceGroupControlsRequest;
  return proto.attachment.GetEvidenceGroupControlsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceGroupControlsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceGroupControlsRequest}
 */
proto.attachment.GetEvidenceGroupControlsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceGroupId;
      reader.readMessage(value,proto.attachment.EvidenceGroupId.deserializeBinaryFromReader);
      msg.setEvidenceGroupId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceGroupControlsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceGroupControlsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceGroupControlsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupControlsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceGroupId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.EvidenceGroupId.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional EvidenceGroupId evidence_group_id = 1;
 * @return {?proto.attachment.EvidenceGroupId}
 */
proto.attachment.GetEvidenceGroupControlsRequest.prototype.getEvidenceGroupId = function() {
  return /** @type{?proto.attachment.EvidenceGroupId} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceGroupId, 1));
};


/**
 * @param {?proto.attachment.EvidenceGroupId|undefined} value
 * @return {!proto.attachment.GetEvidenceGroupControlsRequest} returns this
*/
proto.attachment.GetEvidenceGroupControlsRequest.prototype.setEvidenceGroupId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceGroupControlsRequest} returns this
 */
proto.attachment.GetEvidenceGroupControlsRequest.prototype.clearEvidenceGroupId = function() {
  return this.setEvidenceGroupId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceGroupControlsRequest.prototype.hasEvidenceGroupId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue audit_id = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.GetEvidenceGroupControlsRequest.prototype.getAuditId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.GetEvidenceGroupControlsRequest} returns this
*/
proto.attachment.GetEvidenceGroupControlsRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceGroupControlsRequest} returns this
 */
proto.attachment.GetEvidenceGroupControlsRequest.prototype.clearAuditId = function() {
  return this.setAuditId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceGroupControlsRequest.prototype.hasAuditId = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.GetEvidenceGroupControlsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceGroupControlsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceGroupControlsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceGroupControlsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupControlsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    viaRequestIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceGroupControlsResponse}
 */
proto.attachment.GetEvidenceGroupControlsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceGroupControlsResponse;
  return proto.attachment.GetEvidenceGroupControlsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceGroupControlsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceGroupControlsResponse}
 */
proto.attachment.GetEvidenceGroupControlsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addControlIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addViaRequestIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceGroupControlsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceGroupControlsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceGroupControlsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupControlsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getViaRequestIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string control_ids = 1;
 * @return {!Array<string>}
 */
proto.attachment.GetEvidenceGroupControlsResponse.prototype.getControlIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.GetEvidenceGroupControlsResponse} returns this
 */
proto.attachment.GetEvidenceGroupControlsResponse.prototype.setControlIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.GetEvidenceGroupControlsResponse} returns this
 */
proto.attachment.GetEvidenceGroupControlsResponse.prototype.addControlIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetEvidenceGroupControlsResponse} returns this
 */
proto.attachment.GetEvidenceGroupControlsResponse.prototype.clearControlIdsList = function() {
  return this.setControlIdsList([]);
};


/**
 * repeated string via_request_ids = 2;
 * @return {!Array<string>}
 */
proto.attachment.GetEvidenceGroupControlsResponse.prototype.getViaRequestIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.GetEvidenceGroupControlsResponse} returns this
 */
proto.attachment.GetEvidenceGroupControlsResponse.prototype.setViaRequestIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.GetEvidenceGroupControlsResponse} returns this
 */
proto.attachment.GetEvidenceGroupControlsResponse.prototype.addViaRequestIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetEvidenceGroupControlsResponse} returns this
 */
proto.attachment.GetEvidenceGroupControlsResponse.prototype.clearViaRequestIdsList = function() {
  return this.setViaRequestIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceGroupDRLRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceGroupDRLRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceGroupDRLRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupDRLRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceGroupId: (f = msg.getEvidenceGroupId()) && proto.attachment.EvidenceGroupId.toObject(includeInstance, f),
    auditId: (f = msg.getAuditId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceGroupDRLRequest}
 */
proto.attachment.GetEvidenceGroupDRLRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceGroupDRLRequest;
  return proto.attachment.GetEvidenceGroupDRLRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceGroupDRLRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceGroupDRLRequest}
 */
proto.attachment.GetEvidenceGroupDRLRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceGroupId;
      reader.readMessage(value,proto.attachment.EvidenceGroupId.deserializeBinaryFromReader);
      msg.setEvidenceGroupId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceGroupDRLRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceGroupDRLRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceGroupDRLRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupDRLRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceGroupId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.EvidenceGroupId.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional EvidenceGroupId evidence_group_id = 1;
 * @return {?proto.attachment.EvidenceGroupId}
 */
proto.attachment.GetEvidenceGroupDRLRequest.prototype.getEvidenceGroupId = function() {
  return /** @type{?proto.attachment.EvidenceGroupId} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceGroupId, 1));
};


/**
 * @param {?proto.attachment.EvidenceGroupId|undefined} value
 * @return {!proto.attachment.GetEvidenceGroupDRLRequest} returns this
*/
proto.attachment.GetEvidenceGroupDRLRequest.prototype.setEvidenceGroupId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceGroupDRLRequest} returns this
 */
proto.attachment.GetEvidenceGroupDRLRequest.prototype.clearEvidenceGroupId = function() {
  return this.setEvidenceGroupId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceGroupDRLRequest.prototype.hasEvidenceGroupId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue audit_id = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.GetEvidenceGroupDRLRequest.prototype.getAuditId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.GetEvidenceGroupDRLRequest} returns this
*/
proto.attachment.GetEvidenceGroupDRLRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceGroupDRLRequest} returns this
 */
proto.attachment.GetEvidenceGroupDRLRequest.prototype.clearAuditId = function() {
  return this.setAuditId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceGroupDRLRequest.prototype.hasAuditId = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.GetEvidenceGroupDRLResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceGroupDRLResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceGroupDRLResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceGroupDRLResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupDRLResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceGroupDRLResponse}
 */
proto.attachment.GetEvidenceGroupDRLResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceGroupDRLResponse;
  return proto.attachment.GetEvidenceGroupDRLResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceGroupDRLResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceGroupDRLResponse}
 */
proto.attachment.GetEvidenceGroupDRLResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addRequestIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceGroupDRLResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceGroupDRLResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceGroupDRLResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupDRLResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string request_ids = 1;
 * @return {!Array<string>}
 */
proto.attachment.GetEvidenceGroupDRLResponse.prototype.getRequestIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.GetEvidenceGroupDRLResponse} returns this
 */
proto.attachment.GetEvidenceGroupDRLResponse.prototype.setRequestIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.GetEvidenceGroupDRLResponse} returns this
 */
proto.attachment.GetEvidenceGroupDRLResponse.prototype.addRequestIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetEvidenceGroupDRLResponse} returns this
 */
proto.attachment.GetEvidenceGroupDRLResponse.prototype.clearRequestIdsList = function() {
  return this.setRequestIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceGroupDocumentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceGroupDocumentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceGroupDocumentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupDocumentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceGroupId: (f = msg.getEvidenceGroupId()) && proto.attachment.EvidenceGroupId.toObject(includeInstance, f),
    auditId: (f = msg.getAuditId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceGroupDocumentsRequest}
 */
proto.attachment.GetEvidenceGroupDocumentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceGroupDocumentsRequest;
  return proto.attachment.GetEvidenceGroupDocumentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceGroupDocumentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceGroupDocumentsRequest}
 */
proto.attachment.GetEvidenceGroupDocumentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceGroupId;
      reader.readMessage(value,proto.attachment.EvidenceGroupId.deserializeBinaryFromReader);
      msg.setEvidenceGroupId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceGroupDocumentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceGroupDocumentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceGroupDocumentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupDocumentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceGroupId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.EvidenceGroupId.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional EvidenceGroupId evidence_group_id = 1;
 * @return {?proto.attachment.EvidenceGroupId}
 */
proto.attachment.GetEvidenceGroupDocumentsRequest.prototype.getEvidenceGroupId = function() {
  return /** @type{?proto.attachment.EvidenceGroupId} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceGroupId, 1));
};


/**
 * @param {?proto.attachment.EvidenceGroupId|undefined} value
 * @return {!proto.attachment.GetEvidenceGroupDocumentsRequest} returns this
*/
proto.attachment.GetEvidenceGroupDocumentsRequest.prototype.setEvidenceGroupId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceGroupDocumentsRequest} returns this
 */
proto.attachment.GetEvidenceGroupDocumentsRequest.prototype.clearEvidenceGroupId = function() {
  return this.setEvidenceGroupId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceGroupDocumentsRequest.prototype.hasEvidenceGroupId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue audit_id = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.GetEvidenceGroupDocumentsRequest.prototype.getAuditId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.GetEvidenceGroupDocumentsRequest} returns this
*/
proto.attachment.GetEvidenceGroupDocumentsRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceGroupDocumentsRequest} returns this
 */
proto.attachment.GetEvidenceGroupDocumentsRequest.prototype.clearAuditId = function() {
  return this.setAuditId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceGroupDocumentsRequest.prototype.hasAuditId = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.GetEvidenceGroupDocumentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceGroupDocumentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceGroupDocumentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceGroupDocumentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupDocumentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    documentIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceGroupDocumentsResponse}
 */
proto.attachment.GetEvidenceGroupDocumentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceGroupDocumentsResponse;
  return proto.attachment.GetEvidenceGroupDocumentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceGroupDocumentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceGroupDocumentsResponse}
 */
proto.attachment.GetEvidenceGroupDocumentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addDocumentIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceGroupDocumentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceGroupDocumentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceGroupDocumentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupDocumentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string document_ids = 1;
 * @return {!Array<string>}
 */
proto.attachment.GetEvidenceGroupDocumentsResponse.prototype.getDocumentIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.GetEvidenceGroupDocumentsResponse} returns this
 */
proto.attachment.GetEvidenceGroupDocumentsResponse.prototype.setDocumentIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.GetEvidenceGroupDocumentsResponse} returns this
 */
proto.attachment.GetEvidenceGroupDocumentsResponse.prototype.addDocumentIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetEvidenceGroupDocumentsResponse} returns this
 */
proto.attachment.GetEvidenceGroupDocumentsResponse.prototype.clearDocumentIdsList = function() {
  return this.setDocumentIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && proto.attachment.EvidenceGroupId.toObject(includeInstance, f),
    auditId: (f = msg.getAuditId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceGroupRequest}
 */
proto.attachment.GetEvidenceGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceGroupRequest;
  return proto.attachment.GetEvidenceGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceGroupRequest}
 */
proto.attachment.GetEvidenceGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceGroupId;
      reader.readMessage(value,proto.attachment.EvidenceGroupId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.EvidenceGroupId.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional EvidenceGroupId id = 1;
 * @return {?proto.attachment.EvidenceGroupId}
 */
proto.attachment.GetEvidenceGroupRequest.prototype.getId = function() {
  return /** @type{?proto.attachment.EvidenceGroupId} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceGroupId, 1));
};


/**
 * @param {?proto.attachment.EvidenceGroupId|undefined} value
 * @return {!proto.attachment.GetEvidenceGroupRequest} returns this
*/
proto.attachment.GetEvidenceGroupRequest.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceGroupRequest} returns this
 */
proto.attachment.GetEvidenceGroupRequest.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceGroupRequest.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue audit_id = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.attachment.GetEvidenceGroupRequest.prototype.getAuditId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.attachment.GetEvidenceGroupRequest} returns this
*/
proto.attachment.GetEvidenceGroupRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceGroupRequest} returns this
 */
proto.attachment.GetEvidenceGroupRequest.prototype.clearAuditId = function() {
  return this.setAuditId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceGroupRequest.prototype.hasAuditId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceGroupResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceGroupResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceGroupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceGroup: (f = msg.getEvidenceGroup()) && proto.attachment.EvidenceGroup.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceGroupResponse}
 */
proto.attachment.GetEvidenceGroupResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceGroupResponse;
  return proto.attachment.GetEvidenceGroupResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceGroupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceGroupResponse}
 */
proto.attachment.GetEvidenceGroupResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceGroup;
      reader.readMessage(value,proto.attachment.EvidenceGroup.deserializeBinaryFromReader);
      msg.setEvidenceGroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceGroupResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceGroupResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceGroupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceGroup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.EvidenceGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional EvidenceGroup evidence_group = 1;
 * @return {?proto.attachment.EvidenceGroup}
 */
proto.attachment.GetEvidenceGroupResponse.prototype.getEvidenceGroup = function() {
  return /** @type{?proto.attachment.EvidenceGroup} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceGroup, 1));
};


/**
 * @param {?proto.attachment.EvidenceGroup|undefined} value
 * @return {!proto.attachment.GetEvidenceGroupResponse} returns this
*/
proto.attachment.GetEvidenceGroupResponse.prototype.setEvidenceGroup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceGroupResponse} returns this
 */
proto.attachment.GetEvidenceGroupResponse.prototype.clearEvidenceGroup = function() {
  return this.setEvidenceGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceGroupResponse.prototype.hasEvidenceGroup = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceGroupByIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceGroupByIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceGroupByIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupByIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    auditId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceGroupByIdRequest}
 */
proto.attachment.GetEvidenceGroupByIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceGroupByIdRequest;
  return proto.attachment.GetEvidenceGroupByIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceGroupByIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceGroupByIdRequest}
 */
proto.attachment.GetEvidenceGroupByIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceGroupByIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceGroupByIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceGroupByIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupByIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.attachment.GetEvidenceGroupByIdRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetEvidenceGroupByIdRequest} returns this
 */
proto.attachment.GetEvidenceGroupByIdRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string audit_id = 2;
 * @return {string}
 */
proto.attachment.GetEvidenceGroupByIdRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetEvidenceGroupByIdRequest} returns this
 */
proto.attachment.GetEvidenceGroupByIdRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceGroupIfExistsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceGroupIfExistsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceGroupIfExistsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupIfExistsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceGroupIfExistsRequest}
 */
proto.attachment.GetEvidenceGroupIfExistsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceGroupIfExistsRequest;
  return proto.attachment.GetEvidenceGroupIfExistsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceGroupIfExistsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceGroupIfExistsRequest}
 */
proto.attachment.GetEvidenceGroupIfExistsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceGroupIfExistsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceGroupIfExistsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceGroupIfExistsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupIfExistsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.attachment.GetEvidenceGroupIfExistsRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetEvidenceGroupIfExistsRequest} returns this
 */
proto.attachment.GetEvidenceGroupIfExistsRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceGroupByIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceGroupByIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceGroupByIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupByIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceGroup: (f = msg.getEvidenceGroup()) && proto.attachment.EvidenceGroup.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceGroupByIdResponse}
 */
proto.attachment.GetEvidenceGroupByIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceGroupByIdResponse;
  return proto.attachment.GetEvidenceGroupByIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceGroupByIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceGroupByIdResponse}
 */
proto.attachment.GetEvidenceGroupByIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceGroup;
      reader.readMessage(value,proto.attachment.EvidenceGroup.deserializeBinaryFromReader);
      msg.setEvidenceGroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceGroupByIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceGroupByIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceGroupByIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupByIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceGroup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attachment.EvidenceGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional EvidenceGroup evidence_group = 1;
 * @return {?proto.attachment.EvidenceGroup}
 */
proto.attachment.GetEvidenceGroupByIdResponse.prototype.getEvidenceGroup = function() {
  return /** @type{?proto.attachment.EvidenceGroup} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceGroup, 1));
};


/**
 * @param {?proto.attachment.EvidenceGroup|undefined} value
 * @return {!proto.attachment.GetEvidenceGroupByIdResponse} returns this
*/
proto.attachment.GetEvidenceGroupByIdResponse.prototype.setEvidenceGroup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceGroupByIdResponse} returns this
 */
proto.attachment.GetEvidenceGroupByIdResponse.prototype.clearEvidenceGroup = function() {
  return this.setEvidenceGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceGroupByIdResponse.prototype.hasEvidenceGroup = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceGroupIfExistsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceGroupIfExistsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceGroupIfExistsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupIfExistsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    evidenceGroup: (f = msg.getEvidenceGroup()) && proto.attachment.EvidenceGroup.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceGroupIfExistsResponse}
 */
proto.attachment.GetEvidenceGroupIfExistsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceGroupIfExistsResponse;
  return proto.attachment.GetEvidenceGroupIfExistsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceGroupIfExistsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceGroupIfExistsResponse}
 */
proto.attachment.GetEvidenceGroupIfExistsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    case 2:
      var value = new proto.attachment.EvidenceGroup;
      reader.readMessage(value,proto.attachment.EvidenceGroup.deserializeBinaryFromReader);
      msg.setEvidenceGroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceGroupIfExistsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceGroupIfExistsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceGroupIfExistsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceGroupIfExistsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getEvidenceGroup();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.attachment.EvidenceGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.attachment.GetEvidenceGroupIfExistsResponse.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetEvidenceGroupIfExistsResponse} returns this
 */
proto.attachment.GetEvidenceGroupIfExistsResponse.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional EvidenceGroup evidence_group = 2;
 * @return {?proto.attachment.EvidenceGroup}
 */
proto.attachment.GetEvidenceGroupIfExistsResponse.prototype.getEvidenceGroup = function() {
  return /** @type{?proto.attachment.EvidenceGroup} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceGroup, 2));
};


/**
 * @param {?proto.attachment.EvidenceGroup|undefined} value
 * @return {!proto.attachment.GetEvidenceGroupIfExistsResponse} returns this
*/
proto.attachment.GetEvidenceGroupIfExistsResponse.prototype.setEvidenceGroup = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceGroupIfExistsResponse} returns this
 */
proto.attachment.GetEvidenceGroupIfExistsResponse.prototype.clearEvidenceGroup = function() {
  return this.setEvidenceGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceGroupIfExistsResponse.prototype.hasEvidenceGroup = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.GetEvidenceIndexPageRequest.repeatedFields_ = [9,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceIndexPageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceIndexPageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceIndexPageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    auditId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dateRangeFilter: (f = msg.getDateRangeFilter()) && common_time_pb.TimeRange.toObject(includeInstance, f),
    controlFilter: (f = msg.getControlFilter()) && proto.attachment.ControlFilter.toObject(includeInstance, f),
    actorFilter: (f = msg.getActorFilter()) && proto.attachment.ActorFilter.toObject(includeInstance, f),
    evidenceTypeFilter: (f = msg.getEvidenceTypeFilter()) && proto.attachment.EvidenceTypeFilter.toObject(includeInstance, f),
    sort: (f = msg.getSort()) && proto.attachment.EvidenceSort.toObject(includeInstance, f),
    showStats: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    receptorIdList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    evidenceIdFilter: (f = msg.getEvidenceIdFilter()) && proto.attachment.EvidenceIdFilter.toObject(includeInstance, f),
    includeOutOfWindow: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    labelIdsList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceIndexPageRequest}
 */
proto.attachment.GetEvidenceIndexPageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceIndexPageRequest;
  return proto.attachment.GetEvidenceIndexPageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceIndexPageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceIndexPageRequest}
 */
proto.attachment.GetEvidenceIndexPageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    case 3:
      var value = new common_time_pb.TimeRange;
      reader.readMessage(value,common_time_pb.TimeRange.deserializeBinaryFromReader);
      msg.setDateRangeFilter(value);
      break;
    case 4:
      var value = new proto.attachment.ControlFilter;
      reader.readMessage(value,proto.attachment.ControlFilter.deserializeBinaryFromReader);
      msg.setControlFilter(value);
      break;
    case 5:
      var value = new proto.attachment.ActorFilter;
      reader.readMessage(value,proto.attachment.ActorFilter.deserializeBinaryFromReader);
      msg.setActorFilter(value);
      break;
    case 6:
      var value = new proto.attachment.EvidenceTypeFilter;
      reader.readMessage(value,proto.attachment.EvidenceTypeFilter.deserializeBinaryFromReader);
      msg.setEvidenceTypeFilter(value);
      break;
    case 7:
      var value = new proto.attachment.EvidenceSort;
      reader.readMessage(value,proto.attachment.EvidenceSort.deserializeBinaryFromReader);
      msg.setSort(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowStats(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addReceptorId(value);
      break;
    case 10:
      var value = new proto.attachment.EvidenceIdFilter;
      reader.readMessage(value,proto.attachment.EvidenceIdFilter.deserializeBinaryFromReader);
      msg.setEvidenceIdFilter(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeOutOfWindow(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addLabelIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceIndexPageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceIndexPageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceIndexPageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDateRangeFilter();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_time_pb.TimeRange.serializeBinaryToWriter
    );
  }
  f = message.getControlFilter();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.attachment.ControlFilter.serializeBinaryToWriter
    );
  }
  f = message.getActorFilter();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.attachment.ActorFilter.serializeBinaryToWriter
    );
  }
  f = message.getEvidenceTypeFilter();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.attachment.EvidenceTypeFilter.serializeBinaryToWriter
    );
  }
  f = message.getSort();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.attachment.EvidenceSort.serializeBinaryToWriter
    );
  }
  f = message.getShowStats();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getReceptorIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getEvidenceIdFilter();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.attachment.EvidenceIdFilter.serializeBinaryToWriter
    );
  }
  f = message.getIncludeOutOfWindow();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
};


/**
 * optional string audit_id = 2;
 * @return {string}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.TimeRange date_range_filter = 3;
 * @return {?proto.common.TimeRange}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.getDateRangeFilter = function() {
  return /** @type{?proto.common.TimeRange} */ (
    jspb.Message.getWrapperField(this, common_time_pb.TimeRange, 3));
};


/**
 * @param {?proto.common.TimeRange|undefined} value
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
*/
proto.attachment.GetEvidenceIndexPageRequest.prototype.setDateRangeFilter = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.clearDateRangeFilter = function() {
  return this.setDateRangeFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.hasDateRangeFilter = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ControlFilter control_filter = 4;
 * @return {?proto.attachment.ControlFilter}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.getControlFilter = function() {
  return /** @type{?proto.attachment.ControlFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.ControlFilter, 4));
};


/**
 * @param {?proto.attachment.ControlFilter|undefined} value
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
*/
proto.attachment.GetEvidenceIndexPageRequest.prototype.setControlFilter = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.clearControlFilter = function() {
  return this.setControlFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.hasControlFilter = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ActorFilter actor_filter = 5;
 * @return {?proto.attachment.ActorFilter}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.getActorFilter = function() {
  return /** @type{?proto.attachment.ActorFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.ActorFilter, 5));
};


/**
 * @param {?proto.attachment.ActorFilter|undefined} value
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
*/
proto.attachment.GetEvidenceIndexPageRequest.prototype.setActorFilter = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.clearActorFilter = function() {
  return this.setActorFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.hasActorFilter = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional EvidenceTypeFilter evidence_type_filter = 6;
 * @return {?proto.attachment.EvidenceTypeFilter}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.getEvidenceTypeFilter = function() {
  return /** @type{?proto.attachment.EvidenceTypeFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceTypeFilter, 6));
};


/**
 * @param {?proto.attachment.EvidenceTypeFilter|undefined} value
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
*/
proto.attachment.GetEvidenceIndexPageRequest.prototype.setEvidenceTypeFilter = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.clearEvidenceTypeFilter = function() {
  return this.setEvidenceTypeFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.hasEvidenceTypeFilter = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional EvidenceSort sort = 7;
 * @return {?proto.attachment.EvidenceSort}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.getSort = function() {
  return /** @type{?proto.attachment.EvidenceSort} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceSort, 7));
};


/**
 * @param {?proto.attachment.EvidenceSort|undefined} value
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
*/
proto.attachment.GetEvidenceIndexPageRequest.prototype.setSort = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.clearSort = function() {
  return this.setSort(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.hasSort = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool show_stats = 8;
 * @return {boolean}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.getShowStats = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.setShowStats = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * repeated string receptor_id = 9;
 * @return {!Array<string>}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.getReceptorIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.setReceptorIdList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.addReceptorId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.clearReceptorIdList = function() {
  return this.setReceptorIdList([]);
};


/**
 * optional EvidenceIdFilter evidence_id_filter = 10;
 * @return {?proto.attachment.EvidenceIdFilter}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.getEvidenceIdFilter = function() {
  return /** @type{?proto.attachment.EvidenceIdFilter} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceIdFilter, 10));
};


/**
 * @param {?proto.attachment.EvidenceIdFilter|undefined} value
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
*/
proto.attachment.GetEvidenceIndexPageRequest.prototype.setEvidenceIdFilter = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.clearEvidenceIdFilter = function() {
  return this.setEvidenceIdFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.hasEvidenceIdFilter = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool include_out_of_window = 11;
 * @return {boolean}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.getIncludeOutOfWindow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.setIncludeOutOfWindow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * repeated string label_ids = 12;
 * @return {!Array<string>}
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.getLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.setLabelIdsList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.addLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetEvidenceIndexPageRequest} returns this
 */
proto.attachment.GetEvidenceIndexPageRequest.prototype.clearLabelIdsList = function() {
  return this.setLabelIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetControlEvidenceTabRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetControlEvidenceTabRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetControlEvidenceTabRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlModelId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    auditId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dateRangeFilter: (f = msg.getDateRangeFilter()) && common_time_pb.TimeRange.toObject(includeInstance, f),
    sort: (f = msg.getSort()) && proto.attachment.EvidenceSort.toObject(includeInstance, f),
    showStats: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    includeOutOfWindow: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetControlEvidenceTabRequest}
 */
proto.attachment.GetControlEvidenceTabRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetControlEvidenceTabRequest;
  return proto.attachment.GetControlEvidenceTabRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetControlEvidenceTabRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetControlEvidenceTabRequest}
 */
proto.attachment.GetControlEvidenceTabRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlModelId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    case 3:
      var value = new common_time_pb.TimeRange;
      reader.readMessage(value,common_time_pb.TimeRange.deserializeBinaryFromReader);
      msg.setDateRangeFilter(value);
      break;
    case 7:
      var value = new proto.attachment.EvidenceSort;
      reader.readMessage(value,proto.attachment.EvidenceSort.deserializeBinaryFromReader);
      msg.setSort(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowStats(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeOutOfWindow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetControlEvidenceTabRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetControlEvidenceTabRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetControlEvidenceTabRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlModelId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDateRangeFilter();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_time_pb.TimeRange.serializeBinaryToWriter
    );
  }
  f = message.getSort();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.attachment.EvidenceSort.serializeBinaryToWriter
    );
  }
  f = message.getShowStats();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getIncludeOutOfWindow();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional string control_model_id = 1;
 * @return {string}
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.getControlModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetControlEvidenceTabRequest} returns this
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.setControlModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string audit_id = 2;
 * @return {string}
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetControlEvidenceTabRequest} returns this
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.TimeRange date_range_filter = 3;
 * @return {?proto.common.TimeRange}
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.getDateRangeFilter = function() {
  return /** @type{?proto.common.TimeRange} */ (
    jspb.Message.getWrapperField(this, common_time_pb.TimeRange, 3));
};


/**
 * @param {?proto.common.TimeRange|undefined} value
 * @return {!proto.attachment.GetControlEvidenceTabRequest} returns this
*/
proto.attachment.GetControlEvidenceTabRequest.prototype.setDateRangeFilter = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetControlEvidenceTabRequest} returns this
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.clearDateRangeFilter = function() {
  return this.setDateRangeFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.hasDateRangeFilter = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional EvidenceSort sort = 7;
 * @return {?proto.attachment.EvidenceSort}
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.getSort = function() {
  return /** @type{?proto.attachment.EvidenceSort} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceSort, 7));
};


/**
 * @param {?proto.attachment.EvidenceSort|undefined} value
 * @return {!proto.attachment.GetControlEvidenceTabRequest} returns this
*/
proto.attachment.GetControlEvidenceTabRequest.prototype.setSort = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetControlEvidenceTabRequest} returns this
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.clearSort = function() {
  return this.setSort(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.hasSort = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool show_stats = 8;
 * @return {boolean}
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.getShowStats = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetControlEvidenceTabRequest} returns this
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.setShowStats = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool include_out_of_window = 9;
 * @return {boolean}
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.getIncludeOutOfWindow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetControlEvidenceTabRequest} returns this
 */
proto.attachment.GetControlEvidenceTabRequest.prototype.setIncludeOutOfWindow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetRequestEvidenceTabRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetRequestEvidenceTabRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetRequestEvidenceTabRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    auditId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dateRangeFilter: (f = msg.getDateRangeFilter()) && common_time_pb.TimeRange.toObject(includeInstance, f),
    sort: (f = msg.getSort()) && proto.attachment.EvidenceSort.toObject(includeInstance, f),
    showStats: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    includeOutOfWindow: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetRequestEvidenceTabRequest}
 */
proto.attachment.GetRequestEvidenceTabRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetRequestEvidenceTabRequest;
  return proto.attachment.GetRequestEvidenceTabRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetRequestEvidenceTabRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetRequestEvidenceTabRequest}
 */
proto.attachment.GetRequestEvidenceTabRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    case 3:
      var value = new common_time_pb.TimeRange;
      reader.readMessage(value,common_time_pb.TimeRange.deserializeBinaryFromReader);
      msg.setDateRangeFilter(value);
      break;
    case 7:
      var value = new proto.attachment.EvidenceSort;
      reader.readMessage(value,proto.attachment.EvidenceSort.deserializeBinaryFromReader);
      msg.setSort(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowStats(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeOutOfWindow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetRequestEvidenceTabRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetRequestEvidenceTabRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetRequestEvidenceTabRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDateRangeFilter();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_time_pb.TimeRange.serializeBinaryToWriter
    );
  }
  f = message.getSort();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.attachment.EvidenceSort.serializeBinaryToWriter
    );
  }
  f = message.getShowStats();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getIncludeOutOfWindow();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetRequestEvidenceTabRequest} returns this
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string audit_id = 2;
 * @return {string}
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetRequestEvidenceTabRequest} returns this
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.TimeRange date_range_filter = 3;
 * @return {?proto.common.TimeRange}
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.getDateRangeFilter = function() {
  return /** @type{?proto.common.TimeRange} */ (
    jspb.Message.getWrapperField(this, common_time_pb.TimeRange, 3));
};


/**
 * @param {?proto.common.TimeRange|undefined} value
 * @return {!proto.attachment.GetRequestEvidenceTabRequest} returns this
*/
proto.attachment.GetRequestEvidenceTabRequest.prototype.setDateRangeFilter = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetRequestEvidenceTabRequest} returns this
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.clearDateRangeFilter = function() {
  return this.setDateRangeFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.hasDateRangeFilter = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional EvidenceSort sort = 7;
 * @return {?proto.attachment.EvidenceSort}
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.getSort = function() {
  return /** @type{?proto.attachment.EvidenceSort} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceSort, 7));
};


/**
 * @param {?proto.attachment.EvidenceSort|undefined} value
 * @return {!proto.attachment.GetRequestEvidenceTabRequest} returns this
*/
proto.attachment.GetRequestEvidenceTabRequest.prototype.setSort = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetRequestEvidenceTabRequest} returns this
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.clearSort = function() {
  return this.setSort(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.hasSort = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool show_stats = 8;
 * @return {boolean}
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.getShowStats = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetRequestEvidenceTabRequest} returns this
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.setShowStats = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool include_out_of_window = 9;
 * @return {boolean}
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.getIncludeOutOfWindow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetRequestEvidenceTabRequest} returns this
 */
proto.attachment.GetRequestEvidenceTabRequest.prototype.setIncludeOutOfWindow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceInstanceListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceInstanceListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceInstanceListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    auditId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dateRangeFilter: (f = msg.getDateRangeFilter()) && common_time_pb.TimeRange.toObject(includeInstance, f),
    controlId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    showStats: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    includeOutOfWindow: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceInstanceListRequest}
 */
proto.attachment.GetEvidenceInstanceListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceInstanceListRequest;
  return proto.attachment.GetEvidenceInstanceListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceInstanceListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceInstanceListRequest}
 */
proto.attachment.GetEvidenceInstanceListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    case 3:
      var value = new common_time_pb.TimeRange;
      reader.readMessage(value,common_time_pb.TimeRange.deserializeBinaryFromReader);
      msg.setDateRangeFilter(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlId(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowStats(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeOutOfWindow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceInstanceListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceInstanceListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceInstanceListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDateRangeFilter();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_time_pb.TimeRange.serializeBinaryToWriter
    );
  }
  f = message.getControlId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getShowStats();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getIncludeOutOfWindow();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional string evidence_id = 1;
 * @return {string}
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetEvidenceInstanceListRequest} returns this
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string audit_id = 2;
 * @return {string}
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetEvidenceInstanceListRequest} returns this
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.TimeRange date_range_filter = 3;
 * @return {?proto.common.TimeRange}
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.getDateRangeFilter = function() {
  return /** @type{?proto.common.TimeRange} */ (
    jspb.Message.getWrapperField(this, common_time_pb.TimeRange, 3));
};


/**
 * @param {?proto.common.TimeRange|undefined} value
 * @return {!proto.attachment.GetEvidenceInstanceListRequest} returns this
*/
proto.attachment.GetEvidenceInstanceListRequest.prototype.setDateRangeFilter = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.GetEvidenceInstanceListRequest} returns this
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.clearDateRangeFilter = function() {
  return this.setDateRangeFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.hasDateRangeFilter = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string control_id = 4;
 * @return {string}
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.getControlId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetEvidenceInstanceListRequest} returns this
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.setControlId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool show_stats = 8;
 * @return {boolean}
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.getShowStats = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetEvidenceInstanceListRequest} returns this
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.setShowStats = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool include_out_of_window = 9;
 * @return {boolean}
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.getIncludeOutOfWindow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.GetEvidenceInstanceListRequest} returns this
 */
proto.attachment.GetEvidenceInstanceListRequest.prototype.setIncludeOutOfWindow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.EvidenceWrapperResponse.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.EvidenceWrapperResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.EvidenceWrapperResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.EvidenceWrapperResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceWrapperResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.attachment.EvidenceWrapper.toObject, includeInstance),
    evidenceIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    evidenceInstanceIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    hasEvidence: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    milliseconds: jspb.Message.getFieldWithDefault(msg, 5, 0),
    outOfWindowCount: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.EvidenceWrapperResponse}
 */
proto.attachment.EvidenceWrapperResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.EvidenceWrapperResponse;
  return proto.attachment.EvidenceWrapperResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.EvidenceWrapperResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.EvidenceWrapperResponse}
 */
proto.attachment.EvidenceWrapperResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceWrapper;
      reader.readMessage(value,proto.attachment.EvidenceWrapper.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addEvidenceIds(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addEvidenceInstanceIds(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasEvidence(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMilliseconds(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOutOfWindowCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.EvidenceWrapperResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.EvidenceWrapperResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.EvidenceWrapperResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceWrapperResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.EvidenceWrapper.serializeBinaryToWriter
    );
  }
  f = message.getEvidenceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getEvidenceInstanceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getHasEvidence();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getMilliseconds();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getOutOfWindowCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * repeated EvidenceWrapper items = 1;
 * @return {!Array<!proto.attachment.EvidenceWrapper>}
 */
proto.attachment.EvidenceWrapperResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.attachment.EvidenceWrapper>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.EvidenceWrapper, 1));
};


/**
 * @param {!Array<!proto.attachment.EvidenceWrapper>} value
 * @return {!proto.attachment.EvidenceWrapperResponse} returns this
*/
proto.attachment.EvidenceWrapperResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.EvidenceWrapper=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceWrapper}
 */
proto.attachment.EvidenceWrapperResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.EvidenceWrapper, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.EvidenceWrapperResponse} returns this
 */
proto.attachment.EvidenceWrapperResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * repeated string evidence_ids = 2;
 * @return {!Array<string>}
 */
proto.attachment.EvidenceWrapperResponse.prototype.getEvidenceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.EvidenceWrapperResponse} returns this
 */
proto.attachment.EvidenceWrapperResponse.prototype.setEvidenceIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceWrapperResponse} returns this
 */
proto.attachment.EvidenceWrapperResponse.prototype.addEvidenceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.EvidenceWrapperResponse} returns this
 */
proto.attachment.EvidenceWrapperResponse.prototype.clearEvidenceIdsList = function() {
  return this.setEvidenceIdsList([]);
};


/**
 * repeated string evidence_instance_ids = 3;
 * @return {!Array<string>}
 */
proto.attachment.EvidenceWrapperResponse.prototype.getEvidenceInstanceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.EvidenceWrapperResponse} returns this
 */
proto.attachment.EvidenceWrapperResponse.prototype.setEvidenceInstanceIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceWrapperResponse} returns this
 */
proto.attachment.EvidenceWrapperResponse.prototype.addEvidenceInstanceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.EvidenceWrapperResponse} returns this
 */
proto.attachment.EvidenceWrapperResponse.prototype.clearEvidenceInstanceIdsList = function() {
  return this.setEvidenceInstanceIdsList([]);
};


/**
 * optional bool has_evidence = 4;
 * @return {boolean}
 */
proto.attachment.EvidenceWrapperResponse.prototype.getHasEvidence = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.EvidenceWrapperResponse} returns this
 */
proto.attachment.EvidenceWrapperResponse.prototype.setHasEvidence = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int64 milliseconds = 5;
 * @return {number}
 */
proto.attachment.EvidenceWrapperResponse.prototype.getMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.EvidenceWrapperResponse} returns this
 */
proto.attachment.EvidenceWrapperResponse.prototype.setMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 out_of_window_count = 6;
 * @return {number}
 */
proto.attachment.EvidenceWrapperResponse.prototype.getOutOfWindowCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.EvidenceWrapperResponse} returns this
 */
proto.attachment.EvidenceWrapperResponse.prototype.setOutOfWindowCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.EvidenceReadOnlyField.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.EvidenceReadOnlyField.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.EvidenceReadOnlyField} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceReadOnlyField.toObject = function(includeInstance, msg) {
  var f, obj = {
    field: jspb.Message.getFieldWithDefault(msg, 1, 0),
    details: (f = msg.getDetails()) && common_grc_platform_pb.ReadOnlyFieldDetail.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.EvidenceReadOnlyField}
 */
proto.attachment.EvidenceReadOnlyField.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.EvidenceReadOnlyField;
  return proto.attachment.EvidenceReadOnlyField.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.EvidenceReadOnlyField} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.EvidenceReadOnlyField}
 */
proto.attachment.EvidenceReadOnlyField.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.attachment.EVIDENCE_READ_ONLY_FIELDS} */ (reader.readEnum());
      msg.setField(value);
      break;
    case 2:
      var value = new common_grc_platform_pb.ReadOnlyFieldDetail;
      reader.readMessage(value,common_grc_platform_pb.ReadOnlyFieldDetail.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.EvidenceReadOnlyField.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.EvidenceReadOnlyField.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.EvidenceReadOnlyField} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceReadOnlyField.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getField();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_grc_platform_pb.ReadOnlyFieldDetail.serializeBinaryToWriter
    );
  }
};


/**
 * optional EVIDENCE_READ_ONLY_FIELDS field = 1;
 * @return {!proto.attachment.EVIDENCE_READ_ONLY_FIELDS}
 */
proto.attachment.EvidenceReadOnlyField.prototype.getField = function() {
  return /** @type {!proto.attachment.EVIDENCE_READ_ONLY_FIELDS} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.attachment.EVIDENCE_READ_ONLY_FIELDS} value
 * @return {!proto.attachment.EvidenceReadOnlyField} returns this
 */
proto.attachment.EvidenceReadOnlyField.prototype.setField = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional common.ReadOnlyFieldDetail details = 2;
 * @return {?proto.common.ReadOnlyFieldDetail}
 */
proto.attachment.EvidenceReadOnlyField.prototype.getDetails = function() {
  return /** @type{?proto.common.ReadOnlyFieldDetail} */ (
    jspb.Message.getWrapperField(this, common_grc_platform_pb.ReadOnlyFieldDetail, 2));
};


/**
 * @param {?proto.common.ReadOnlyFieldDetail|undefined} value
 * @return {!proto.attachment.EvidenceReadOnlyField} returns this
*/
proto.attachment.EvidenceReadOnlyField.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceReadOnlyField} returns this
 */
proto.attachment.EvidenceReadOnlyField.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceReadOnlyField.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.EvidenceReadOnlyFields.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.EvidenceReadOnlyFields.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.EvidenceReadOnlyFields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.EvidenceReadOnlyFields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceReadOnlyFields.toObject = function(includeInstance, msg) {
  var f, obj = {
    fieldsList: jspb.Message.toObjectList(msg.getFieldsList(),
    proto.attachment.EvidenceReadOnlyField.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.EvidenceReadOnlyFields}
 */
proto.attachment.EvidenceReadOnlyFields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.EvidenceReadOnlyFields;
  return proto.attachment.EvidenceReadOnlyFields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.EvidenceReadOnlyFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.EvidenceReadOnlyFields}
 */
proto.attachment.EvidenceReadOnlyFields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceReadOnlyField;
      reader.readMessage(value,proto.attachment.EvidenceReadOnlyField.deserializeBinaryFromReader);
      msg.addFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.EvidenceReadOnlyFields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.EvidenceReadOnlyFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.EvidenceReadOnlyFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceReadOnlyFields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.EvidenceReadOnlyField.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EvidenceReadOnlyField fields = 1;
 * @return {!Array<!proto.attachment.EvidenceReadOnlyField>}
 */
proto.attachment.EvidenceReadOnlyFields.prototype.getFieldsList = function() {
  return /** @type{!Array<!proto.attachment.EvidenceReadOnlyField>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.EvidenceReadOnlyField, 1));
};


/**
 * @param {!Array<!proto.attachment.EvidenceReadOnlyField>} value
 * @return {!proto.attachment.EvidenceReadOnlyFields} returns this
*/
proto.attachment.EvidenceReadOnlyFields.prototype.setFieldsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.EvidenceReadOnlyField=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceReadOnlyField}
 */
proto.attachment.EvidenceReadOnlyFields.prototype.addFields = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.EvidenceReadOnlyField, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.EvidenceReadOnlyFields} returns this
 */
proto.attachment.EvidenceReadOnlyFields.prototype.clearFieldsList = function() {
  return this.setFieldsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.EvidenceWrapper.repeatedFields_ = [41];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.EvidenceWrapper.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.EvidenceWrapper.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.EvidenceWrapper} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceWrapper.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    caption: jspb.Message.getFieldWithDefault(msg, 2, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    actorEmail: jspb.Message.getFieldWithDefault(msg, 4, ""),
    actorName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    isAutomated: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    mime: jspb.Message.getFieldWithDefault(msg, 7, ""),
    relevantDate: (f = msg.getRelevantDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    contentId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    discoveryId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    description: jspb.Message.getFieldWithDefault(msg, 12, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    bodySize: jspb.Message.getFieldWithDefault(msg, 16, 0),
    actorId: jspb.Message.getFieldWithDefault(msg, 17, ""),
    fileName: jspb.Message.getFieldWithDefault(msg, 18, ""),
    serviceModelId: jspb.Message.getFieldWithDefault(msg, 19, ""),
    evidenceId: jspb.Message.getFieldWithDefault(msg, 22, ""),
    evidenceInstanceId: jspb.Message.getFieldWithDefault(msg, 23, ""),
    isViaRequest: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    isLinkedDocument: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
    isLinkBroken: jspb.Message.getBooleanFieldWithDefault(msg, 26, false),
    receptorId: jspb.Message.getFieldWithDefault(msg, 27, ""),
    receptorModelId: jspb.Message.getFieldWithDefault(msg, 28, ""),
    docImportKey: jspb.Message.getFieldWithDefault(msg, 29, ""),
    docImportLink: jspb.Message.getFieldWithDefault(msg, 30, ""),
    docModifiedAt: (f = msg.getDocModifiedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    docScannedAt: (f = msg.getDocScannedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    isInstanceMissing: jspb.Message.getBooleanFieldWithDefault(msg, 33, false),
    linkedControlsCount: jspb.Message.getFieldWithDefault(msg, 34, 0),
    stackedEvidenceCount: jspb.Message.getFieldWithDefault(msg, 35, 0),
    linkedRequestsCount: jspb.Message.getFieldWithDefault(msg, 36, 0),
    grcPlatform: (f = msg.getGrcPlatform()) && common_grc_platform_pb.GrcPlatform.toObject(includeInstance, f),
    readOnlyFields: (f = msg.getReadOnlyFields()) && proto.attachment.EvidenceReadOnlyFields.toObject(includeInstance, f),
    indexingStatus: jspb.Message.getFieldWithDefault(msg, 39, 0),
    windowStatus: jspb.Message.getFieldWithDefault(msg, 40, 0),
    labelIdsList: (f = jspb.Message.getRepeatedField(msg, 41)) == null ? undefined : f,
    sourceKind: jspb.Message.getFieldWithDefault(msg, 42, 0),
    sourceId: jspb.Message.getFieldWithDefault(msg, 43, ""),
    sourceName: jspb.Message.getFieldWithDefault(msg, 44, ""),
    sourceParentId: jspb.Message.getFieldWithDefault(msg, 45, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.EvidenceWrapper}
 */
proto.attachment.EvidenceWrapper.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.EvidenceWrapper;
  return proto.attachment.EvidenceWrapper.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.EvidenceWrapper} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.EvidenceWrapper}
 */
proto.attachment.EvidenceWrapper.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setActorEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setActorName(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAutomated(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMime(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRelevantDate(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscoveryId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBodySize(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setActorId(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceModelId(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceInstanceId(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsViaRequest(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLinkedDocument(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLinkBroken(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorModelId(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocImportKey(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocImportLink(value);
      break;
    case 31:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDocModifiedAt(value);
      break;
    case 32:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDocScannedAt(value);
      break;
    case 33:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsInstanceMissing(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLinkedControlsCount(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStackedEvidenceCount(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLinkedRequestsCount(value);
      break;
    case 37:
      var value = new common_grc_platform_pb.GrcPlatform;
      reader.readMessage(value,common_grc_platform_pb.GrcPlatform.deserializeBinaryFromReader);
      msg.setGrcPlatform(value);
      break;
    case 38:
      var value = new proto.attachment.EvidenceReadOnlyFields;
      reader.readMessage(value,proto.attachment.EvidenceReadOnlyFields.deserializeBinaryFromReader);
      msg.setReadOnlyFields(value);
      break;
    case 39:
      var value = /** @type {!proto.common.INDEXING_STATUS} */ (reader.readEnum());
      msg.setIndexingStatus(value);
      break;
    case 40:
      var value = /** @type {!proto.attachment.EVIDENCE_WINDOW_STATUS} */ (reader.readEnum());
      msg.setWindowStatus(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.addLabelIds(value);
      break;
    case 42:
      var value = /** @type {!proto.attachment.EVIDENCE_SOURCE_KIND} */ (reader.readEnum());
      msg.setSourceKind(value);
      break;
    case 43:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceId(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceName(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceParentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.EvidenceWrapper.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.EvidenceWrapper.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.EvidenceWrapper} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceWrapper.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getActorEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getActorName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsAutomated();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getMime();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRelevantDate();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDiscoveryId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getBodySize();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getActorId();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getServiceModelId();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getEvidenceInstanceId();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getIsViaRequest();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getIsLinkedDocument();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getIsLinkBroken();
  if (f) {
    writer.writeBool(
      26,
      f
    );
  }
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getReceptorModelId();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getDocImportKey();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getDocImportLink();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getDocModifiedAt();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDocScannedAt();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsInstanceMissing();
  if (f) {
    writer.writeBool(
      33,
      f
    );
  }
  f = message.getLinkedControlsCount();
  if (f !== 0) {
    writer.writeInt32(
      34,
      f
    );
  }
  f = message.getStackedEvidenceCount();
  if (f !== 0) {
    writer.writeInt32(
      35,
      f
    );
  }
  f = message.getLinkedRequestsCount();
  if (f !== 0) {
    writer.writeInt32(
      36,
      f
    );
  }
  f = message.getGrcPlatform();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      common_grc_platform_pb.GrcPlatform.serializeBinaryToWriter
    );
  }
  f = message.getReadOnlyFields();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      proto.attachment.EvidenceReadOnlyFields.serializeBinaryToWriter
    );
  }
  f = message.getIndexingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      39,
      f
    );
  }
  f = message.getWindowStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      40,
      f
    );
  }
  f = message.getLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      41,
      f
    );
  }
  f = message.getSourceKind();
  if (f !== 0.0) {
    writer.writeEnum(
      42,
      f
    );
  }
  f = message.getSourceId();
  if (f.length > 0) {
    writer.writeString(
      43,
      f
    );
  }
  f = message.getSourceName();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getSourceParentId();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string caption = 2;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.EvidenceWrapper.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
*/
proto.attachment.EvidenceWrapper.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceWrapper.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string actor_email = 4;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getActorEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setActorEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string actor_name = 5;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getActorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setActorName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_automated = 6;
 * @return {boolean}
 */
proto.attachment.EvidenceWrapper.prototype.getIsAutomated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setIsAutomated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string mime = 7;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getMime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setMime = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp relevant_date = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.EvidenceWrapper.prototype.getRelevantDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
*/
proto.attachment.EvidenceWrapper.prototype.setRelevantDate = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.clearRelevantDate = function() {
  return this.setRelevantDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceWrapper.prototype.hasRelevantDate = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string content_id = 9;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string discovery_id = 10;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getDiscoveryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setDiscoveryId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string description = 12;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string account_id = 14;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional int64 body_size = 16;
 * @return {number}
 */
proto.attachment.EvidenceWrapper.prototype.getBodySize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setBodySize = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string actor_id = 17;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getActorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setActorId = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string file_name = 18;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string service_model_id = 19;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getServiceModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setServiceModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string evidence_id = 22;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string evidence_instance_id = 23;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getEvidenceInstanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setEvidenceInstanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional bool is_via_request = 24;
 * @return {boolean}
 */
proto.attachment.EvidenceWrapper.prototype.getIsViaRequest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setIsViaRequest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional bool is_linked_document = 25;
 * @return {boolean}
 */
proto.attachment.EvidenceWrapper.prototype.getIsLinkedDocument = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setIsLinkedDocument = function(value) {
  return jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional bool is_link_broken = 26;
 * @return {boolean}
 */
proto.attachment.EvidenceWrapper.prototype.getIsLinkBroken = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setIsLinkBroken = function(value) {
  return jspb.Message.setProto3BooleanField(this, 26, value);
};


/**
 * optional string receptor_id = 27;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string receptor_model_id = 28;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getReceptorModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setReceptorModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string doc_import_key = 29;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getDocImportKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setDocImportKey = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string doc_import_link = 30;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getDocImportLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setDocImportLink = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional google.protobuf.Timestamp doc_modified_at = 31;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.EvidenceWrapper.prototype.getDocModifiedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 31));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
*/
proto.attachment.EvidenceWrapper.prototype.setDocModifiedAt = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.clearDocModifiedAt = function() {
  return this.setDocModifiedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceWrapper.prototype.hasDocModifiedAt = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional google.protobuf.Timestamp doc_scanned_at = 32;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.attachment.EvidenceWrapper.prototype.getDocScannedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 32));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
*/
proto.attachment.EvidenceWrapper.prototype.setDocScannedAt = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.clearDocScannedAt = function() {
  return this.setDocScannedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceWrapper.prototype.hasDocScannedAt = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional bool is_instance_missing = 33;
 * @return {boolean}
 */
proto.attachment.EvidenceWrapper.prototype.getIsInstanceMissing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 33, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setIsInstanceMissing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 33, value);
};


/**
 * optional int32 linked_controls_count = 34;
 * @return {number}
 */
proto.attachment.EvidenceWrapper.prototype.getLinkedControlsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setLinkedControlsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 34, value);
};


/**
 * optional int32 stacked_evidence_count = 35;
 * @return {number}
 */
proto.attachment.EvidenceWrapper.prototype.getStackedEvidenceCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setStackedEvidenceCount = function(value) {
  return jspb.Message.setProto3IntField(this, 35, value);
};


/**
 * optional int32 linked_requests_count = 36;
 * @return {number}
 */
proto.attachment.EvidenceWrapper.prototype.getLinkedRequestsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/**
 * @param {number} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setLinkedRequestsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 36, value);
};


/**
 * optional common.GrcPlatform grc_platform = 37;
 * @return {?proto.common.GrcPlatform}
 */
proto.attachment.EvidenceWrapper.prototype.getGrcPlatform = function() {
  return /** @type{?proto.common.GrcPlatform} */ (
    jspb.Message.getWrapperField(this, common_grc_platform_pb.GrcPlatform, 37));
};


/**
 * @param {?proto.common.GrcPlatform|undefined} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
*/
proto.attachment.EvidenceWrapper.prototype.setGrcPlatform = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.clearGrcPlatform = function() {
  return this.setGrcPlatform(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceWrapper.prototype.hasGrcPlatform = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional EvidenceReadOnlyFields read_only_fields = 38;
 * @return {?proto.attachment.EvidenceReadOnlyFields}
 */
proto.attachment.EvidenceWrapper.prototype.getReadOnlyFields = function() {
  return /** @type{?proto.attachment.EvidenceReadOnlyFields} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceReadOnlyFields, 38));
};


/**
 * @param {?proto.attachment.EvidenceReadOnlyFields|undefined} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
*/
proto.attachment.EvidenceWrapper.prototype.setReadOnlyFields = function(value) {
  return jspb.Message.setWrapperField(this, 38, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.clearReadOnlyFields = function() {
  return this.setReadOnlyFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.EvidenceWrapper.prototype.hasReadOnlyFields = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional common.INDEXING_STATUS indexing_status = 39;
 * @return {!proto.common.INDEXING_STATUS}
 */
proto.attachment.EvidenceWrapper.prototype.getIndexingStatus = function() {
  return /** @type {!proto.common.INDEXING_STATUS} */ (jspb.Message.getFieldWithDefault(this, 39, 0));
};


/**
 * @param {!proto.common.INDEXING_STATUS} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setIndexingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 39, value);
};


/**
 * optional EVIDENCE_WINDOW_STATUS window_status = 40;
 * @return {!proto.attachment.EVIDENCE_WINDOW_STATUS}
 */
proto.attachment.EvidenceWrapper.prototype.getWindowStatus = function() {
  return /** @type {!proto.attachment.EVIDENCE_WINDOW_STATUS} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/**
 * @param {!proto.attachment.EVIDENCE_WINDOW_STATUS} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setWindowStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 40, value);
};


/**
 * repeated string label_ids = 41;
 * @return {!Array<string>}
 */
proto.attachment.EvidenceWrapper.prototype.getLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 41));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setLabelIdsList = function(value) {
  return jspb.Message.setField(this, 41, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.addLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 41, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.clearLabelIdsList = function() {
  return this.setLabelIdsList([]);
};


/**
 * optional EVIDENCE_SOURCE_KIND source_kind = 42;
 * @return {!proto.attachment.EVIDENCE_SOURCE_KIND}
 */
proto.attachment.EvidenceWrapper.prototype.getSourceKind = function() {
  return /** @type {!proto.attachment.EVIDENCE_SOURCE_KIND} */ (jspb.Message.getFieldWithDefault(this, 42, 0));
};


/**
 * @param {!proto.attachment.EVIDENCE_SOURCE_KIND} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setSourceKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 42, value);
};


/**
 * optional string source_id = 43;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getSourceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setSourceId = function(value) {
  return jspb.Message.setProto3StringField(this, 43, value);
};


/**
 * optional string source_name = 44;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getSourceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setSourceName = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional string source_parent_id = 45;
 * @return {string}
 */
proto.attachment.EvidenceWrapper.prototype.getSourceParentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceWrapper} returns this
 */
proto.attachment.EvidenceWrapper.prototype.setSourceParentId = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceControlsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceControlsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceControlsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceControlsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    auditId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceControlsRequest}
 */
proto.attachment.GetEvidenceControlsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceControlsRequest;
  return proto.attachment.GetEvidenceControlsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceControlsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceControlsRequest}
 */
proto.attachment.GetEvidenceControlsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceControlsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceControlsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceControlsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceControlsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string evidence_id = 1;
 * @return {string}
 */
proto.attachment.GetEvidenceControlsRequest.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetEvidenceControlsRequest} returns this
 */
proto.attachment.GetEvidenceControlsRequest.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string audit_id = 2;
 * @return {string}
 */
proto.attachment.GetEvidenceControlsRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.GetEvidenceControlsRequest} returns this
 */
proto.attachment.GetEvidenceControlsRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.EvidenceControl.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.EvidenceControl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.EvidenceControl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceControl.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlModelId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    isViaRequest: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.EvidenceControl}
 */
proto.attachment.EvidenceControl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.EvidenceControl;
  return proto.attachment.EvidenceControl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.EvidenceControl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.EvidenceControl}
 */
proto.attachment.EvidenceControl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlModelId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsViaRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.EvidenceControl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.EvidenceControl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.EvidenceControl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.EvidenceControl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlModelId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIsViaRequest();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string control_model_id = 1;
 * @return {string}
 */
proto.attachment.EvidenceControl.prototype.getControlModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.EvidenceControl} returns this
 */
proto.attachment.EvidenceControl.prototype.setControlModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_via_request = 2;
 * @return {boolean}
 */
proto.attachment.EvidenceControl.prototype.getIsViaRequest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.attachment.EvidenceControl} returns this
 */
proto.attachment.EvidenceControl.prototype.setIsViaRequest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.GetEvidenceControlsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.GetEvidenceControlsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.GetEvidenceControlsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.GetEvidenceControlsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceControlsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceControlsList: jspb.Message.toObjectList(msg.getEvidenceControlsList(),
    proto.attachment.EvidenceControl.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.GetEvidenceControlsResponse}
 */
proto.attachment.GetEvidenceControlsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.GetEvidenceControlsResponse;
  return proto.attachment.GetEvidenceControlsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.GetEvidenceControlsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.GetEvidenceControlsResponse}
 */
proto.attachment.GetEvidenceControlsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attachment.EvidenceControl;
      reader.readMessage(value,proto.attachment.EvidenceControl.deserializeBinaryFromReader);
      msg.addEvidenceControls(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.GetEvidenceControlsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.GetEvidenceControlsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.GetEvidenceControlsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.GetEvidenceControlsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceControlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attachment.EvidenceControl.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EvidenceControl evidence_controls = 1;
 * @return {!Array<!proto.attachment.EvidenceControl>}
 */
proto.attachment.GetEvidenceControlsResponse.prototype.getEvidenceControlsList = function() {
  return /** @type{!Array<!proto.attachment.EvidenceControl>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attachment.EvidenceControl, 1));
};


/**
 * @param {!Array<!proto.attachment.EvidenceControl>} value
 * @return {!proto.attachment.GetEvidenceControlsResponse} returns this
*/
proto.attachment.GetEvidenceControlsResponse.prototype.setEvidenceControlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attachment.EvidenceControl=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.EvidenceControl}
 */
proto.attachment.GetEvidenceControlsResponse.prototype.addEvidenceControls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attachment.EvidenceControl, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.GetEvidenceControlsResponse} returns this
 */
proto.attachment.GetEvidenceControlsResponse.prototype.clearEvidenceControlsList = function() {
  return this.setEvidenceControlsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.UpdateEvidenceReadOnlyFieldsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updates: (f = msg.getUpdates()) && proto.attachment.EvidenceReadOnlyFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.UpdateEvidenceReadOnlyFieldsRequest}
 */
proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.UpdateEvidenceReadOnlyFieldsRequest;
  return proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.UpdateEvidenceReadOnlyFieldsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.UpdateEvidenceReadOnlyFieldsRequest}
 */
proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 2:
      var value = new proto.attachment.EvidenceReadOnlyFields;
      reader.readMessage(value,proto.attachment.EvidenceReadOnlyFields.deserializeBinaryFromReader);
      msg.setUpdates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.UpdateEvidenceReadOnlyFieldsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdates();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.attachment.EvidenceReadOnlyFields.serializeBinaryToWriter
    );
  }
};


/**
 * optional string evidence_id = 1;
 * @return {string}
 */
proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.UpdateEvidenceReadOnlyFieldsRequest} returns this
 */
proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional EvidenceReadOnlyFields updates = 2;
 * @return {?proto.attachment.EvidenceReadOnlyFields}
 */
proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.prototype.getUpdates = function() {
  return /** @type{?proto.attachment.EvidenceReadOnlyFields} */ (
    jspb.Message.getWrapperField(this, proto.attachment.EvidenceReadOnlyFields, 2));
};


/**
 * @param {?proto.attachment.EvidenceReadOnlyFields|undefined} value
 * @return {!proto.attachment.UpdateEvidenceReadOnlyFieldsRequest} returns this
*/
proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.prototype.setUpdates = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attachment.UpdateEvidenceReadOnlyFieldsRequest} returns this
 */
proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.prototype.clearUpdates = function() {
  return this.setUpdates(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attachment.UpdateEvidenceReadOnlyFieldsRequest.prototype.hasUpdates = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attachment.UpdateEvidenceLabelsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.UpdateEvidenceLabelsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.UpdateEvidenceLabelsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.UpdateEvidenceLabelsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.UpdateEvidenceLabelsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    labelIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.UpdateEvidenceLabelsRequest}
 */
proto.attachment.UpdateEvidenceLabelsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.UpdateEvidenceLabelsRequest;
  return proto.attachment.UpdateEvidenceLabelsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.UpdateEvidenceLabelsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.UpdateEvidenceLabelsRequest}
 */
proto.attachment.UpdateEvidenceLabelsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addLabelIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.UpdateEvidenceLabelsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.UpdateEvidenceLabelsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.UpdateEvidenceLabelsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.UpdateEvidenceLabelsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string evidence_id = 1;
 * @return {string}
 */
proto.attachment.UpdateEvidenceLabelsRequest.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.UpdateEvidenceLabelsRequest} returns this
 */
proto.attachment.UpdateEvidenceLabelsRequest.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string label_ids = 2;
 * @return {!Array<string>}
 */
proto.attachment.UpdateEvidenceLabelsRequest.prototype.getLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.attachment.UpdateEvidenceLabelsRequest} returns this
 */
proto.attachment.UpdateEvidenceLabelsRequest.prototype.setLabelIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.attachment.UpdateEvidenceLabelsRequest} returns this
 */
proto.attachment.UpdateEvidenceLabelsRequest.prototype.addLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attachment.UpdateEvidenceLabelsRequest} returns this
 */
proto.attachment.UpdateEvidenceLabelsRequest.prototype.clearLabelIdsList = function() {
  return this.setLabelIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.AddEvidenceLabelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.AddEvidenceLabelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.AddEvidenceLabelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AddEvidenceLabelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    labelId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.AddEvidenceLabelRequest}
 */
proto.attachment.AddEvidenceLabelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.AddEvidenceLabelRequest;
  return proto.attachment.AddEvidenceLabelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.AddEvidenceLabelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.AddEvidenceLabelRequest}
 */
proto.attachment.AddEvidenceLabelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabelId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.AddEvidenceLabelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.AddEvidenceLabelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.AddEvidenceLabelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.AddEvidenceLabelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabelId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string evidence_id = 1;
 * @return {string}
 */
proto.attachment.AddEvidenceLabelRequest.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AddEvidenceLabelRequest} returns this
 */
proto.attachment.AddEvidenceLabelRequest.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label_id = 2;
 * @return {string}
 */
proto.attachment.AddEvidenceLabelRequest.prototype.getLabelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.AddEvidenceLabelRequest} returns this
 */
proto.attachment.AddEvidenceLabelRequest.prototype.setLabelId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attachment.RemoveEvidenceLabelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.attachment.RemoveEvidenceLabelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attachment.RemoveEvidenceLabelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.RemoveEvidenceLabelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    labelId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attachment.RemoveEvidenceLabelRequest}
 */
proto.attachment.RemoveEvidenceLabelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attachment.RemoveEvidenceLabelRequest;
  return proto.attachment.RemoveEvidenceLabelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attachment.RemoveEvidenceLabelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attachment.RemoveEvidenceLabelRequest}
 */
proto.attachment.RemoveEvidenceLabelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidenceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabelId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attachment.RemoveEvidenceLabelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attachment.RemoveEvidenceLabelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attachment.RemoveEvidenceLabelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attachment.RemoveEvidenceLabelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabelId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string evidence_id = 1;
 * @return {string}
 */
proto.attachment.RemoveEvidenceLabelRequest.prototype.getEvidenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.RemoveEvidenceLabelRequest} returns this
 */
proto.attachment.RemoveEvidenceLabelRequest.prototype.setEvidenceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label_id = 2;
 * @return {string}
 */
proto.attachment.RemoveEvidenceLabelRequest.prototype.getLabelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.attachment.RemoveEvidenceLabelRequest} returns this
 */
proto.attachment.RemoveEvidenceLabelRequest.prototype.setLabelId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.attachment.EVIDENCE_READ_ONLY_FIELDS = {
  EVIDENCE_CAPTION: 0,
  EVIDENCE_DESCRIPTION: 1
};

/**
 * @enum {number}
 */
proto.attachment.ACTOR_TYPE = {
  USER: 0,
  RECEPTOR: 1,
  TRUSTERO: 2,
  LINKER: 3
};

/**
 * @enum {number}
 */
proto.attachment.DOCUMENT_TYPE = {
  POLICYDOC: 0,
  TEST: 1,
  EVIDENCE: 2,
  COMMENT: 3,
  REPORT: 4,
  USER_ACTION: 5,
  COMPANY_INFO: 6,
  KNOWLEDGE_BASE: 7,
  GRC_DOCUMENT: 8,
  DOCUMENT_GROUP: 9,
  _DEPRECATED_TRUST_PORTAL_HEADER_: 10,
  _DEPRECATED_TRUST_PORTAL_LOGO_: 11,
  TRUST_PORTAL_POLICY: 12,
  TRUST_PORTAL_CONTROL: 13
};

/**
 * @enum {number}
 */
proto.attachment.ATTACHMENT_TYPE = {
  AUDITPERIOD: 0,
  DOCUMENT: 1,
  TRACER: 2,
  TESTRESULT: 3,
  CONTROL: 4,
  POLICY: 5,
  REQUEST: 6,
  RISK: 7,
  AUDIT_RUN: 8,
  QUESTIONNAIRE_ANSWER: 9,
  ATTESTATION: 10,
  VENDOR: 11
};

/**
 * @enum {number}
 */
proto.attachment.EVIDENCE_SORT_COLUMN = {
  NAME: 0,
  RELEVANT_DATE: 1,
  CREATED_AT: 2,
  LAST_SCANNED: 3
};

/**
 * @enum {number}
 */
proto.attachment.EVIDENCE_LINKAGE_TYPE = {
  CONTROL_LINK: 0,
  REQUEST_LINK: 1
};

/**
 * @enum {number}
 */
proto.attachment.EVIDENCE_WINDOW_STATUS = {
  IN_WINDOW: 0,
  BEFORE_EARLIEST_EVIDENCE_DATE: 1,
  BEFORE_AUDIT_START: 2,
  AFTER_AUDIT_END: 3,
  FUTURE_RELEVANT_DATE: 4
};

/**
 * @enum {number}
 */
proto.attachment.EVIDENCE_SOURCE_KIND = {
  EVIDENCE_SOURCE_NONE: 0,
  EVIDENCE_SOURCE_POLICY_DOCUMENT: 1,
  EVIDENCE_SOURCE_COMPANY_INFO: 2,
  EVIDENCE_SOURCE_RISK_REGISTER: 3
};

goog.object.extend(exports, proto.attachment);
